<template>
  <div class="ml-6 mr-6 mt-4"> <!--note: mt,mb,ml,mr(margin) jangan diubah-->
    <v-layout row wrap>
      <v-flex
        sm12
        xs12
        md12
        lg12
        >
        <v-card height="auto" class="mb-6 rounded-lg" flat>
          <v-card-title height="50" class="body-2 font-weight-regular blue-grey lighten-5 grey--text">
            <v-icon small class="mr-4" color="grey">mdi-laptop</v-icon> Analytical Overview > Most Talked
          </v-card-title>
          <!-- TOPIC BERITA DAN PEROIDE BERITA -->
            <v-row class="mt-4 ml-2">
              <v-col class="d-flex" cols="12" sm="2">
                <v-select class=" elevation-0 shadow-0" dense
                  :items="topicsentiment"
                  label="Topic"
                  outlined rounded
                  v-model="selectedTopic"
                  @change="loadKontenBerita"
                  >
                </v-select>
              </v-col>
              <v-col class="d-flex" cols="12" sm="2">
                <v-select dark dense class="elevation-0"  background-color="#0471A5"
                  :items="periodeberita"
                  outlined rounded
                  label="Periode Berita"
                  v-model="selectedPeriode"
                  @change="loadKontenBerita"
                  >
                  <template v-slot:append-item>
                    <v-list-item>
                      <v-list-item-title>
                        <v-menu
                          v-model="menu"
                          :close-on-content-click="false"
                          :nudge-width="200"
                          offset-x
                          >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn small width="120"
                              color="#0471A5"
                              dark
                              v-bind="attrs"
                              v-on="on"
                              >
                              Custom
                            </v-btn>
                          </template>
                          <v-card>
                            <v-row justify="space-around" class="ma-4">
                              <v-date-picker class="ml-8"
                                v-model="date2"
                                show-current="2013-07-13"
                                color="#0471A5"
                                header-color="#0471A5">
                              </v-date-picker>
                              <v-date-picker dense
                                v-model="date1"
                                :show-current="false"
                                color="#0471A5">
                              </v-date-picker>
                            </v-row>
                            <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                @click="menu = false"
                                >
                                Cancel
                              </v-btn>
                              <v-btn
                                color="primary"
                                text
                                
                                @click="loadKontenBerita"
                                >
                                Set
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-menu>
                      </v-list-item-title>
                    </v-list-item>
                  </template>
                </v-select>
              </v-col>
            </v-row>
            <!--END TOPIC DAN PEROIDE BERITA-->          
            <v-row>
            <v-flex lg8>
              <div class="example ml-4 mb-4"> 
                <v-card-text>Sentiment Analysis</v-card-text>
                  <apexcharts class="" width="100%" height="240px" type="line" :options="sentimentanalysis" :series="seriessentiment"></apexcharts>
              </div>
              <v-row class="ma-4 ml-8 mb-8">
                <v-flex
                  xs12
                  sm12
                  md12
                  lg4
                  >
                  <v-btn color="#0471A5" x-large width="200" height="80" outlined class="ml-4" @click="loadSentimentanalysisBerita">
                    <v-card-text>
                      <h2 align="center" justify="center" class="text--teal darken-2">{{valueTotalBerita}}</h2>
                      <h5 align="center" justify="center" class="text--teal darken-2">Total Berita Online</h5>
                    </v-card-text>
                  </v-btn>
                </v-flex>

                <v-flex
                  xs12
                  sm12
                  md12
                  lg4
                  >
                  <v-btn color="#0471A5" x-large outlined width="200" height="80" class="ml-4" @click="loadSentimentTweet">
                    <v-card-text>
                      <h2 align="center" justify="center"  class="text--teal darken-2">{{valueTotalTwet}}</h2>
                      <h5 align="center" justify="center"  class="text--teal darken-2">Total Tweet</h5>
                    </v-card-text>
                  </v-btn>
                </v-flex>

                <v-flex
                  xs12
                  sm12
                  md12
                  lg4
                  >
                  <v-btn color="#0471A5" x-large outlined width="200" height="80" class="ml-4" @click="loadSentimentYt">
                    <v-card-text>
                      <h2 align="center" justify="center" class="text--teal darken-2">{{valueTotalYt}}</h2>
                      <h5 align="center" justify="center" class="text--teal darken-2">Total Comment Youtube</h5>
                    </v-card-text>
                  </v-btn>
                </v-flex>
              </v-row>
            </v-flex>

            <v-flex sm12 xs12 md12 lg4>
              <v-card flat> 
                <v-card-text class="mt-4">
                  <apexchart type="donut" :options="chartOptionss" :series="seriess" @dataPointSelection="clickHandle"></apexchart>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-row>
        </v-card>
      </v-flex>

      <v-flex
        sm6
        xs12
        md6
        lg6
        >
        <v-card height="auto" class="mr-4 mb-6 mt-6 rounded-lg" flat>
          <v-flex lg12>
            <div class="example"> 
              <v-card-text>Top Person</v-card-text>
              <div>
                <svg width="500" height="500">
                  <g
                    class="chart"
                    v-for="chart in layoutData.children"
                    :key="chart.data.name"
                    :style="{ transform: `translate(${chart.x}px, ${chart.y}px)`}"
                    >
                    <circle class="chart__circle" :r="chart.r" :fill="chart.data.color" @click="clickTopPerson(chart.data.name)" :stroke="chart.data.stroke"></circle>
                    <text class="chart__label">{{ chart.data.name }}</text>
                  </g>
                </svg>
              </div>
            </div>
          </v-flex>
        </v-card>
      </v-flex>

      <v-flex
        sm6
        xs12
        md6
        lg6
        >
        <v-card height="auto" class="mr-4 mb-6 mt-6 rounded-lg" flat>
          <v-flex lg12>
            <div class="example"> 
              <v-card-text>Top Organisasi</v-card-text>
              <div>
                <svg width="500" height="500">
                  <g
                    class="chart"
                    v-for="chart in layoutDataOrgnisasi.children"
                    :key="chart.data.name"
                    :style="{ transform: `translate(${chart.x}px, ${chart.y}px)`}"
                    >
                    <circle class="chart__circle" :r="chart.r" :fill="chart.data.color"  @click="clickTopOrganisasi(chart.data.name)" :stroke="chart.data.stroke"></circle>
                    <text class="chart__label">{{ chart.data.name }}</text>
                  </g>
                </svg>
              </div>
            </div>
          </v-flex>
        </v-card>
      </v-flex>
    
      <v-flex
        sm6
        xs12
        md6
        lg8
        >
        <v-card height="780px" class="mr-4 mb-6 mt-6 rounded-lg" flat >
          <v-flex lg12>
            <v-row>
              <v-flex
                lg8
                md8
                >
                <v-card-text class="ml-4 text-md-body-1">
                  Konten Berita
                </v-card-text>
              </v-flex>

              <v-flex
                lg4
                md4
                >
                <v-card-text class="d-flex align-end flex-column">
                  <div>
                    <v-btn small class="mr-4"
                      outlined
                      color="#0471A5"
                      >
                      Capture
                    </v-btn>
                  </div>
                </v-card-text>
              </v-flex>
            </v-row>
            <v-row class="ma-4">
              <v-flex
                xs12
                sm12
                md12
                lg12
                >
                <v-tabs color="#0471A5">
                  <v-tab>Netral <v-chip small
                    class="ma-2"
                    color="#0471A5"
                    text-color="white"
                    >
                    {{beritaNetralPersen}} %
                    </v-chip>
                  </v-tab>
                    <v-tab-item>
                      <v-card width="100%" height="auto" flat>
                        <v-row class="mb-4 mt-4">
                        <v-flex
                          xs12
                          sm12
                          md12
                          lg12
                          v-for="item in kontenBeritaNetral" :key="item.id"
                          >
                          <v-list-item class="grow ml-4">
                            <v-list-item-content>
                              <v-list-item-title>{{item.title}}</v-list-item-title>
                              <v-list-item-title class="body-2 grey--text">{{item.content}}</v-list-item-title>   
                            </v-list-item-content>
                             <v-btn class="ml-8" small
                            outlined
                            rounded
                            dark
                            color="#0471A5"
                            :href="item.url"
                            >
                            open
                          </v-btn>           
                          </v-list-item>
                        </v-flex>                                                                                    
                        </v-row>
                      </v-card>
                    </v-tab-item>
                    <v-tab>Negatif <v-chip small
                    class="ma-2"
                    color="#0471A5"
                    text-color="white"
                    >
                    {{beritaNegativePersen}} %
                    </v-chip>
                  </v-tab>
                    <v-tab-item>
                      <v-card width="100%" height="auto">
                        <v-row class="mb-4 mt-4">
                        <v-flex
                          xs12
                          sm12
                          md12
                          lg12
                          v-for="item in kontenBeritaNegative" :key="item.id"
                          >
                        <v-list-item class="grow ml-4">
                            <v-list-item-content>
                              <v-list-item-title>{{item.title}}</v-list-item-title>
                              <v-list-item-title class="body-2 grey--text">{{item.content}}</v-list-item-title>                                               
                            </v-list-item-content>
                             <v-btn class="ml-8" small
                            outlined
                            rounded
                            dark
                            color="#0471A5"
                            :href="item.url"
                            >
                            open
                          </v-btn>       
                          </v-list-item>
                           </v-flex>                                                                                    
                        </v-row>
                      </v-card>
                    </v-tab-item>

                    <v-tab>Positif <v-chip small
                    class="ma-2"
                    color="#1A8EC5"
                    text-color="white"
                    >
                    {{beritaPositifPersen}} %
                    </v-chip>
                  </v-tab>
                    <v-tab-item>
                    <v-card width="100%" height="auto">
                        <v-row class="mb-4 mt-4">
                        <v-flex
                          xs12
                          sm12
                          md12
                          lg12
                          v-for="item in kontenBeritaPositive" :key="item.id"
                          >
                        <v-list-item class="grow ml-4">
                            <v-list-item-content>
                              <v-list-item-title>{{item.title}}</v-list-item-title>
                              <v-list-item-title class="body-2 grey--text">{{item.content}}</v-list-item-title>                                  
                            </v-list-item-content>
                             <v-btn class="ml-8" small
                            outlined
                            rounded
                            dark
                            color="#0471A5"
                            :href="item.url"
                            >
                            open
                          </v-btn>       
                          </v-list-item>                          
                           </v-flex>                                                                                    
                        </v-row>
                      </v-card>
                    </v-tab-item>
                </v-tabs>
              </v-flex>   
              </v-row>
            </v-flex>
        </v-card>
      </v-flex>

      <v-flex
        sm6
        xs12
        md6
        lg4
        >
        <v-card height="780px" class="mr-4 mb-6 mt-6 rounded-lg" flat>
          <v-flex lg12>
              <div class="example"> 
                <v-row><v-flex>
                <v-card-text class="ml-4">Online News Share</v-card-text></v-flex></v-row>
                <div align="center" justify="center">
                  <apexchart type="radialBar" :options="onlinenew" :series="seriesonline"></apexchart>
                </div>
              </div>
            </v-flex>
            <v-flex lg12>
              <div class="example"> 
                <v-card-text>Online Media Share</v-card-text>
                <div align="center" justify="center">
                <apexchart type="radialBar" :options="onlinemedia" :series="seriesmedia"></apexchart>
                </div>
              </div>
            </v-flex>

        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialog" persistent max-width="290">                 
      <v-card>
        <v-card-title class="text-h6 font-weight-medium align-center justify-center">
          Page loading
        </v-card-title>
        <v-card-text class="body-1 align-center justify-center"> Loading content, please wait</v-card-text>
        <v-card-title class="align-center justify-center">
            <v-progress-circular :size="70" :width="7" color="#0471A5" indeterminate></v-progress-circular>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#0471A5" text @click="dialog = false">
            cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
import { hierarchy, pack } from 'd3-hierarchy';
import VueApexCharts from 'vue-apexcharts'
import axios from "axios"

export default {
  components: {
    apexcharts: VueApexCharts,
  },
  
  //inside of the component:
 
  // data: function() {
    data() {
    return {
      Settanggal : [],
      SettanggalLast30 : [],
      StartDateLast30: "",
      EndDate: "",
      SetPerson: [],
      SetOrganisasi: [],
      beritaNetralPersen : "",
      beritaNegativePersen: "",
      beritaPositifPersen : "", 
      click : "",    
      selectedTopic: "",
      selectedPeriode: "",
      topicsentiment: [],
      periodeberita: ['Today', 'Yesterday', 'Last 7 Days', 'Previous Week', 'Last 30 Days', 'Previous Month'],
      chartBubleIndx0:[],
      chartBubleIndx1: [],
      chartBubleIndx2: [],
      chartBubleIndx3: [],
      chartBubleIndx4: [],
      chartBubleIndx5: [],
      chartBubleIndxOrg0: [],
      chartBubleIndxOrg1: [],
      chartBubleIndxOrg2: [],
      chartBubleIndxOrg3: [],
      chartBubleIndxOrg4: [],
      chartBubleIndxOrg5: [],
      dialog: false,

// simple search 
      topik_search: [],

      topik0: [],
      topik1: [],
      topik2: [],
      topik3: [],
      tnglIndex0:[],
      tnglIndex1: [],
      tnglIndex2: [],
      tnglIndex3: [],
      tnglIndex4: [],
      tnglIndex5: [],
      tnglIndex6: [],
      tnglIndex7: [],
      tnglIndex0Twet:[],
      tnglIndex1Twet: [],
      tnglIndex2Twet: [],
      tnglIndex3Twet: [],
      tnglIndex4Twet: [],
      tnglIndex5Twet: [],
      tnglIndex6Twet: [],
      tnglIndex7Twet: [],
      tnglIndex0Yt:[],
      tnglIndex1Yt: [],
      tnglIndex2Yt: [],
      tnglIndex3Yt: [],
      tnglIndex4Yt: [],
      tnglIndex5Yt: [],
      tnglIndex6Yt: [],
      tnglIndex7Yt: [],
      // last 30 day      
      tnglIndex0Last30Day: [],
      tnglIndex1Last30Day: [],
      tnglIndex2Last30Day: [],
      tnglIndex3Last30Day: [],
      tnglIndex4Last30Day: [],
      tnglIndex5Last30Day: [],
      tnglIndex6Last30Day: [], 
      tnglIndex7Last30Day:[],
      tnglIndex8Last30Day: [],
      tnglIndex9Last30Day: [],
      tnglIndex10Last30Day: [],
      tnglIndex11Last30Day: [],
      tnglIndex12Last30Day: [],
      tnglIndex13Last30Day: [], 
      tnglIndex14Last30Day:[],
      tnglIndex15Last30Day: [],
      tnglIndex16Last30Day: [],
      tnglIndex17Last30Day: [],
      tnglIndex18Last30Day: [],
      tnglIndex19Last30Day: [],
      tnglIndex20Last30Day: [], 
      tnglIndex21Last30Day: [], 
      tnglIndex22Last30Day: [],       
      tnglIndex23Last30Day: [], 
      tnglIndex24Last30Day: [], 
      tnglIndex25Last30Day: [], 
      tnglIndex26Last30Day: [], 
      tnglIndex27Last30Day: [], 
      tnglIndex28Last30Day: [], 
      tnglIndex29Last30Day: [], 
      tnglIndex30Last30Day: [],               
      tnglIndex0Last30DayTwitter: [],
      tnglIndex1Last30DayTwitter: [],
      tnglIndex2Last30DayTwitter: [],
      tnglIndex3Last30DayTwitter: [],
      tnglIndex4Last30DayTwitter: [],
      tnglIndex5Last30DayTwitter: [],
      tnglIndex6Last30DayTwitter: [],
      tnglIndex7Last30DayTwitter: [], 
      tnglIndex8Last30DayTwitter:[],
      tnglIndex9Last30DayTwitter: [],
      tnglIndex10Last30DayTwitter: [],
      tnglIndex11Last30DayTwitter: [],
      tnglIndex12Last30DayTwitter: [],
      tnglIndex13Last30DayTwitter: [],
      tnglIndex14Last30DayTwitter: [], 
      tnglIndex15Last30DayTwitter:[],
      tnglIndex16Last30DayTwitter: [],
      tnglIndex17Last30DayTwitter: [],
      tnglIndex18Last30DayTwitter: [],
      tnglIndex19Last30DayTwitter: [],
      tnglIndex20Last30DayTwitter: [],
      tnglIndex21Last30DayTwitter: [], 
      tnglIndex22Last30DayTwitter: [], 
      tnglIndex23Last30DayTwitter: [],
      tnglIndex24Last30DayTwitter: [],
      tnglIndex25Last30DayTwitter: [], 
      tnglIndex26Last30DayTwitter: [], 
      tnglIndex27Last30DayTwitter: [], 
      tnglIndex28Last30DayTwitter: [], 
      tnglIndex29Last30DayTwitter: [], 
      tnglIndex30Last30DayTwitter: [],                  
      tnglIndex0Last30DayYoutube: [],
      tnglIndex1Last30DayYoutube: [],
      tnglIndex2Last30DayYoutube: [],
      tnglIndex3Last30DayYoutube: [],
      tnglIndex4Last30DayYoutube: [],
      tnglIndex5Last30DayYoutube: [],
      tnglIndex6Last30DayYoutube: [],
      tnglIndex7Last30DayYoutube: [], 
      tnglIndex8Last30DayYoutube:[],
      tnglIndex9Last30DayYoutube: [],
      tnglIndex10Last30DayYoutube: [],
      tnglIndex11Last30DayYoutube: [],
      tnglIndex12Last30DayYoutube: [],
      tnglIndex13Last30DayYoutube: [],
      tnglIndex14Last30DayYoutube: [], 
      tnglIndex15Last30DayYoutube:[],
      tnglIndex16Last30DayYoutube: [],
      tnglIndex17Last30DayYoutube: [],
      tnglIndex18Last30DayYoutube: [],
      tnglIndex19Last30DayYoutube: [],
      tnglIndex20Last30DayYoutube: [],
      tnglIndex21Last30DayYoutube: [], 
      tnglIndex22Last30DayYoutube: [],
      tnglIndex23Last30DayYoutube: [],  
      tnglIndex24Last30DayYoutube: [], 
      tnglIndex25Last30DayYoutube: [], 
      tnglIndex26Last30DayYoutube: [], 
      tnglIndex27Last30DayYoutube: [], 
      tnglIndex28Last30DayYoutube: [], 
      tnglIndex29Last30DayYoutube: [], 
      tnglIndex30Last30DayYoutube: [],       
      valueBubleIndx0Topik0: [],
      valueBubleIndx1Topik0: [],
      valueBubleIndx2Topik0: [],
      valueBubleIndx3Topik0: [],
      valueBubleIndx4Topik0: [],
      valueBubleIndx5Topik0: [],
      valueBubleIndx0Topik1: [],
      valueBubleIndx1Topik1: [],
      valueBubleIndx2Topik1: [],
      valueBubleIndx3Topik1: [],
      valueBubleIndx4Topik1: [],
      valueBubleIndx5Topik1: [],
      valueBubleIndx0Topik2: [],
      valueBubleIndx1Topik2: [],
      valueBubleIndx2Topik2: [],
      valueBubleIndx3Topik2: [],
      valueBubleIndx4Topik2: [],
      valueBubleIndx5Topik2: [], 
      valueBubleIndx0Topik3: [],
      valueBubleIndx1Topik3: [],
      valueBubleIndx2Topik3: [],
      valueBubleIndx3Topik3: [],     
      valueBubleIndx4Topik3: [],     
      valueBubleIndx5Topik3: [],                
      chartBubleIndx0Today: [],
      chartBubleIndx1Today: [],
      chartBubleIndx2Today: [],
      chartBubleIndx3Today: [],
      chartBubleIndx4Today: [],
      chartBubleIndx5Today: [],
      chartBubleIndx0Yesterday: [],
      chartBubleIndx1Yesterday: [],
      chartBubleIndx2Yesterday: [],
      chartBubleIndx3Yesterday: [],
      chartBubleIndx4Yesterday: [],
      chartBubleIndx5Yesterday: [],
      chartBubleIndx0Last7Day: [],
      chartBubleIndx1Last7Day: [],
      chartBubleIndx2Last7Day: [],
      chartBubleIndx3Last7Day: [],
      chartBubleIndx4Last7Day: [],
      chartBubleIndx5Last7Day: [],
      chartBubleIndx0Last30Day: [],
      chartBubleIndx1Last30Day: [],
      chartBubleIndx2Last30Day: [],
      chartBubleIndx3Last30Day: [],
      chartBubleIndx4Last30Day: [],
      chartBubleIndx5Last30Day: [],
      // chart buble organisasi
      valueBubleIndx0OrgTopik0:[],
      valueBubleIndx1OrgTopik0:[],
      valueBubleIndx2OrgTopik0: [],
      valueBubleIndx3OrgTopik0: [],
      valueBubleIndx4OrgTopik0: [],
      valueBubleIndx5OrgTopik0: [],
      valueBubleIndx0OrgTopik1:[],
      valueBubleIndx1OrgTopik1:[],
      valueBubleIndx2OrgTopik1: [],
      valueBubleIndx3OrgTopik1: [],
      valueBubleIndx4OrgTopik1: [],
      valueBubleIndx5OrgTopik1: [],
      valueBubleIndx0OrgTopik2:[],
      valueBubleIndx1OrgTopik2:[],
      valueBubleIndx2OrgTopik2: [],
      valueBubleIndx3OrgTopik2: [],
      valueBubleIndx4OrgTopik2: [],
      valueBubleIndx5OrgTopik2: [],            
      valueBubleIndx0OrgTopik3:[],
      valueBubleIndx1OrgTopik3:[],
      valueBubleIndx2OrgTopik3: [],
      valueBubleIndx3OrgTopik3: [],
      valueBubleIndx4OrgTopik3: [],
      valueBubleIndx5OrgTopik3: [], 
      chartBubleIndx0OrgToday: [],
      chartBubleIndx1OrgToday: [],
      chartBubleIndx2OrgToday: [],
      chartBubleIndx3OrgToday: [],
      chartBubleIndx4OrgToday: [],
      chartBubleIndx5OrgToday: [],
      chartBubleIndx0OrgYesterday: [],
      chartBubleIndx1OrgYesterday: [],
      chartBubleIndx2OrgYesterday: [],
      chartBubleIndx3OrgYesterday: [],
      chartBubleIndx4OrgYesterday: [],
      chartBubleIndx5OrgYesterday: [],
      chartBubleIndx0OrgLast7Day: [],
      chartBubleIndx1OrgLast7Day: [],
      chartBubleIndx2OrgLast7Day: [],
      chartBubleIndx3OrgLast7Day: [],
      chartBubleIndx4OrgLast7Day: [],
      chartBubleIndx5OrgLast7Day: [],
      chartBubleIndx0OrgLast30Day: [],
      chartBubleIndx1OrgLast30Day: [],
      chartBubleIndx2OrgLast30Day: [],
      chartBubleIndx3OrgLast30Day: [],
      chartBubleIndx4OrgLast30Day: [],
      chartBubleIndx5OrgLast30Day: [],
      valueBubleIndx0Berita: [],
      valueBubleIndx1Berita: [],
      valueBubleIndx2Berita: [],
      valueBubleIndx3Berita: [],
      valueBubleIndx4Berita: [],
      valueBubleIndx5Berita: [],
      valueBubleIndx0Twitter: [],
      valueBubleIndx1Twitter: [],
      valueBubleIndx2Twitter: [],
      valueBubleIndx3Twitter: [],
      valueBubleIndx4Twitter: [],
      valueBubleIndx5Twitter: [],
      valueBubleIndx0Youtube: [],
      valueBubleIndx1Youtube: [],
      valueBubleIndx2Youtube: [],
      valueBubleIndx3Youtube: [],
      valueBubleIndx4Youtube: [],
      valueBubleIndx5Youtube: [],
      valueBubleIndx0OrgBerita: [],
      valueBubleIndx1OrgBerita: [],
      valueBubleIndx2OrgBerita: [],
      valueBubleIndx3OrgBerita: [],
      valueBubleIndx4OrgBerita: [],
      valueBubleIndx5OrgBerita: [],
      valueBubleIndx0OrgTwitter: [],
      valueBubleIndx1OrgTwitter: [],
      valueBubleIndx2OrgTwitter: [],
      valueBubleIndx3OrgTwitter: [],     
      valueBubleIndx4OrgTwitter: [],     
      valueBubleIndx5OrgTwitter: [],     
      valueBubleIndx0OrgYoutube: [],
      valueBubleIndx1OrgYoutube: [],
      valueBubleIndx2OrgYoutube: [],
      valueBubleIndx3OrgYoutube: [],       
      valueBubleIndx4OrgYoutube: [],    
      valueBubleIndx5OrgYoutube: [],                
      // click buble organisasi
      valueBubleIndx0Positive: [],
      valueBubleIndx0Negative: [],
      valueBubleIndx0Netral: [],
      valueBubleIndx1Positive: [],
      valueBubleIndx1Negative: [],
      valueBubleIndx1Netral: [],
      valueBubleIndx2Positive: [],
      valueBubleIndx2Negative: [],
      valueBubleIndx2Netral: [],
      valueBubleIndx3Positive: [],
      valueBubleIndx3Negative: [],
      valueBubleIndx3Netral: [],
      valueBubleIndx4Positive: [],
      valueBubleIndx4Negative: [],
      valueBubleIndx4Netral: [],
      valueBubleIndx5Positive: [],
      valueBubleIndx5Negative: [],
      valueBubleIndx5Netral: [],
      valueBubleIndx0OrgPositive: [],
      valueBubleIndx0OrgNegative: [],
      valueBubleIndx0OrgNetral: [],
      valueBubleIndx1OrgPositive: [],
      valueBubleIndx1OrgNegative: [],
      valueBubleIndx1OrgNetral: [],
      valueBubleIndx2OrgPositive: [],
      valueBubleIndx2OrgNegative: [],
      valueBubleIndx2OrgNetral: [],
      valueBubleIndx3OrgPositive: [],
      valueBubleIndx3OrgNegative: [],
      valueBubleIndx3OrgNetral: [],
      valueBubleIndx4OrgPositive: [],
      valueBubleIndx4OrgNegative: [],
      valueBubleIndx4OrgNetral: [],
      valueBubleIndx5OrgPositive: [],
      valueBubleIndx5OrgNegative: [],
      valueBubleIndx5OrgNetral: [],
      mediaTopik0OnlineNewsShare: [],
      mediaTopik1OnlineNewsShare: [],
      mediaTopik2OnlineNewsShare: [],
      mediaTopik3nlineNewsShare: [],
      mediaTodayOnlineNewsShare: [],
      mediaYesterdayOnlineNewsShare: [],
      mediaLast7DayOnlineNewsShare: [],
      mediaLast30DayOnlineNewsShare: [],
      valueBubleIndx0NewsShare: [],
      valueBubleIndx1NewsShare: [],
      valueBubleIndx2NewsShare: [],
      valueBubleIndx3NewsShare: [],
      valueBubleIndx4NewsShare: [],
      valueBubleIndx5NewsShare: [],
      valueBubleIndx0OrgNewsShare: [],
      valueBubleIndx1OrgNewsShare: [],
      valueBubleIndx2OrgNewsShare: [],
      valueBubleIndx3OrgNewsShare: [],
      valueBubleIndx4OrgNewsShare: [],
      valueBubleIndx5OrgNewsShare: [],
      valueBubleIndx0ShareYoutube: [],
      valueBubleIndx1ShareYoutube: [],
      valueBubleIndx2ShareYoutube: [],
      valueBubleIndx3ShareYoutube: [],
      valueBubleIndx4ShareYoutube: [],
      valueBubleIndx5ShareYoutube: [],
      valueBubleIndx0OrgShareYoutube: [],
      valueBubleIndx1OrgShareYoutube: [],
      valueBubleIndx2OrgShareYoutube: [],
      valueBubleIndx3OrgShareYoutube: [],
      valueBubleIndx4OrgShareYoutube: [],
      valueBubleIndx5OrgShareYoutube: [],
      valueBubleIndx0ShareTwitter: [],
      valueBubleIndx1ShareTwitter: [],
      valueBubleIndx2ShareTwitter: [],
      valueBubleIndx3ShareTwitter: [],
      valueBubleIndx4ShareTwitter: [],
      valueBubleIndx5ShareTwitter: [],
      valueBubleIndx0OrgShareTwitter: [],
      valueBubleIndx1OrgShareTwitter: [],
      valueBubleIndx2OrgShareTwitter: [],
      valueBubleIndx3OrgShareTwitter: [],
      valueBubleIndx4OrgShareTwitter: [],
      valueBubleIndx5OrgShareTwitter: [],
      valueIndx0Org0: [],
      valueIndx0Org1: [],
      valueIndx0Org2: [],    
      valueIndx0Org3: [],
      valueIndx0Org4: [],    
      valueIndx0Org5: [],    
      valueIndx1Org0: [],
      valueIndx1Org1: [],
      valueIndx1Org2: [],    
      valueIndx1Org3: [],
      valueIndx1Org4: [],    
      valueIndx1Org5: [],    
      valueIndx2Org0: [],
      valueIndx2Org1: [],
      valueIndx2Org2: [],    
      valueIndx2Org3: [],
      valueIndx2Org4: [],    
      valueIndx2Org5: [],    
      valueIndx3Org0: [],
      valueIndx3Org1: [],
      valueIndx3Org2: [],    
      valueIndx3Org3: [],
      valueIndx3Org4: [],    
      valueIndx3Org5: [],        
      valueIndx4Org0: [],
      valueIndx4Org1: [],
      valueIndx4Org2: [],    
      valueIndx4Org3: [],
      valueIndx4Org4: [],    
      valueIndx4Org5: [],    
      valueIndx5Org0: [],
      valueIndx5Org1: [],
      valueIndx5Org2: [],    
      valueIndx5Org3: [],
      valueIndx5Org4: [],    
      valueIndx5Org5: [],        
      valueOrg0Indx0: [],
      valueOrg0Indx1: [],
      valueOrg0Indx2: [],    
      valueOrg0Indx3: [],
      valueOrg0Indx4: [],    
      valueOrg0Indx5: [],    
      valueOrg1Indx0: [],
      valueOrg1Indx1: [],
      valueOrg1Indx2: [],    
      valueOrg1Indx3: [],
      valueOrg1Indx4: [],    
      valueOrg1Indx5: [],    
      valueOrg2Indx0: [],
      valueOrg2Indx1: [],
      valueOrg2Indx2: [],    
      valueOrg2Indx3: [],
      valueOrg2Indx4: [],    
      valueOrg2Indx5: [],    
      valueOrg3Indx0: [],
      valueOrg3Indx1: [],
      valueOrg3Indx2: [],    
      valueOrg3Indx3: [],
      valueOrg3Indx4: [],    
      valueOrg3Indx5: [],        
      valueOrg4Indx0: [],
      valueOrg4Indx1: [],
      valueOrg4Indx2: [],    
      valueOrg4Indx3: [],
      valueOrg4Indx4: [],    
      valueOrg4Indx5: [],    
      valueOrg5Indx0: [],
      valueOrg5Indx1: [],
      valueOrg5Indx2: [],    
      valueOrg5Indx3: [],
      valueOrg5Indx4: [],    
      valueOrg5Indx5: [],                 
      kontenBerita: [],
      mediaBeritaPositive: [],       
      mediaBeritaNegative: [],       
      mediaBeritaNetral: [],       
      mediaTweetPositive: [],       
      mediaTweetNegative: [],       
      mediaTweetNetral: [],       
      mediaYtPositive: [],       
      mediaYtNegative: [],       
      mediaYtNetral: [],       
      kontenBeritaPositive: [],       
      kontenBeritaNegative: [],       
      kontenBeritaNetral: [],       
      kontenBeritaPositiveTopik0: [],       
      kontenBeritaNegativeTopik0: [],       
      kontenBeritaNetralTopik0: [],       
      kontenBeritaPositiveTopik1: [],       
      kontenBeritaNegativeTopik1: [],       
      kontenBeritaNetralTopik1: [],       
      kontenBeritaPositiveTopik2: [],       
      kontenBeritaNegativeTopik2: [],       
      kontenBeritaNetralTopik2: [],       
      kontenBeritaPositiveTopik3: [],       
      kontenBeritaNegativeTopik3: [],       
      kontenBeritaNetralTopik3: [],       
      kontenBeritaPositiveToday: [],       
      kontenBeritaNegativeToday: [],       
      kontenBeritaNetralToday: [],       
      kontenBeritaPositiveYesterday: [],       
      kontenBeritaNegativeYesterday: [],       
      kontenBeritaNetralYesterday: [],       
      kontenBeritaPositiveLast7Day: [],       
      kontenBeritaNegativeLast7Day: [],       
      kontenBeritaNetralLast7Day: [],       
      kontenBeritaPositiveLast30Day: [],       
      kontenBeritaNegativeLast30Day: [],       
      kontenBeritaNetralLast30Day: [],           
      dateid: [],             
      // end last 30 day



      tanggalIndx0Topik0:[],
      tanggalIndx1Topik0: [],
      tanggalIndx2Topik0: [],
      tanggalIndx3Topik0: [],
      tanggalIndx4Topik0: [],
      tanggalIndx5Topik0: [],
      tanggalIndx6Topik0: [],
      tanggalIndx7Topik0: [],
      tanggalIndx0Topik1:[],
      tanggalIndx1Topik1: [],
      tanggalIndx2Topik1: [],
      tanggalIndx3Topik1: [],
      tanggalIndx4Topik1: [],
      tanggalIndx5Topik1: [],
      tanggalIndx6Topik1: [],
      tanggalIndx7Topik1: [],
      tanggalIndx0Topik2:[],
      tanggalIndx1Topik2: [],
      tanggalIndx2Topik2: [],
      tanggalIndx3Topik2: [],
      tanggalIndx4Topik2: [],
      tanggalIndx5Topik2: [],
      tanggalIndx6Topik2: [],
      tanggalIndx7Topik2: [],
      tanggalIndx0Topik3:[],
      tanggalIndx1Topik3: [],
      tanggalIndx2Topik3: [],
      tanggalIndx3Topik3: [],
      tanggalIndx4Topik3: [],
      tanggalIndx5Topik3: [],
      tanggalIndx6Topik3: [],
      tanggalIndx7Topik3: [],               
      today : [],
      yesterday : [],
      Last7Day: [],
      Last30Day: [],   
      
      
      jumlahSentimenNetral: "",
      jumlahSentimenNegatif: "",
      jumlahSentimenPostif: "",
      mediaBerita: [],
      DomainOnlineNews: [],
      MediaOnlineShare: [],
      MediatwitterShare: [],
      MediaYtShare: [],



      MediaTopik0OnlineShare: [],
      MediaTopik0twitterShare: [],
      MediaTopik0YtShare: [],
      MediaTopik1OnlineShare: [],
      MediaTopik1twitterShare: [],
      MediaTopik1YtShare: [],
      MediaTopik2OnlineShare: [],
      MediaTopik2twitterShare: [],
      MediaTopik2YtShare: [],
      mediaTopik3OnlineNewsShare: [],
      MediaTopik3twitterShare: [],
      MediaTopik3YtShare: [],
      mediaBeritaTopik0: [],
      mediaTwetTopik0: [],
      mediaYtTopik0: [],
      mediaBeritaTopik1: [],
      mediaTwetTopik1: [],
      mediaYtTopik1: [],
      mediaBeritaTopik2: [],
      mediaTwetTopik2: [],
      mediaYtTopik2: [],
      mediaBeritaTopik3: [],
      mediaTwetTopik3: [],
      mediaYtTopik3: [],
      mediaBeritaToday: [],
      mediaTwetToday: [],
      mediaYtToday: [],
      mediaBeritaYesterday: [],
      mediaTwetYesterday: [],
      mediaYtYesterday: [],
      mediaBeritaLast7Day: [],
      mediaTwetLast7Day: [],
      mediaYtLast7Day: [],
      mediaBeritaLast30Day: [],
      mediaTwetLast30Day: [],
      mediaYtLast30Day: [],
      valueTotalBerita : "",
      valueTotalTwet: "",
      valueTotalYt: "",
      beritaNetral : [],
      beritaNegative: [],
      beritaPositif : [],     
      menu:false, 
      date1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      date2: '2013-07-29',     

      /*Chart sentiment analysis*/
      sentimentanalysis: {
        chart: {
          id: 'Chart1'
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth',
          width: 2,
        },
        colors: ['#6F6F6F', '#FFB000', '#814AD6'], /*color line*/
        xaxis: {
          categories: [],         
        }
      },
      seriessentiment: [{
        name: 'Berita Online',
        data: []
      },
      {
        name: 'Twitter',
        data: []
      },
      {
        name: 'Youtube',
        data: []
      },     
      ],
      
      /*Bubblechart*/
       chart: [
        {
          name: '',
          amount: 0,
          color: '#F88FB3'
        },
        {
          name: '',
          amount: 0,
          color: '#F1E987'
        },
        {
          name: '',
          amount: 0,
          color: '#B3B8F4'
        },
        {
          name: '',
          amount: 0,
          color: '#5EC3C2',
        },
        {
          name: '',
          amount: 0,
          color: '#AFDAF5'
        },
        {
          name: '',
          amount: 0,
          color: '#C4C4C4'
        },
      ],
      /*end Bubblechart*/
      /*Bubblechart*/
       chartOrganisasi: [
        {
          name: '',
          amount: 0,
          color: '#F88FB3'
        },
        {
          name: '',
          amount: 0,
          color: '#F1E987'
        },
        {
          name: '',
          amount: 0,
          color: '#B3B8F4'
        },
        {
          name: '',
          amount: 0,
          color: '#5EC3C2',
        },
        {
          name: '',
          amount: 0,
          color: '#AFDAF5'
        },
        {
          name: '',
          amount: 0,
          color: '#C4C4C4'
        },
      ],
      /*end Bubblechart*/

      /*pie*/
      seriess: [],
        chartOptionss: {
          colors:['#008FFB', '#FF4560', '#00E396'],
          chart: {
            width: 380,
            type: 'pie',
          },
          dataLabels: {
            enabled: false
          },         
          plotOptions: {
          pie: {
            donut: {
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: '22px',
                  color: '#226077',
                  offsetY: -10,
                },
                total: {
                  show: true,
                },
              }
            }
          }
        },
      labels: ['Netral', 'negative', 'positive'],
      },

      /*radial*/
      seriesonline: [],
      onlinenew: {
        colors:['#38BABC', '#16A5A7', '#079092', '#057577', '#025354'],
        chart: {
          height: '50px',
          type: 'radialBar',
        },
        plotOptions: {
          radialBar: {
            dataLabels: {
              name: {
                fontSize: '22px',
              },
              value: {
                fontSize: '16px',
              },
              total: {
                show: true,
                label: 'Total',
              }
            }
          }
        },
        labels: ['News',],
      },

      /*radial*/
      seriesmedia: [],
      onlinemedia: {
        colors:['#38BABC', '#16A5A7', '#079092', '#057577', '#025354'],
        chart: {
          height: '50px',
          type: 'radialBar',
        },
        plotOptions: {
          radialBar: {
            dataLabels: {
              name: {
                fontSize: '22px',
              },
              value: {
                fontSize: '16px',
              },
              total: {
                show: true,
                label: 'Total',
              }
            }
          }
        },
        labels: [],
      },
    }
  },
  mounted(){
    this.loadTopic();
    this.loadKontenBerita();
    // this.loadSentimentanalysis();

    // this.loadKontenOnlineNews();

    // this.loadKontenOnlineMedia();     
  },
   /*Bubblechart*/
  computed: {
    transformedChartData() {
      return {
        name: 'Top Level',
        children: this.chart.map(chart => ({
          ...chart,
          size: chart.amount,
          parent: 'Top Level'
        }))
      }
    },
    layoutData() {
      // Generate a D3 hierarchy
      const rootHierarchy = hierarchy(this.transformedChartData)
        .sum(d => d.size)
        .sort((a, b) => {
          return b.value - a.value
        })
      // Pack the circles inside the viewbox
      return pack()
        .size([500, 500])
        .padding(10)(rootHierarchy)
    },
    transformedChartDataOrgnisasi() {
      return {
        name: 'Top Level',
        children: this.chartOrganisasi.map(chart => ({
          ...chart,
          size: chart.amount,
          parent: 'Top Level'
        }))
      }
    },
    layoutDataOrgnisasi() {
      // Generate a D3 hierarchy
      const rootHierarchy = hierarchy(this.transformedChartDataOrgnisasi)
        .sum(d => d.size)
        .sort((a, b) => {
          return b.value - a.value
        })
      // Pack the circles inside the viewbox
      return pack()
        .size([500, 500])
        .padding(10)(rootHierarchy)
    },
  /*methods chartbubble*/
 
  },
   methods: {
    async loadTopic(){
       // start loading 
        this.loading = true
         axios.get("keyword",
          { headers:{'auth-token':localStorage.getItem('token_app')}},
          {dataType: 'json'}
          ).then((response) => {
            this.posts = response.data
          const data =response.data;
          const topik = []   
          this.kontenBerita = data ; 
            this.kontenBerita.forEach((element) => {
              topik.push(element["KEYWORD"]);
            });
            this.topicsentiment = [...new Set(topik)] 

            for (let i = 0; i < data.length; i++) {  
              // selectedTopic topik_search
              if (data[i].KEYWORD == this.topicsentiment[i]) {
                this.topik_search.push(data[i]);
              }   
              if (data[i].KEYWORD == this.topicsentiment[i]) {
                this.topik0.push(data[i]);
              }         
            }
            for (let i = 0; i < data.length; i++) {       
                if (data[i].KEYWORD == this.topicsentiment[1]) {
                  this.topik1.push(data[i]);
                }         
            }    
              for (let i = 0; i < data.length; i++) {       
                if (data[i].KEYWORD == this.topicsentiment[2]) {
                  this.topik2.push(data[i]);
                }         
            }    
              for (let i = 0; i < data.length; i++) {       
                if (data[i].KEYWORD == this.topicsentiment[3]) {
                  this.topik3.push(data[i]);
                }         
            }   
          })
          .catch((e) => {
          this.errors=e.response.data.msg;
        });  
    },







    async loadKontenBerita(){



      
        var date_start = this.date2 ;
        var date_end = this.date1;
         const date_awal = new Date();
         const date = new Date();
          date.setDate(date.getDate()+0);
        const datenow = date.toISOString().substr(0, 10);
        if(this.selectedPeriode == "Today"){ 
        this.click = 'Today'
           date_start = datenow;
           date_end = datenow;
        }
        if(this.selectedPeriode == "Yesterday"){ 
        this.click = 'Yesterday'
            date_awal.setDate(date_awal.getDate()-1);
            const date_c = date_awal.toISOString().substr(0, 10);
           date_start = date_c;
           date_end = date_c; 
        }
        if(this.selectedPeriode == "Last 7 Days" ||  this.selectedPeriode == "Previous Week"){ 
        this.click = 'Last 7 Days'
            date_awal.setDate(date_awal.getDate()-7);
            const date_c = date_awal.toISOString().substr(0, 10);

           date_start = date_c;
           date_end = datenow; 
        }
        if(this.selectedPeriode == "Last 30 Days" || this.selectedPeriode == "Previous Month"){ 
        this.click = 'Last 30 Days' 
            date_awal.setDate(date_awal.getDate()-30);
            const date_c = date_awal.toISOString().substr(0, 10);
           date_start = date_c;
           date_end = datenow; 
        }
     
        this.dialog = true;
      try{        
        // const data1 = await axios.get("news")
        const data1 = await axios.get("solr-dashboard?start_date="+date_start+"&end_date="+date_end+"&topic="+this.selectedTopic,
          {headers:{'auth-token':localStorage.getItem('token_app')}}
          )
          // variab series chart 
          
              this.mediaBeritaNetral = []
              this.mediaBeritaNegative = []
              this.mediaBeritaPositive = []
              this.mediaTweetNetral  = []
              this.mediaTweetNegative = []
              this.mediaTweetPositive = []
              this.mediaYtNetral = []
              this.mediaYtNegative = []
              this.mediaYtPositive = []

              // this.kontenBeritaNetralTopik0 = []
              // this.kontenBeritaNegativeTopik0 = []
              // this.kontenBeritaPositiveTopik0 = []
              // this.kontenBeritaNetralTopik1 = []
              // this.kontenBeritaNegativeTopik1 = []
              // this.kontenBeritaPositiveTopik1 = []
              // this.kontenBeritaNetralTopik2 = []
              // this.kontenBeritaNegativeTopik2 = []
              // this.kontenBeritaPositiveTopik2 = []
              // this.kontenBeritaNetralTopik3 = []
              // this.kontenBeritaNegativeTopik3 = []
              // this.kontenBeritaPositiveTopik3 = []
          // end 
        // this.seriessentiment[0].data = []
        // this.seriessentiment[1].name = ''
        // this.seriessentiment[1].data = []
        // this.seriessentiment[2].name = ''
        // this.seriessentiment[2].data = [] 

        
          this.mediaBerita = []
          this.MediatwitterShare = []
          this.MediaYtShare = []
          this.kontenBeritaPositive = []
          this.kontenBeritaNegative = []
          this.kontenBeritaNetral = []
          this.DomainOnlineNews = []
          this.SettanggalLast30 = []
          this.seriesonline = []
          this.seriesmedia = []
          this.mediaBeritaTopik0 = []
          this.mediaBeritaTopik1 = []
          this.mediaBeritaTopik2 = []
          this.mediaBeritaTopik3 = []
          this.mediaTwetTopik0 = []
          this.mediaTwetTopik1 = []
          this.mediaTwetTopik2 = []
          this.mediaTwetTopik3 = []
          this.mediaYtTopik0 = []
          this.mediaYtTopik1 = []
          this.mediaYtTopik2 = []
          this.mediaYtTopik3 = []
          
          





          const data =data1.data;
          
          // this.data();
        // Object.assign(this.data);
        //   const sentimen_chart =data1.sentimen_chart;
          
        // alert(sentimen_chart.chartData.length);  
        this.kontenBerita = data.data
        
        // inisialisasi topik 
        // const topik = []       
        // this.kontenBerita.forEach((element) => {
        //   topik.push(element["topik"]);
        // });

      // this.loadTopic();

      //   this.topicsentiment = [...new Set(topik)] 
      //   for (let i = 0; i < data.data.length; i++) {       
      //     if (data.data[i].topik == this.topicsentiment[0]) {
      //        this.topik0.push(data.data[i]);
      //     }         
      // }    
      //   for (let i = 0; i < data.data.length; i++) {       
      //     if (data.data[i].topik == this.topicsentiment[1]) {
      //        this.topik1.push(data.data[i]);
      //     }         
      // }    
      //   for (let i = 0; i < data.data.length; i++) {       
      //     if (data.data[i].topik == this.topicsentiment[2]) {
      //        this.topik2.push(data.data[i]);
      //     }         
      // }    
      //   for (let i = 0; i < data.data.length; i++) {       
      //     if (data.data[i].topik == this.topicsentiment[3]) {
      //        this.topik3.push(data.data[i]);
      //     }         
      // }     
      // inisialisasi tanggal     
        const tanggal = []
        this.kontenBerita.forEach((element) => {
          tanggal.push(element["dateid"]);
        });
        const Settanggal = [...new Set(tanggal)]       
        const Settanggalreserve =  Settanggal.reverse().slice(0, 8)
        this.Settanggal = Settanggalreserve.reverse()     //Settanggal storage

        this.sentimentanalysis = {...this.sentimentanalysis, ...{
          xaxis: {
              categories: this.Settanggal,              
          }
        }}   
        
       
        // alert('load konten jumlah :' +this.kontenBerita.length);
        // tanggal last 30
        this.EndDate = this.Settanggal.at(-1);
        var time = new Date(this.EndDate);
        time.setDate(time.getDate()-29);
        this.StartDateLast30 = time.toISOString().substr(0, 10);
        var getDaysArray = function(start, end) {
          for(var arr=[],dt=new Date(start); dt<=new Date(end); dt.setDate(dt.getDate()+1)){
            arr.push(new Date(dt));
              }
                  return arr;
              };
        var daylist = getDaysArray(new Date(this.StartDateLast30),new Date(this.EndDate));                           
        for (let i = 0; i < daylist.length; i++) {         
          this.SettanggalLast30.push(daylist[i].toISOString().substr(0, 10))
        }  
        // end last 30    
        // ===========================================================================================
        // kategori kontent  berita, twit & youtube===================================================
        // ===========================================================================================
         for (let i = 0; i < data.data.length; i++) {       
          if (data.data[i].source == 'berita') {
              this.mediaBerita.push(data.data[i]);

          }
      }
        // alert(this.mediaBerita.length) ; 
         for (let i = 0; i < data.data.length; i++) {       
          if (data.data[i].source == 'twitter') {
            // console.log(data.data[i].source);
              this.MediatwitterShare.push(data.data[i]);
          }
      }     
       for (let i = 0; i < data.data.length; i++) {       
          if (data.data[i].source == 'youtube') {
              this.MediaYtShare.push(data.data[i]);
          }
      }  
        // ===========================================================================================
        // end kategori kontent  berita, twit & youtube===============================================
        // ===========================================================================================



      for (let i = 0; i < data.data.length; i++) {       
          if (data.data[i].sentiment == 'Positive') {
              this.kontenBeritaPositive.push(data.data[i]);
          }
      }      
        for (let i = 0; i < data.data.length; i++) {       
          if (data.data[i].sentiment == 'Negative') {
              this.kontenBeritaNegative.push(data.data[i]);
          }
      }      
        for (let i = 0; i < data.data.length; i++) {       
          if (data.data[i].sentiment == 'Netral') {
              this.kontenBeritaNetral.push(data.data[i]);
          }
      }      
      const beritaNetralPersen = this.kontenBeritaNetral.length / this.kontenBerita.length * 100 
      this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
      const beritaNegativePersen = this.kontenBeritaNegative.length / this.kontenBerita.length * 100 
      this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
      const beritaPositvePersen = this.kontenBeritaPositive.length / this.kontenBerita.length * 100 
      this.beritaPositifPersen = beritaPositvePersen.toFixed(2)
      const labelMediaShare = []

      this.kontenBerita.forEach((element) => {
        // alert(element["source"]);
          labelMediaShare.push(element["source"]);
      });
      const SetlabelMediaShare = [...new Set(labelMediaShare)]       
      // console.log(SetlabelMediaShare)        
      var filteredArrays = SetlabelMediaShare.filter(function(e) { return e !== 'berita' })
      this.onlinemedia.labels = ['youtube', 'twitter']
      console.log(filteredArrays)

      //  alert('1. load konten jumlah :' +data.data.length);
        if(data.data.length > 0){
          // const data_semntiment =data.data;
          this.loadSentimentanalysis(data);
          this.loadKontenOnlineNews(data);
          this.loadKontenOnlineMedia(data);
          
        }

      }catch(e){
        console.log('error')
      }


    },

















    //  loadSelectTopic(){
    //   // alert('aa');
    //   this.loadKontenBerita();
    //    this.selectedPeriode = ""
    //     this.dialog = true
    //       setTimeout(() => {
    //       this.dialog = false;
    //     }, 1000);        
    //    if(this.selectedTopic == this.topicsentiment[0]){               
    //     this.click = this.topicsentiment[0]
    //        if(this.click == this.topicsentiment[0]){            
    //           this.chart[0].name = this.SetPerson[0]
    //           this.chart[0].amount = this.valueBubleIndx0Topik0.length
    //           this.chart[1].name = this.SetPerson[1]
    //           this.chart[1].amount = this.valueBubleIndx1Topik0.length
    //           this.chart[2].name = this.SetPerson[2]
    //           this.chart[2].amount = this.valueBubleIndx2Topik0.length
    //           this.chart[3].name = this.SetPerson[3]
    //           this.chart[3].amount = this.valueBubleIndx3Topik0.length
    //           this.chart[4].name = this.SetPerson[4]
    //           this.chart[4].amount = this.valueBubleIndx4Topik0.length
    //           this.chart[5].name = this.SetPerson[5]
    //           this.chart[5].amount = this.valueBubleIndx5Topik0.length
    //           this.chartOrganisasi[0].name = this.SetOrganisasi[0]
    //           this.chartOrganisasi[0].amount = this.valueBubleIndx0OrgTopik0.length
    //           this.chartOrganisasi[1].name = this.SetOrganisasi[1]
    //           this.chartOrganisasi[1].amount = this.valueBubleIndx1OrgTopik0.length
    //           this.chartOrganisasi[2].name = this.SetOrganisasi[2]
    //           this.chartOrganisasi[2].amount = this.valueBubleIndx2OrgTopik0.length
    //           this.chartOrganisasi[3].name = this.SetOrganisasi[3]
    //           this.chartOrganisasi[3].amount = this.valueBubleIndx3OrgTopik0.length
    //           this.chartOrganisasi[4].name = this.SetOrganisasi[4]
    //           this.chartOrganisasi[4].amount = this.valueBubleIndx4OrgTopik0.length
    //           this.chartOrganisasi[5].name = this.SetOrganisasi[5]
    //           this.chartOrganisasi[5].amount = this.valueBubleIndx5OrgTopik0.length
    //          this.seriess = []  
    //     window.dispatchEvent(new Event('resize'))  
    //     this.seriessentiment[0].name = this.click
    //     this.seriessentiment[0].data = []
    //     this.seriessentiment[1].name = ''
    //     this.seriessentiment[1].data = []
    //     this.seriessentiment[2].name = ''
    //     this.seriessentiment[2].data = []   
    //     this.seriessentiment[0].data.push(this.tanggalIndx0Topik0.length, this.tanggalIndx1Topik0.length, this.tanggalIndx2Topik0.length, this.tanggalIndx3Topik0.length, this.tanggalIndx4Topik0.length, this.tanggalIndx5Topik0.length, this.tanggalIndx6Topik0.length, this.tanggalIndx7Topik0.length)
    //     this.seriess.push(this.kontenBeritaNetralTopik0.length, this.kontenBeritaNegativeTopik0.length, this.kontenBeritaPositiveTopik0.length)                       
    //     this.kontenBeritaPositive = this.kontenBeritaPositiveTopik0
    //     this.kontenBeritaNegative = this.kontenBeritaNegativeTopik0
    //     this.kontenBeritaNetral = this.kontenBeritaNetralTopik0
    //     const beritaNetralPersen = this.kontenBeritaNetralTopik0.length / this.topik0.length * 100 
    //     this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
    //     const beritaNegativePersen = this.kontenBeritaNegativeTopik0.length / this.topik0.length * 100 
    //     this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
    //     const beritaPositvePersen = this.kontenBeritaPositiveTopik0.length / this.topik0.length * 100 
    //     this.beritaPositifPersen = beritaPositvePersen.toFixed(2)       
    //     this.valueTotalDomain = this.mediaTopik0OnlineNewsShare.length
    //     const persenDomain = this.mediaTopik0OnlineNewsShare.length / this.mediaBerita.length * 10000 /100            
    //     this.seriesonline = []
    //     this.seriesonline.push(parseInt(persenDomain))         
    //   this.valueTotalBerita = this.mediaBeritaTopik0.length
    //   this.valueTotalTwet = this.mediaTwetTopik0.length
    //   this.valueTotalYt = this.mediaYtTopik0.length 
    //   const valueTwitter = this.mediaTwetTopik0.length / this.MediatwitterShare.length * 10000 /100
    //   const valueYoutube = this.mediaYtTopik0.length  / this.MediaYtShare.length * 10000 /100
    //   this.seriesmedia = [parseInt(valueTwitter.toFixed(2)), parseInt(valueYoutube.toFixed(2))]  
    //   }             
    //   }
    //   if(this.selectedTopic == this.topicsentiment[1]){                
    //     this.click = this.topicsentiment[1] 
    //        if(this.click == this.topicsentiment[1]){
    //          this.chart[0].name = this.SetPerson[0]
    //           this.chart[0].amount = this.valueBubleIndx0Topik1.length
    //           this.chart[1].name = this.SetPerson[1]
    //           this.chart[1].amount = this.valueBubleIndx1Topik1.length
    //           this.chart[2].name = this.SetPerson[2]
    //           this.chart[2].amount = this.valueBubleIndx2Topik1.length
    //           this.chart[3].name = this.SetPerson[3]
    //           this.chart[3].amount = this.valueBubleIndx3Topik1.length
    //           this.chart[4].name = this.SetPerson[4]
    //           this.chart[4].amount = this.valueBubleIndx4Topik1.length
    //           this.chart[5].name = this.SetPerson[5]
    //           this.chart[5].amount = this.valueBubleIndx5Topik1.length
    //           this.chartOrganisasi[0].name = this.SetOrganisasi[0]
    //           this.chartOrganisasi[0].amount = this.valueBubleIndx0OrgTopik1.length
    //           this.chartOrganisasi[1].name = this.SetOrganisasi[1]
    //           this.chartOrganisasi[1].amount = this.valueBubleIndx1OrgTopik1.length
    //           this.chartOrganisasi[2].name = this.SetOrganisasi[2]
    //           this.chartOrganisasi[2].amount = this.valueBubleIndx2OrgTopik1.length
    //           this.chartOrganisasi[3].name = this.SetOrganisasi[3]
    //           this.chartOrganisasi[3].amount = this.valueBubleIndx3OrgTopik1.length
    //           this.chartOrganisasi[4].name = this.SetOrganisasi[4]
    //           this.chartOrganisasi[4].amount = this.valueBubleIndx4OrgTopik1.length
    //           this.chartOrganisasi[5].name = this.SetOrganisasi[5]
    //           this.chartOrganisasi[5].amount = this.valueBubleIndx5OrgTopik1.length
    //         this.seriess = []
    //     window.dispatchEvent(new Event('resize'))  
    //     this.seriessentiment[0].data = []
    //     this.seriessentiment[1].name = ''
    //     this.seriessentiment[1].data = []
    //     this.seriessentiment[2].name = ''
    //     this.seriessentiment[2].data = []     
    //     this.seriessentiment[0].name = this.click
    //     this.seriessentiment[0].data.push(this.tanggalIndx0Topik1.length, this.tanggalIndx1Topik1.length, this.tanggalIndx2Topik1.length, this.tanggalIndx3Topik1.length, this.tanggalIndx4Topik1.length, this.tanggalIndx5Topik1.length, this.tanggalIndx6Topik1.length, this.tanggalIndx7Topik1.length)     
    //     this.seriess.push(this.kontenBeritaNetralTopik1.length, this.kontenBeritaNegativeTopik1.length, this.kontenBeritaPositiveTopik1.length)                     
    //     this.kontenBeritaPositive = this.kontenBeritaPositiveTopik1
    //     this.kontenBeritaNegative = this.kontenBeritaNegativeTopik1
    //     this.kontenBeritaNetral = this.kontenBeritaNetralTopik1
    //     const beritaNetralPersen = this.kontenBeritaNetralTopik1.length / this.topik1.length * 100 
    //     this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
    //     const beritaNegativePersen = this.kontenBeritaNegativeTopik1.length / this.topik1.length * 100 
    //     this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
    //     const beritaPositvePersen = this.kontenBeritaPositiveTopik1.length / this.topik1.length * 100 
    //     this.beritaPositifPersen = beritaPositvePersen.toFixed(2)    
    //     this.valueTotalDomain = this.mediaTopik1OnlineNewsShare.length
    //     const persenDomain = this.mediaTopik1OnlineNewsShare.length / this.mediaBerita.length * 10000 /100            
    //     this.seriesonline = []
    //     this.seriesonline.push(parseInt(persenDomain))        
    //   this.valueTotalBerita = this.mediaBeritaTopik1.length
    //   this.valueTotalTwet = this.mediaTwetTopik1.length
    //   this.valueTotalYt = this.mediaYtTopik1.length 
    //   const valueTwitter = this.mediaTwetTopik1.length / this.MediatwitterShare.length * 10000 /100
    //   const valueYoutube = this.mediaYtTopik1.length  / this.MediaYtShare.length * 10000 /100
    //   this.seriesmedia = [parseInt(valueTwitter.toFixed(2)), parseInt(valueYoutube.toFixed(2))]   
    //   }
    //   }
    //   if(this.selectedTopic == this.topicsentiment[2]){            
    //     this.click = this.topicsentiment[2] 
    //        if(this.click == this.topicsentiment[2]){  
    //           this.chart[0].name = this.SetPerson[0]
    //           this.chart[0].amount = this.valueBubleIndx0Topik2.length
    //           this.chart[1].name = this.SetPerson[1]
    //           this.chart[1].amount = this.valueBubleIndx1Topik2.length
    //           this.chart[2].name = this.SetPerson[2]
    //           this.chart[2].amount = this.valueBubleIndx2Topik2.length
    //           this.chart[3].name = this.SetPerson[3]
    //           this.chart[3].amount = this.valueBubleIndx3Topik2.length
    //           this.chart[4].name = this.SetPerson[4]
    //           this.chart[4].amount = this.valueBubleIndx4Topik2.length
    //           this.chart[5].name = this.SetPerson[5]
    //           this.chart[5].amount = this.valueBubleIndx5Topik2.length
    //           this.chartOrganisasi[0].name = this.SetOrganisasi[0]
    //           this.chartOrganisasi[0].amount = this.valueBubleIndx0OrgTopik2.length
    //           this.chartOrganisasi[1].name = this.SetOrganisasi[1]
    //           this.chartOrganisasi[1].amount = this.valueBubleIndx1OrgTopik2.length
    //           this.chartOrganisasi[2].name = this.SetOrganisasi[2]
    //           this.chartOrganisasi[2].amount = this.valueBubleIndx2OrgTopik2.length
    //           this.chartOrganisasi[3].name = this.SetOrganisasi[3]
    //           this.chartOrganisasi[3].amount = this.valueBubleIndx3OrgTopik2.length
    //           this.chartOrganisasi[4].name = this.SetOrganisasi[4]
    //           this.chartOrganisasi[4].amount = this.valueBubleIndx4OrgTopik2.length
    //           this.chartOrganisasi[5].name = this.SetOrganisasi[5]
    //           this.chartOrganisasi[5].amount = this.valueBubleIndx5OrgTopik2.length
    //         this.seriess = []
    //         window.dispatchEvent(new Event('resize'))        
    //         this.seriessentiment[0].name = this.click
    //     this.seriessentiment[0].data = []
    //     this.seriessentiment[1].name = ''
    //     this.seriessentiment[1].data = []
    //     this.seriessentiment[2].name = ''
    //     this.seriessentiment[2].data = []         
    //     this.seriessentiment[0].data.push(this.tanggalIndx0Topik2.length, this.tanggalIndx1Topik2.length, this.tanggalIndx2Topik2.length, this.tanggalIndx3Topik2.length, this.tanggalIndx4Topik2.length, this.tanggalIndx5Topik2.length, this.tanggalIndx6Topik2.length, this.tanggalIndx7Topik2.length)   
    //     this.seriess.push(this.kontenBeritaNetralTopik2.length, this.kontenBeritaNegativeTopik2.length, this.kontenBeritaPositiveTopik2.length)
    //     this.kontenBeritaPositive = this.kontenBeritaPositiveTopik2
    //     this.kontenBeritaNegative = this.kontenBeritaNegativeTopik2
    //     this.kontenBeritaNetral = this.kontenBeritaNetralTopik2 
    //     const beritaNetralPersen = this.kontenBeritaNetralTopik2.length / this.topik2.length * 100 
    //     this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
    //     const beritaNegativePersen = this.kontenBeritaNegativeTopik2.length / this.topik2.length * 100 
    //     this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
    //     const beritaPositvePersen = this.kontenBeritaPositiveTopik2.length / this.topik2.length * 100 
    //     this.beritaPositifPersen = beritaPositvePersen.toFixed(2)
    //     this.mediaTopik2OnlineNewsShare = []       
    //     this.valueTotalDomain = this.mediaTopik2OnlineNewsShare.length
    //     const persenDomain = this.mediaTopik2OnlineNewsShare.length / this.mediaBerita.length * 10000 /100            
    //     this.seriesonline = []
    //     this.seriesonline.push(parseInt(persenDomain))       
    //   this.valueTotalBerita = this.mediaBeritaTopik2.length
    //   this.valueTotalTwet = this.mediaTwetTopik2.length
    //   this.valueTotalYt = this.mediaYtTopik2.length 
    //    const valueTwitter = this.mediaTwetTopik2.length / this.MediatwitterShare.length * 10000 /100
    //   const valueYoutube = this.mediaYtTopik2.length  / this.MediaYtShare.length * 10000 /100
    //   this.seriesmedia = [parseInt(valueTwitter.toFixed(2)), parseInt(valueYoutube.toFixed(2))]                                     
    //   }
    //   }
    //   if(this.selectedTopic == this.topicsentiment[3]){           
    //     this.click = this.topicsentiment[3]
    //        if(this.click == this.topicsentiment[3]){
    //          this.chart[0].name = this.SetPerson[0]
    //          this.chart[0].amount = this.valueBubleIndx0Topik3.length
    //            this.chart[1].name = this.SetPerson[1]
    //            this.chart[1].amount = this.valueBubleIndx1Topik3.length
    //            this.chart[2].name = this.SetPerson[2]
    //            this.chart[2].amount = this.valueBubleIndx2Topik3.length
    //            this.chart[3].name = this.SetPerson[3]
    //            this.chart[3].amount = this.valueBubleIndx3Topik3.length
    //            this.chart[4].name = this.SetPerson[4]
    //            this.chart[4].amount = this.valueBubleIndx4Topik3.length
    //            this.chart[5].name = this.SetPerson[5]
    //            this.chart[5].amount = this.valueBubleIndx5Topik3.length
    //             this.chartOrganisasi[0].name = this.SetOrganisasi[0]
    //            this.chartOrganisasi[0].amount = this.valueBubleIndx0OrgTopik3.length
    //            this.chartOrganisasi[1].name = this.SetOrganisasi[1]
    //            this.chartOrganisasi[1].amount = this.valueBubleIndx1OrgTopik3.length
    //            this.chartOrganisasi[2].name = this.SetOrganisasi[2]
    //            this.chartOrganisasi[2].amount = this.valueBubleIndx2OrgTopik3.length
    //            this.chartOrganisasi[3].name = this.SetOrganisasi[3]
    //            this.chartOrganisasi[3].amount = this.valueBubleIndx3OrgTopik3.length
    //            this.chartOrganisasi[4].name = this.SetOrganisasi[4]
    //            this.chartOrganisasi[4].amount = this.valueBubleIndx4OrgTopik3.length
    //            this.chartOrganisasi[5].name = this.SetOrganisasi[5]
    //            this.chartOrganisasi[5].amount = this.valueBubleIndx5OrgTopik3.length
    //         this.seriess = []
    //         window.dispatchEvent(new Event('resize'))        
    //     this.seriessentiment[0].data = []
    //     this.seriessentiment[1].name = ''
    //     this.seriessentiment[1].data = []
    //     this.seriessentiment[2].name = ''
    //     this.seriessentiment[2].data = []     
    //     this.seriessentiment[0].name = this.click
    //     this.seriessentiment[0].data.push(this.tanggalIndx0Topik3.length, this.tanggalIndx1Topik3.length, this.tanggalIndx2Topik3.length, this.tanggalIndx3Topik3.length, this.tanggalIndx4Topik3.length, this.tanggalIndx5Topik3.length, this.tanggalIndx6Topik3.length, this.tanggalIndx7Topik3.length)
    //     this.seriess.push(this.kontenBeritaNetralTopik3.length, this.kontenBeritaNegativeTopik3.length, this.kontenBeritaPositiveTopik3.length)
    //     this.kontenBeritaPositive = this.kontenBeritaPositiveTopik3
    //     this.kontenBeritaNegative = this.kontenBeritaNegativeTopik3
    //     this.kontenBeritaNetral = this.kontenBeritaNetralTopik3
    //     const beritaNetralPersen = this.kontenBeritaNetralTopik3.length / this.topik3.length * 100 
    //     this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
    //     const beritaNegativePersen = this.kontenBeritaNegativeTopik3.length / this.topik3.length * 100 
    //     this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
    //     const beritaPositvePersen = this.kontenBeritaPositiveTopik3.length / this.topik3.length * 100 
    //     this.beritaPositifPersen = beritaPositvePersen.toFixed(2)       
    //     this.valueTotalDomain = this.mediaTopik3OnlineNewsShare.length
    //     const persenDomain = this.mediaTopik3OnlineNewsShare.length / this.mediaBerita.length * 10000 /100            
    //     this.seriesonline = []
    //     this.seriesonline.push(parseInt(persenDomain))       
    //     this.mediaYtTopik3 = []    
    //   this.valueTotalBerita = this.mediaBeritaTopik3.length
    //   this.valueTotalTwet = this.mediaTwetTopik3.length
    //   this.valueTotalYt = this.mediaYtTopik3.length 
    //   const valueTwitter = this.mediaTwetTopik3.length / this.MediatwitterShare.length * 10000 /100
    //   const valueYoutube = this.mediaYtTopik3.length  / this.MediaYtShare.length * 10000 /100
    //   this.seriesmedia = [parseInt(valueTwitter.toFixed(2)), parseInt(valueYoutube.toFixed(2))]                                     
    //   }
    //   }
    //  },








     




     clickTopPerson(name){
        this.dialog = true
          setTimeout(() => {
        this.dialog = false;
        }, 1000);         
        // console.log(name)       
       if(name == this.SetPerson[0]){
         this.chart[0].color = "#f20053"
         this.chart[1].color = "#F1E987"
         this.chart[2].color = "#B3B8F4"
         this.chart[3].color = "#5EC3C2"
         this.chart[4].color = "#AFDAF5"
         this.chart[5].color = "#C4C4C4"
          this.chart[0].stroke= '#000'        
          this.chart[1].stroke= ''        
          this.chart[2].stroke= ''        
          this.chart[3].stroke= ''        
          this.chart[4].stroke= ''        
          this.chart[5].stroke= ''        
          this.chartOrganisasi[0].color = "#F88FB3"
         this.chartOrganisasi[1].color = "#F1E987"
         this.chartOrganisasi[2].color = "#B3B8F4"
         this.chartOrganisasi[3].color = "#5EC3C2"
         this.chartOrganisasi[4].color = "#AFDAF5"
         this.chartOrganisasi[5].color = "#C4C4C4"
         this.chartOrganisasi[0].stroke= ''        
          this.chartOrganisasi[1].stroke= ''        
          this.chartOrganisasi[2].stroke= ''        
          this.chartOrganisasi[3].stroke= ''        
          this.chartOrganisasi[4].stroke= ''        
          this.chartOrganisasi[5].stroke= ''  
          this.chartOrganisasi[0].name = this.SetOrganisasi[0]
          this.chartOrganisasi[0].amount = this.valueIndx0Org0.length
          this.chartOrganisasi[1].name = this.SetOrganisasi[1]
          this.chartOrganisasi[1].amount = this.valueIndx0Org1.length
          this.chartOrganisasi[2].name = this.SetOrganisasi[2]
          this.chartOrganisasi[2].amount = this.valueIndx0Org2.length
          this.chartOrganisasi[3].name = this.SetOrganisasi[3]
          this.chartOrganisasi[3].amount = this.valueIndx0Org3.length
          this.chartOrganisasi[4].name = this.SetOrganisasi[4]
          this.chartOrganisasi[4].amount = this.valueIndx0Org4.length
          this.chartOrganisasi[5].name = this.SetOrganisasi[5]
          this.kontenBeritaPositive =  this.valueBubleIndx0Positive
          this.kontenBeritaNegative = this.valueBubleIndx0Negative
          this.kontenBeritaNetral = this.valueBubleIndx0Netral
          const beritaNetralPersen = this.valueBubleIndx0Netral.length / this.chartBubleIndx0.length * 100 
          this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
          const beritaNegativePersen = this.valueBubleIndx0Negative.length / this.chartBubleIndx0.length * 100 
          this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
          const beritaPositvePersen = this.valueBubleIndx0Positive.length / this.chartBubleIndx0.length * 100 
          this.beritaPositifPersen = beritaPositvePersen.toFixed(2)    
      this.valueTotalDomain = this.valueBubleIndx0NewsShare.length
      const persenDomain = this.valueBubleIndx0NewsShare.length / this.mediaBerita.length * 10000 /100      
      this.seriesonline = []
      this.seriesonline.push(parseInt(persenDomain))             
      this.valueTotalDomain = this.valueBubleIndx0ShareTwitter.length
      const persenDomainTwitter = this.valueBubleIndx0ShareTwitter.length / this.MediatwitterShare.length * 10000 /100      
      const persenDomainYoutube = this.valueBubleIndx0ShareYoutube.length / this.MediaYtShare.length * 10000 /100      
      this.seriesmedia = []
      this.seriesmedia.push(parseInt(persenDomainTwitter), parseInt(persenDomainYoutube))    
      }
       if(name == this.SetPerson[1]){
        this.chart[0].color = "#F88FB3"
        this.chart[1].color = "#ffe600"
         this.chart[2].color = "#B3B8F4"
         this.chart[3].color = "#5EC3C2"
         this.chart[4].color = "#AFDAF5"
         this.chart[5].color = "#C4C4C4"
          this.chart[0].stroke= ''        
          this.chart[1].stroke= '#000'        
          this.chart[2].stroke= ''        
          this.chart[3].stroke= ''        
          this.chart[4].stroke= ''        
          this.chart[5].stroke= ''      
        this.chartOrganisasi[0].color = "#F88FB3"
         this.chartOrganisasi[1].color = "#F1E987"
         this.chartOrganisasi[2].color = "#B3B8F4"
         this.chartOrganisasi[3].color = "#5EC3C2"
         this.chartOrganisasi[4].color = "#AFDAF5"
         this.chartOrganisasi[5].color = "#C4C4C4"
          this.chartOrganisasi[0].stroke= ''        
          this.chartOrganisasi[1].stroke= ''        
          this.chartOrganisasi[2].stroke= ''        
          this.chartOrganisasi[3].stroke= ''        
          this.chartOrganisasi[4].stroke= ''        
          this.chartOrganisasi[5].stroke= ''  
          this.chartOrganisasi[0].name = this.SetOrganisasi[0]
          this.chartOrganisasi[0].amount = this.valueIndx1Org0.length
          this.chartOrganisasi[1].name = this.SetOrganisasi[1]
          this.chartOrganisasi[1].amount = this.valueIndx1Org1.length
          this.chartOrganisasi[2].name = this.SetOrganisasi[2]
          this.chartOrganisasi[2].amount = this.valueIndx1Org2.length
          this.chartOrganisasi[3].name = this.SetOrganisasi[3]
          this.chartOrganisasi[3].amount = this.valueIndx1Org3.length
          this.chartOrganisasi[4].name = this.SetOrganisasi[4]
          this.chartOrganisasi[4].amount = this.valueIndx1Org4.length
          this.chartOrganisasi[5].name = this.SetOrganisasi[5]
          this.chartOrganisasi[5].amount = this.valueIndx1Org5.length        
          this.kontenBeritaPositive =  this.valueBubleIndx1Positive
          this.kontenBeritaNegative = this.valueBubleIndx1Negative
          this.kontenBeritaNetral = this.valueBubleIndx1Netral
          const beritaNetralPersen = this.valueBubleIndx1Netral.length / this.chartBubleIndx1.length * 100 
          this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
          const beritaNegativePersen = this.valueBubleIndx1Negative.length / this.chartBubleIndx1.length * 100 
          this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
          const beritaPositvePersen = this.valueBubleIndx1Positive.length / this.chartBubleIndx1.length * 100 
          this.beritaPositifPersen = beritaPositvePersen.toFixed(2)
      this.valueTotalDomain = this.valueBubleIndx1NewsShare.length
      const persenDomain = this.valueBubleIndx1NewsShare.length / this.mediaBerita.length * 10000 /100      
      this.seriesonline = []
      this.seriesonline.push(parseInt(persenDomain))             
      this.valueTotalDomain = this.valueBubleIndx1ShareTwitter.length
      const persenDomainTwitter = this.valueBubleIndx1ShareTwitter.length / this.MediatwitterShare.length * 10000 /100      
      const persenDomainYoutube = this.valueBubleIndx1ShareYoutube.length / this.MediaYtShare.length * 10000 /100      
      this.seriesmedia = []
      this.seriesmedia.push(parseInt(persenDomainTwitter), parseInt(persenDomainYoutube))  
       }
       if(name == this.SetPerson[2]){
        this.chart[0].color = "#F88FB3"
        this.chart[1].color = "#F1E987"
         this.chart[2].color = "#0022ff"
         this.chart[3].color = "#5EC3C2"
         this.chart[4].color = "#AFDAF5"
         this.chart[5].color = "#C4C4C4"
          this.chart[0].stroke= ''        
          this.chart[1].stroke= ''        
          this.chart[2].stroke= '#000'        
          this.chart[3].stroke= ''        
          this.chart[4].stroke= ''        
          this.chart[5].stroke= ''  
        this.chartOrganisasi[0].color = "#F88FB3"
         this.chartOrganisasi[1].color = "#F1E987"
         this.chartOrganisasi[2].color = "#B3B8F4"
         this.chartOrganisasi[3].color = "#5EC3C2"
         this.chartOrganisasi[4].color = "#AFDAF5"
         this.chartOrganisasi[5].color = "#C4C4C4"
          this.chartOrganisasi[0].stroke= ''        
          this.chartOrganisasi[1].stroke= ''        
          this.chartOrganisasi[2].stroke= ''        
          this.chartOrganisasi[3].stroke= ''        
          this.chartOrganisasi[4].stroke= ''        
          this.chartOrganisasi[5].stroke= ''  
          this.chartOrganisasi[0].name = this.SetOrganisasi[0]
          this.chartOrganisasi[0].amount = this.valueIndx2Org0.length
          this.chartOrganisasi[1].name = this.SetOrganisasi[1]
          this.chartOrganisasi[1].amount = this.valueIndx2Org1.length
          this.chartOrganisasi[2].name = this.SetOrganisasi[2]
          this.chartOrganisasi[2].amount = this.valueIndx2Org2.length
          this.chartOrganisasi[3].name = this.SetOrganisasi[3]
          this.chartOrganisasi[3].amount = this.valueIndx2Org3.length
          this.chartOrganisasi[4].name = this.SetOrganisasi[4]
          this.chartOrganisasi[4].amount = this.valueIndx2Org4.length
          this.chartOrganisasi[5].name = this.SetOrganisasi[5]
          this.chartOrganisasi[5].amount = this.valueIndx2Org5.length
          this.kontenBeritaPositive =  this.valueBubleIndx2Positive
          this.kontenBeritaNegative = this.valueBubleIndx2Negative
          this.kontenBeritaNetral = this.valueBubleIndx2Netral
          const beritaNetralPersen = this.valueBubleIndx2Netral.length / this.chartBubleIndx2.length * 100 
          this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
          const beritaNegativePersen = this.valueBubleIndx2Negative.length / this.chartBubleIndx2.length * 100 
          this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
          const beritaPositvePersen = this.valueBubleIndx2Positive.length / this.chartBubleIndx2.length * 100 
          this.beritaPositifPersen = beritaPositvePersen.toFixed(2)
      this.valueTotalDomain = this.valueBubleIndx2NewsShare.length
      const persenDomain = this.valueBubleIndx2NewsShare.length / this.mediaBerita.length * 10000 /100      
      this.seriesonline = []
      this.seriesonline.push(parseInt(persenDomain))             
      this.valueTotalDomain = this.valueBubleIndx2ShareTwitter.length
      const persenDomainTwitter = this.valueBubleIndx2ShareTwitter.length / this.MediatwitterShare.length * 10000 /100      
      const persenDomainYoutube = this.valueBubleIndx2ShareYoutube.length / this.MediaYtShare.length * 10000 /100      
      this.seriesmedia = []
      this.seriesmedia.push(parseInt(persenDomainTwitter), parseInt(persenDomainYoutube))             
      }
       if(name == this.SetPerson[3]){
        this.chart[0].color = "#F88FB3"
        this.chart[1].color = "#F1E987"
         this.chart[2].color = "#B3B8F4"
         this.chart[3].color = "#00fffc"
         this.chart[4].color = "#AFDAF5"
         this.chart[5].color = "#C4C4C4"
          this.chart[0].stroke= ''        
          this.chart[1].stroke= ''        
          this.chart[2].stroke= ''        
          this.chart[3].stroke= '#000'        
          this.chart[4].stroke= ''        
          this.chart[5].stroke= ''  
        this.chartOrganisasi[0].color = "#F88FB3"
         this.chartOrganisasi[1].color = "#F1E987"
         this.chartOrganisasi[2].color = "#B3B8F4"
         this.chartOrganisasi[3].color = "#5EC3C2"
         this.chartOrganisasi[4].color = "#AFDAF5"
         this.chartOrganisasi[5].color = "#C4C4C4"
          this.chartOrganisasi[0].stroke= ''        
          this.chartOrganisasi[1].stroke= ''        
          this.chartOrganisasi[2].stroke= ''        
          this.chartOrganisasi[3].stroke= ''        
          this.chartOrganisasi[4].stroke= ''        
          this.chartOrganisasi[5].stroke= ''  
          this.chartOrganisasi[0].name = this.SetOrganisasi[0]
          this.chartOrganisasi[0].amount = this.valueIndx3Org0.length
          this.chartOrganisasi[1].name = this.SetOrganisasi[1]
          this.chartOrganisasi[1].amount = this.valueIndx3Org1.length
          this.chartOrganisasi[2].name = this.SetOrganisasi[2]
          this.chartOrganisasi[2].amount = this.valueIndx3Org2.length
          this.chartOrganisasi[3].name = this.SetOrganisasi[3]
          this.chartOrganisasi[3].amount = this.valueIndx3Org3.length
          this.chartOrganisasi[4].name = this.SetOrganisasi[4]
          this.chartOrganisasi[4].amount = this.valueIndx3Org4.length
          this.chartOrganisasi[5].name = this.SetOrganisasi[5]
          this.chartOrganisasi[5].amount = this.valueIndx3Org5.length         
          this.kontenBeritaPositive =  this.valueBubleIndx3Positive
          this.kontenBeritaNegative = this.valueBubleIndx3Negative
          this.kontenBeritaNetral = this.valueBubleIndx3Netral
          const beritaNetralPersen = this.valueBubleIndx3Netral.length / this.chartBubleIndx3.length * 100 
          this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
          const beritaNegativePersen = this.valueBubleIndx3Negative.length / this.chartBubleIndx3.length * 100 
          this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
          const beritaPositvePersen = this.valueBubleIndx3Positive.length / this.chartBubleIndx3.length * 100 
          this.beritaPositifPersen = beritaPositvePersen.toFixed(2)
      this.valueTotalDomain = this.valueBubleIndx3NewsShare.length
      const persenDomain = this.valueBubleIndx3NewsShare.length / this.mediaBerita.length * 10000 /100      
      this.seriesonline = []
      this.seriesonline.push(parseInt(persenDomain))             
      this.valueTotalDomain = this.valueBubleIndx3ShareTwitter.length
      const persenDomainTwitter = this.valueBubleIndx3ShareTwitter.length / this.MediatwitterShare.length * 10000 /100      
      const persenDomainYoutube = this.valueBubleIndx3ShareYoutube.length / this.MediaYtShare.length * 10000 /100      
      this.seriesmedia = []
      this.seriesmedia.push(parseInt(persenDomainTwitter), parseInt(persenDomainYoutube))  
      }
       if(name == this.SetPerson[4]){
        this.chart[0].color = "#F88FB3"
        this.chart[1].color = "#F1E987"
         this.chart[2].color = "#B3B8F4"
         this.chart[3].color = "#5EC3C2"
         this.chart[4].color = "#009dff"
         this.chart[5].color = "#C4C4C4"
          this.chart[0].stroke= ''        
          this.chart[1].stroke= ''        
          this.chart[2].stroke= ''        
          this.chart[3].stroke= ''        
          this.chart[4].stroke= '#000'        
          this.chart[5].stroke= ''  
        this.chartOrganisasi[0].color = "#F88FB3"
         this.chartOrganisasi[1].color = "#F1E987"
         this.chartOrganisasi[2].color = "#B3B8F4"
         this.chartOrganisasi[3].color = "#5EC3C2"
         this.chartOrganisasi[4].color = "#AFDAF5"
         this.chartOrganisasi[5].color = "#C4C4C4"
          this.chartOrganisasi[0].stroke= ''        
          this.chartOrganisasi[1].stroke= ''        
          this.chartOrganisasi[2].stroke= ''        
          this.chartOrganisasi[3].stroke= ''        
          this.chartOrganisasi[4].stroke= ''        
          this.chartOrganisasi[5].stroke= ''
          this.chartOrganisasi[0].name = this.SetOrganisasi[0]
          this.chartOrganisasi[0].amount = this.valueIndx4Org0.length
          this.chartOrganisasi[1].name = this.SetOrganisasi[1]
          this.chartOrganisasi[1].amount = this.valueIndx4Org1.length
          this.chartOrganisasi[2].name = this.SetOrganisasi[2]
          this.chartOrganisasi[2].amount = this.valueIndx4Org2.length
          this.chartOrganisasi[3].name = this.SetOrganisasi[3]
          this.chartOrganisasi[3].amount = this.valueIndx4Org3.length
          this.chartOrganisasi[4].name = this.SetOrganisasi[4]
          this.chartOrganisasi[4].amount = this.valueIndx4Org4.length
          this.chartOrganisasi[5].name = this.SetOrganisasi[5]
          this.chartOrganisasi[5].amount = this.valueIndx4Org5.length            
          this.kontenBeritaPositive =  this.valueBubleIndx4Positive
          this.kontenBeritaNegative = this.valueBubleIndx4Negative
          this.kontenBeritaNetral = this.valueBubleIndx4Netral
          const beritaNetralPersen = this.valueBubleIndx4Netral.length / this.chartBubleIndx4.length * 100 
          this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
          const beritaNegativePersen = this.valueBubleIndx4Negative.length / this.chartBubleIndx4.length * 100 
          this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
          const beritaPositvePersen = this.valueBubleIndx4Positive.length / this.chartBubleIndx4.length * 100 
          this.beritaPositifPersen = beritaPositvePersen.toFixed(2)
      this.valueTotalDomain = this.valueBubleIndx4NewsShare.length
      const persenDomain = this.valueBubleIndx4NewsShare.length / this.mediaBerita.length * 10000 /100      
      this.seriesonline = []
      this.seriesonline.push(parseInt(persenDomain))             
      this.valueTotalDomain = this.valueBubleIndx4ShareTwitter.length
      const persenDomainTwitter = this.valueBubleIndx4ShareTwitter.length / this.MediatwitterShare.length * 10000 /100      
      const persenDomainYoutube = this.valueBubleIndx4ShareYoutube.length / this.MediaYtShare.length * 10000 /100      
      this.seriesmedia = []
      this.seriesmedia.push(parseInt(persenDomainTwitter), parseInt(persenDomainYoutube))  
      }
       if(name == this.SetPerson[5]){
        this.chart[0].color = "#F88FB3"
         this.chart[1].color = "#F1E987"
         this.chart[2].color = "#B3B8F4"
         this.chart[3].color = "#5EC3C2"
         this.chart[4].color = "#AFDAF5"
         this.chart[5].color = "#454545"
          this.chart[0].stroke= ''        
          this.chart[1].stroke= ''        
          this.chart[2].stroke= ''        
          this.chart[3].stroke= ''        
          this.chart[4].stroke= ''        
          this.chart[5].stroke= '#000'  
        this.chartOrganisasi[0].color = "#F88FB3"
         this.chartOrganisasi[1].color = "#F1E987"
         this.chartOrganisasi[2].color = "#B3B8F4"
         this.chartOrganisasi[3].color = "#5EC3C2"
         this.chartOrganisasi[4].color = "#AFDAF5"
         this.chartOrganisasi[5].color = "#C4C4C4"
          this.chartOrganisasi[0].stroke= ''        
          this.chartOrganisasi[1].stroke= ''        
          this.chartOrganisasi[2].stroke= ''        
          this.chartOrganisasi[3].stroke= ''        
          this.chartOrganisasi[4].stroke= ''        
          this.chartOrganisasi[5].stroke= '' 
          this.chartOrganisasi[0].name = this.SetOrganisasi[0]
          this.chartOrganisasi[0].amount = this.valueIndx5Org0.length
          this.chartOrganisasi[1].name = this.SetOrganisasi[1]
          this.chartOrganisasi[1].amount = this.valueIndx5Org1.length
          this.chartOrganisasi[2].name = this.SetOrganisasi[2]
          this.chartOrganisasi[2].amount = this.valueIndx5Org2.length
          this.chartOrganisasi[3].name = this.SetOrganisasi[3]
          this.chartOrganisasi[3].amount = this.valueIndx5Org3.length
          this.chartOrganisasi[4].name = this.SetOrganisasi[4]
          this.chartOrganisasi[4].amount = this.valueIndx5Org4.length
          this.chartOrganisasi[5].name = this.SetOrganisasi[5]
          this.chartOrganisasi[5].amount = this.valueIndx5Org5.length         
          this.kontenBeritaPositive =  this.valueBubleIndx5Positive
          this.kontenBeritaNegative = this.valueBubleIndx5Negative
          this.kontenBeritaNetral = this.valueBubleIndx5Netral
          const beritaNetralPersen = this.valueBubleIndx5Netral.length / this.chartBubleIndx5.length * 100 
          this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
          const beritaNegativePersen = this.valueBubleIndx5Negative.length / this.chartBubleIndx5.length * 100 
          this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
          const beritaPositvePersen = this.valueBubleIndx5Positive.length / this.chartBubleIndx5.length * 100 
          this.beritaPositifPersen = beritaPositvePersen.toFixed(2)
      this.valueTotalDomain = this.valueBubleIndx5NewsShare.length
      const persenDomain = this.valueBubleIndx5NewsShare.length / this.mediaBerita.length * 10000 /100      
      this.seriesonline = []
      this.seriesonline.push(parseInt(persenDomain))             
      this.valueTotalDomain = this.valueBubleIndx5ShareTwitter.length
      const persenDomainTwitter = this.valueBubleIndx5ShareTwitter.length / this.MediatwitterShare.length * 10000 /100      
      const persenDomainYoutube = this.valueBubleIndx5ShareYoutube.length / this.MediaYtShare.length * 10000 /100      
      this.seriesmedia = []
      this.seriesmedia.push(parseInt(persenDomainTwitter), parseInt(persenDomainYoutube))       
      }    
     },


     clickTopOrganisasi(name){
        this.dialog = true
          setTimeout(() => {
        this.dialog = false;
        }, 1000);         
        console.log(name)       
       if(name == this.SetOrganisasi[0]){
        this.chart[0].color = "#F88FB3"
         this.chart[1].color = "#F1E987"
         this.chart[2].color = "#B3B8F4"
         this.chart[3].color = "#5EC3C2"
         this.chart[4].color = "#AFDAF5"
         this.chart[5].color = "#C4C4C4"
          this.chart[0].stroke= ''        
          this.chart[1].stroke= ''        
          this.chart[2].stroke= ''        
          this.chart[3].stroke= ''        
          this.chart[4].stroke= ''        
          this.chart[5].stroke= ''  
         this.chartOrganisasi[0].color = "#f20053"
         this.chartOrganisasi[1].color = "#F1E987"
         this.chartOrganisasi[2].color = "#B3B8F4"
         this.chartOrganisasi[3].color = "#5EC3C2"
         this.chartOrganisasi[4].color = "#AFDAF5"
         this.chartOrganisasi[5].color = "#C4C4C4"
          this.chartOrganisasi[0].stroke= '#000'        
          this.chartOrganisasi[1].stroke= ''        
          this.chartOrganisasi[2].stroke= ''        
          this.chartOrganisasi[3].stroke= ''        
          this.chartOrganisasi[4].stroke= ''        
          this.chartOrganisasi[5].stroke= '' 
          this.chart[0].name = this.SetPerson[0]
          this.chart[0].amount = this.valueOrg0Indx0.length
          this.chart[1].name = this.SetPerson[1]
          this.chart[1].amount = this.valueOrg0Indx1.length
          this.chart[2].name = this.SetPerson[2]
          this.chart[2].amount = this.valueOrg0Indx2.length
          this.chart[3].name = this.SetPerson[3]
          this.chart[3].amount = this.valueOrg0Indx3.length
          this.chart[4].name = this.SetPerson[4]
          this.chart[4].amount = this.valueOrg0Indx4.length
          this.chart[5].name = this.SetPerson[5]
          this.chart[5].amount = this.valueOrg0Indx5.length       
          this.kontenBeritaPositive =  this.valueBubleIndx0OrgPositive
          this.kontenBeritaNegative = this.valueBubleIndx0OrgNegative
          this.kontenBeritaNetral = this.valueBubleIndx0OrgNetral
          const beritaNetralPersen = this.valueBubleIndx0OrgNetral.length / this.chartBubleIndxOrg0.length * 100 
          this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
          const beritaNegativePersen = this.valueBubleIndx0OrgNegative.length / this.chartBubleIndxOrg0.length * 100 
          this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
          const beritaPositvePersen = this.valueBubleIndx0OrgPositive.length / this.chartBubleIndxOrg0.length * 100 
          this.beritaPositifPersen = beritaPositvePersen.toFixed(2)
          this.valueTotalDomain = this.valueBubleIndx0OrgNewsShare.length
          const persenDomain = this.valueBubleIndx0OrgNewsShare.length / this.mediaBerita.length * 10000 /100      
          this.seriesonline = []
          this.seriesonline.push(parseInt(persenDomain))             
          this.valueTotalDomain = this.valueBubleIndx0OrgShareTwitter.length
          const persenDomainTwitter = this.valueBubleIndx0OrgShareTwitter.length / this.MediatwitterShare.length * 10000 /100      
          const persenDomainYoutube = this.valueBubleIndx0OrgShareYoutube.length / this.MediaYtShare.length * 10000 /100      
          this.seriesmedia = []
          this.seriesmedia.push(parseInt(persenDomainTwitter), parseInt(persenDomainYoutube))            
       }
       if(name == this.SetOrganisasi[1]){
        this.chart[0].color = "#F88FB3"
         this.chart[1].color = "#F1E987"
         this.chart[2].color = "#B3B8F4"
         this.chart[3].color = "#5EC3C2"
         this.chart[4].color = "#AFDAF5"
         this.chart[5].color = "#C4C4C4"
          this.chart[0].stroke= ''        
          this.chart[1].stroke= ''        
          this.chart[2].stroke= ''        
          this.chart[3].stroke= ''        
          this.chart[4].stroke= ''        
          this.chart[5].stroke= ''  
        this.chartOrganisasi[0].color = "#F88FB3"
        this.chartOrganisasi[1].color = "#ffe600"
         this.chartOrganisasi[2].color = "#B3B8F4"
         this.chartOrganisasi[3].color = "#5EC3C2"
         this.chartOrganisasi[4].color = "#AFDAF5"
         this.chartOrganisasi[5].color = "#C4C4C4" 
          this.chartOrganisasi[0].stroke= ''        
          this.chartOrganisasi[1].stroke= '#000'        
          this.chartOrganisasi[2].stroke= ''        
          this.chartOrganisasi[3].stroke= ''        
          this.chartOrganisasi[4].stroke= ''        
          this.chartOrganisasi[5].stroke= '' 
          this.chart[0].name = this.SetPerson[0]
          this.chart[0].amount = this.valueOrg1Indx0.length
          this.chart[1].name = this.SetPerson[1]
          this.chart[1].amount = this.valueOrg1Indx1.length
          this.chart[2].name = this.SetPerson[2]
          this.chart[2].amount = this.valueOrg1Indx2.length
          this.chart[3].name = this.SetPerson[3]
          this.chart[3].amount = this.valueOrg1Indx3.length
          this.chart[4].name = this.SetPerson[4]
          this.chart[4].amount = this.valueOrg1Indx4.length
          this.chart[5].name = this.SetPerson[5]
          this.chart[5].amount = this.valueOrg1Indx5.length                 
          this.kontenBeritaPositive =  this.valueBubleIndx1OrgPositive
          this.kontenBeritaNegative = this.valueBubleIndx1OrgNegative
          this.kontenBeritaNetral = this.valueBubleIndx1OrgNetral
          const beritaNetralPersen = this.valueBubleIndx1OrgNetral.length / this.chartBubleIndxOrg1.length * 100 
          this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
          const beritaNegativePersen = this.valueBubleIndx1OrgNegative.length / this.chartBubleIndxOrg1.length * 100 
          this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
          const beritaPositvePersen = this.valueBubleIndx1OrgPositive.length / this.chartBubleIndxOrg1.length * 100 
          this.beritaPositifPersen = beritaPositvePersen.toFixed(2)
          this.valueTotalDomain = this.valueBubleIndx1OrgNewsShare.length
          const persenDomain = this.valueBubleIndx1OrgNewsShare.length / this.mediaBerita.length * 10000 /100      
          this.seriesonline = []
          this.seriesonline.push(parseInt(persenDomain))             
          this.valueTotalDomain = this.valueBubleIndx1OrgShareTwitter.length
          const persenDomainTwitter = this.valueBubleIndx1OrgShareTwitter.length / this.MediatwitterShare.length * 10000 /100      
          const persenDomainYoutube = this.valueBubleIndx1OrgShareYoutube.length / this.MediaYtShare.length * 10000 /100      
          this.seriesmedia = []
          this.seriesmedia.push(parseInt(persenDomainTwitter), parseInt(persenDomainYoutube))                                       
       }
       if(name == this.SetOrganisasi[2]){
        this.chart[0].color = "#F88FB3"
         this.chart[1].color = "#F1E987"
         this.chart[2].color = "#B3B8F4"
         this.chart[3].color = "#5EC3C2"
         this.chart[4].color = "#AFDAF5"
         this.chart[5].color = "#C4C4C4"
          this.chart[0].stroke= ''        
          this.chart[1].stroke= ''        
          this.chart[2].stroke= ''        
          this.chart[3].stroke= ''        
          this.chart[4].stroke= ''        
          this.chart[5].stroke= ''  
        this.chartOrganisasi[0].color = "#F88FB3"
        this.chartOrganisasi[1].color = "#F1E987"
         this.chartOrganisasi[2].color = "#0022ff"
         this.chartOrganisasi[3].color = "#5EC3C2"
         this.chartOrganisasi[4].color = "#AFDAF5"
         this.chartOrganisasi[5].color = "#C4C4C4"
          this.chartOrganisasi[0].stroke= ''        
          this.chartOrganisasi[1].stroke= ''        
          this.chartOrganisasi[2].stroke= '#000'        
          this.chartOrganisasi[3].stroke= ''        
          this.chartOrganisasi[4].stroke= ''        
          this.chartOrganisasi[5].stroke= ''
          this.chart[0].name = this.SetPerson[0]
          this.chart[0].amount = this.valueOrg2Indx0.length
          this.chart[1].name = this.SetPerson[1]
          this.chart[1].amount = this.valueOrg2Indx1.length
          this.chart[2].name = this.SetPerson[2]
          this.chart[2].amount = this.valueOrg2Indx2.length
          this.chart[3].name = this.SetPerson[3]
          this.chart[3].amount = this.valueOrg2Indx3.length
          this.chart[4].name = this.SetPerson[4]
          this.chart[4].amount = this.valueOrg2Indx4.length
          this.chart[5].name = this.SetPerson[5]
          this.chart[5].amount = this.valueOrg2Indx5.length                
          this.kontenBeritaPositive =  this.valueBubleIndx2OrgPositive
          this.kontenBeritaNegative = this.valueBubleIndx2OrgNegative
          this.kontenBeritaNetral = this.valueBubleIndx2OrgNetral
          const beritaNetralPersen = this.valueBubleIndx2OrgNetral.length / this.chartBubleIndxOrg2.length * 100 
          this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
          const beritaNegativePersen = this.valueBubleIndx2OrgNegative.length / this.chartBubleIndxOrg2.length * 100 
          this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
          const beritaPositvePersen = this.valueBubleIndx2OrgPositive.length / this.chartBubleIndxOrg2.length * 100 
          this.beritaPositifPersen = beritaPositvePersen.toFixed(2)
      this.valueTotalDomain = this.valueBubleIndx2OrgNewsShare.length
      const persenDomain = this.valueBubleIndx2OrgNewsShare.length / this.mediaBerita.length * 10000 /100      
      this.seriesonline = []
      this.seriesonline.push(parseInt(persenDomain))             
      this.valueTotalDomain = this.valueBubleIndx2OrgShareTwitter.length
      const persenDomainTwitter = this.valueBubleIndx2OrgShareTwitter.length / this.MediatwitterShare.length * 10000 /100      
      const persenDomainYoutube = this.valueBubleIndx2OrgShareYoutube.length / this.MediaYtShare.length * 10000 /100      
      this.seriesmedia = []
      this.seriesmedia.push(parseInt(persenDomainTwitter), parseInt(persenDomainYoutube))      
      }
       if(name == this.SetOrganisasi[3]){
        this.chart[0].color = "#F88FB3"
         this.chart[1].color = "#F1E987"
         this.chart[2].color = "#B3B8F4"
         this.chart[3].color = "#5EC3C2"
         this.chart[4].color = "#AFDAF5"
         this.chart[5].color = "#C4C4C4"
          this.chart[0].stroke= ''        
          this.chart[1].stroke= ''        
          this.chart[2].stroke= ''        
          this.chart[3].stroke= ''        
          this.chart[4].stroke= ''        
          this.chart[5].stroke= ''  
        this.chartOrganisasi[0].color = "#F88FB3"
        this.chartOrganisasi[1].color = "#F1E987"
         this.chartOrganisasi[2].color = "#B3B8F4"
         this.chartOrganisasi[3].color = "#00fffc"
         this.chartOrganisasi[4].color = "#AFDAF5"
         this.chartOrganisasi[5].color = "#C4C4C4"
          this.chartOrganisasi[0].stroke= ''        
          this.chartOrganisasi[1].stroke= ''        
          this.chartOrganisasi[2].stroke= ''        
          this.chartOrganisasi[3].stroke= '#000'        
          this.chartOrganisasi[4].stroke= ''        
          this.chartOrganisasi[5].stroke= ''            
      this.chart[0].name = this.SetPerson[0]
      this.chart[0].amount = this.valueOrg3Indx0.length
      this.chart[1].name = this.SetPerson[1]
      this.chart[1].amount = this.valueOrg3Indx1.length
      this.chart[2].name = this.SetPerson[2]
      this.chart[2].amount = this.valueOrg3Indx2.length
      this.chart[3].name = this.SetPerson[3]
      this.chart[3].amount = this.valueOrg3Indx3.length
      this.chart[4].name = this.SetPerson[4]
      this.chart[4].amount = this.valueOrg3Indx4.length
      this.chart[5].name = this.SetPerson[5]
      this.chart[5].amount = this.valueOrg3Indx5.length
      this.kontenBeritaPositive =  this.valueBubleIndx3OrgPositive
      this.kontenBeritaNegative = this.valueBubleIndx3OrgNegative
      this.kontenBeritaNetral = this.valueBubleIndx3OrgNetral
      const beritaNetralPersen = this.valueBubleIndx3OrgNetral.length / this.chartBubleIndxOrg3.length * 100 
      this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
      const beritaNegativePersen = this.valueBubleIndx3OrgNegative.length / this.chartBubleIndxOrg3.length * 100 
      this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
      const beritaPositvePersen = this.valueBubleIndx3OrgPositive.length / this.chartBubleIndxOrg3.length * 100 
      this.beritaPositifPersen = beritaPositvePersen.toFixed(2)
      this.valueTotalDomain = this.valueBubleIndx3OrgNewsShare.length
      const persenDomain = this.valueBubleIndx3OrgNewsShare.length / this.mediaBerita.length * 10000 /100      
      this.seriesonline = []
      this.seriesonline.push(parseInt(persenDomain))             
      this.valueTotalDomain = this.valueBubleIndx3OrgShareTwitter.length
      const persenDomainTwitter = this.valueBubleIndx3OrgShareTwitter.length / this.MediatwitterShare.length * 10000 /100      
      const persenDomainYoutube = this.valueBubleIndx3OrgShareYoutube.length / this.MediaYtShare.length * 10000 /100      
      this.seriesmedia = []
      this.seriesmedia.push(parseInt(persenDomainTwitter), parseInt(persenDomainYoutube))            
      }
      if(name == this.SetOrganisasi[4]){
        this.chart[0].color = "#F88FB3"
         this.chart[1].color = "#F1E987"
         this.chart[2].color = "#B3B8F4"
         this.chart[3].color = "#5EC3C2"
         this.chart[4].color = "#AFDAF5"
         this.chart[5].color = "#C4C4C4"
          this.chart[0].stroke= ''        
          this.chart[1].stroke= ''        
          this.chart[2].stroke= ''        
          this.chart[3].stroke= ''        
          this.chart[4].stroke= ''        
          this.chart[5].stroke= ''  
        this.chartOrganisasi[0].color = "#F88FB3"
        this.chartOrganisasi[1].color = "#F1E987"
         this.chartOrganisasi[2].color = "#B3B8F4"
         this.chartOrganisasi[3].color = "#5EC3C2"
         this.chartOrganisasi[4].color = "#009dff"
         this.chartOrganisasi[5].color = "#C4C4C4"
          this.chartOrganisasi[0].stroke= ''        
          this.chartOrganisasi[1].stroke= ''        
          this.chartOrganisasi[2].stroke= ''        
          this.chartOrganisasi[3].stroke= ''        
          this.chartOrganisasi[4].stroke= '#000'        
          this.chartOrganisasi[5].stroke= ''  
          this.chart[0].name = this.SetPerson[0]
          this.chart[0].amount = this.valueOrg4Indx0.length
          this.chart[1].name = this.SetPerson[1]
          this.chart[1].amount = this.valueOrg4Indx1.length
          this.chart[2].name = this.SetPerson[2]
          this.chart[2].amount = this.valueOrg4Indx2.length
          this.chart[3].name = this.SetPerson[3]
          this.chart[3].amount = this.valueOrg4Indx3.length
          this.chart[4].name = this.SetPerson[4]
          this.chart[4].amount = this.valueOrg4Indx4.length
          this.chart[5].name = this.SetPerson[5]
          this.chart[5].amount = this.valueOrg4Indx5.length      
          this.kontenBeritaPositive =  this.valueBubleIndx4OrgPositive
          this.kontenBeritaNegative = this.valueBubleIndx4OrgNegative
          this.kontenBeritaNetral = this.valueBubleIndx4OrgNetral
          const beritaNetralPersen = this.valueBubleIndx4OrgNetral.length / this.chartBubleIndxOrg4.length * 100 
          this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
          const beritaNegativePersen = this.valueBubleIndx4OrgNegative.length / this.chartBubleIndxOrg4.length * 100 
          this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
          const beritaPositvePersen = this.valueBubleIndx4OrgPositive.length / this.chartBubleIndxOrg4.length * 100 
          this.beritaPositifPersen = beritaPositvePersen.toFixed(2)
      this.valueTotalDomain = this.valueBubleIndx4OrgNewsShare.length
      const persenDomain = this.valueBubleIndx4OrgNewsShare.length / this.mediaBerita.length * 10000 /100      
      this.seriesonline = []
      this.seriesonline.push(parseInt(persenDomain))             
      this.valueTotalDomain = this.valueBubleIndx4OrgShareTwitter.length
      const persenDomainTwitter = this.valueBubleIndx4OrgShareTwitter.length / this.MediatwitterShare.length * 10000 /100      
      const persenDomainYoutube = this.valueBubleIndx4OrgShareYoutube.length / this.MediaYtShare.length * 10000 /100      
      this.seriesmedia = []
      this.seriesmedia.push(parseInt(persenDomainTwitter), parseInt(persenDomainYoutube))           
      }
       if(name == this.SetOrganisasi[5]){
          this.chart[0].color = "#F88FB3"
         this.chart[1].color = "#F1E987"
         this.chart[2].color = "#B3B8F4"
         this.chart[3].color = "#5EC3C2"
         this.chart[4].color = "#AFDAF5"
         this.chart[5].color = "#C4C4C4" 
          this.chart[0].stroke= ''        
          this.chart[1].stroke= ''        
          this.chart[2].stroke= ''        
          this.chart[3].stroke= ''        
          this.chart[4].stroke= ''        
          this.chart[5].stroke= ''  
        this.chartOrganisasi[0].color = "#F88FB3"
         this.chartOrganisasi[1].color = "#F1E987"
         this.chartOrganisasi[2].color = "#B3B8F4"
         this.chartOrganisasi[3].color = "#5EC3C2"
         this.chartOrganisasi[4].color = "#AFDAF5"
         this.chartOrganisasi[5].color = "#454545"
          this.chartOrganisasi[0].stroke= ''        
          this.chartOrganisasi[1].stroke= ''        
          this.chartOrganisasi[2].stroke= ''        
          this.chartOrganisasi[3].stroke= ''        
          this.chartOrganisasi[4].stroke= ''        
          this.chartOrganisasi[5].stroke= '#000'
          this.chart[0].name = this.SetPerson[0]
          this.chart[0].amount = this.valueOrg5Indx0.length
          this.chart[1].name = this.SetPerson[1]
          this.chart[1].amount = this.valueOrg5Indx1.length
          this.chart[2].name = this.SetPerson[2]
          this.chart[2].amount = this.valueOrg5Indx2.length
          this.chart[3].name = this.SetPerson[3]
          this.chart[3].amount = this.valueOrg5Indx3.length
          this.chart[4].name = this.SetPerson[4]
          this.chart[4].amount = this.valueOrg5Indx4.length
          this.chart[5].name = this.SetPerson[5]
          this.chart[5].amount = this.valueOrg5Indx5.length      
          this.kontenBeritaPositive =  this.valueBubleIndx5OrgPositive
          this.kontenBeritaNegative = this.valueBubleIndx5OrgNegative
          this.kontenBeritaNetral = this.valueBubleIndx5OrgNetral
          const beritaNetralPersen = this.valueBubleIndx5OrgNetral.length / this.chartBubleIndxOrg5.length * 100 
          this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
          const beritaNegativePersen = this.valueBubleIndx5OrgNegative.length / this.chartBubleIndxOrg5.length * 100 
          this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
          const beritaPositvePersen = this.valueBubleIndx5OrgPositive.length / this.chartBubleIndxOrg5.length * 100 
          this.beritaPositifPersen = beritaPositvePersen.toFixed(2)
      this.valueTotalDomain = this.valueBubleIndx5OrgNewsShare.length
      const persenDomain = this.valueBubleIndx5OrgNewsShare.length / this.mediaBerita.length * 10000 /100      
      this.seriesonline = []
      this.seriesonline.push(parseInt(persenDomain))             
      this.valueTotalDomain = this.valueBubleIndx5OrgShareTwitter.length
      const persenDomainTwitter = this.valueBubleIndx5OrgShareTwitter.length / this.MediatwitterShare.length * 10000 /100      
      const persenDomainYoutube = this.valueBubleIndx5OrgShareYoutube.length / this.MediaYtShare.length * 10000 /100      
      this.seriesmedia = []
      this.seriesmedia.push(parseInt(persenDomainTwitter), parseInt(persenDomainYoutube))      
      }
     },
    // clickHandle(event, chartContext, config) {    
    //   console.log(chartContext, config.dataPointIndex);
    //   this.chart[0].name = "Prabowo"
    //   this.chart[0].amount = this.valueBublePrabowoBisnis.length
    //   this.chart[1].name = "Jokowi"
    //   this.chart[1].amount = this.valueBubleJokowiBisnis.length
    //   this.chart[2].name = "Anies"
    //   this.chart[2].amount = this.valueBubleAniesBisnis.length
    //   this.chart[3].name = "Risma"
    //   this.chart[3].amount = this.valueBubleRismaBisnis.length
    //   this.chart[4].name = "Ganjar"
    //   this.chart[4].amount = this.valueBubleGanjarBisnis.length
    //   this.chart[5].name = "Sandiuno"
    //   this.chart[5].amount = this.valueBubleSandiBisnis.length    
    // },  
    generateData(baseval, count, yrange) {
      var i = 0;
      var series = [];
      while (i < count) {
        var x = Math.floor(Math.random() * (750 - 1 + 1)) + 1;
        var y = Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;
        var z = Math.floor(Math.random() * (75 - 15 + 1)) + 15;
        series.push([x, y, z]);
        baseval += 86400000;
        i++;
      }
      return series;
    },             



































    // ========================================== =============== ======================================
    // ========================================== sentiment analisis ======================================
    // ========================================== =============== ======================================

    //sentimentanalysis
    async loadSentimentanalysis(data){
      
        // this.dialog = true;
      try{
        
        // const data1 = await axios.get("solr-dashboard?start_date="+this.date2+"&end_date="+this.date1+"&topic="+this.selectedTopic,
        //   {headers:{'auth-token':localStorage.getItem('token_app')}}
        //   )
        // // //const data1 = await axios.get("news")
        //   // const data =data1.data;
        //   const data =data1.data;
          // alert('2. Load sentimen berita : '+this.mediaBerita.length);
          // alert('3. Load sentimen tweet : '+this.MediatwitterShare.length);
          
// oke  =========== 
          for (let i = 0; i < this.mediaBerita.length; i++) {       
              if (this.mediaBerita[i].dateid == this.Settanggal[0]) {
                  this.tnglIndex0.push(data.data[i]);
              }
          }
          for (let i = 0; i < this.mediaBerita.length; i++) {       
              if (this.mediaBerita[i].dateid == this.Settanggal[1]) {

                  this.tnglIndex1.push(data.data[i]);
              }
          }
          for (let i = 0; i < this.mediaBerita.length; i++) {       
              if (this.mediaBerita[i].dateid == this.Settanggal[2]) {
                  this.tnglIndex2.push(data.data[i]);
              }
          }
          for (let i = 0; i < this.mediaBerita.length; i++) {       
              if (this.mediaBerita[i].dateid == this.Settanggal[3]) {
                  this.tnglIndex3.push(data.data[i]);
              }
          }
          for (let i = 0; i < this.mediaBerita.length; i++) {       
              if (this.mediaBerita[i].dateid == this.Settanggal[4]) {
                  this.tnglIndex4.push(data.data[i]);
              }
          }
          for (let i = 0; i < this.mediaBerita.length; i++) {       
              if (this.mediaBerita[i].dateid == this.Settanggal[5]) {
                  this.tnglIndex5.push(data.data[i]);
              }
          }
          for (let i = 0; i < this.mediaBerita.length; i++) {       
              if (this.mediaBerita[i].dateid == this.Settanggal[6]) {
                  this.tnglIndex6.push(data.data[i]);
              }
          }
          for (let i = 0; i < this.mediaBerita.length; i++) {       
              if (this.mediaBerita[i].dateid == this.Settanggal[7]) {
                  this.tnglIndex7.push(data.data[i]);
              }
          }          
      // end topik berita

// end oke  =========== 




      // topik twet
      for (let i = 0; i < this.MediatwitterShare.length; i++) {       
          if (this.MediatwitterShare[i].dateid == this.Settanggal[0]) {
              this.tnglIndex0Twet.push(this.MediatwitterShare[i]);
          }        
      }
       for (let i = 0; i < this.MediatwitterShare.length; i++) {       
          if (this.MediatwitterShare[i].dateid == this.Settanggal[1]) {
              this.tnglIndex1Twet.push(data.data[i]);
          }
      }
       for (let i = 0; i < this.MediatwitterShare.length; i++) {       
          if (this.MediatwitterShare[i].dateid == this.Settanggal[2]) {
              this.tnglIndex2Twet.push(data.data[i]);
          }
      }
       for (let i = 0; i < this.MediatwitterShare.length; i++) {       
          if (this.MediatwitterShare[i].dateid == this.Settanggal[3]) {
              this.tnglIndex3Twet.push(data.data[i]);
          }
      }
       for (let i = 0; i < this.MediatwitterShare.length; i++) {       
          if (this.MediatwitterShare[i].dateid == this.Settanggal[4]) {
              this.tnglIndex4Twet.push(data.data[i]);
          }
      }
       for (let i = 0; i < this.MediatwitterShare.length; i++) {       
          if (this.MediatwitterShare[i].dateid == this.Settanggal[5]) {
              this.tnglIndex5Twet.push(data.data[i]);
          }
      }
       for (let i = 0; i < this.MediatwitterShare.length; i++) {       
          if (this.MediatwitterShare[i].dateid == this.Settanggal[6]) {
              this.tnglIndex6Twet.push(data.data[i]);
          }
      }
       for (let i = 0; i < this.MediatwitterShare.length; i++) {       
          if (this.MediatwitterShare[i].dateid == this.Settanggal[7]) {
              this.tnglIndex7Twet.push(data.data[i]);
          }
      }   
      // end topik twet




      
      // topik yt
        for (let i = 0; i < this.MediaYtShare.length; i++) {       
          if (this.MediaYtShare[i].dateid == this.Settanggal[0]) {
              this.tnglIndex0Yt.push(data.data[i]);
          }
      }
       for (let i = 0; i < this.MediaYtShare.length; i++) {               
          if (this.MediaYtShare[i].dateid == this.Settanggal[1]) {
              this.tnglIndex1Yt.push(data.data[i]);
          }
      }
       for (let i = 0; i < this.MediaYtShare.length; i++) {       
          if (this.MediaYtShare[i].dateid == this.Settanggal[2]) {
              this.tnglIndex2Yt.push(data.data[i]);
          }
      }
       for (let i = 0; i < this.MediaYtShare.length; i++) {       
          if (this.MediaYtShare[i].dateid == this.Settanggal[3]) {
              this.tnglIndex3Yt.push(data.data[i]);
          }
      }
       for (let i = 0; i < this.MediaYtShare.length; i++) {       
          if (this.MediaYtShare[i].dateid == this.Settanggal[4]) {
              this.tnglIndex4Yt.push(data.data[i]);
          }
      }
       for (let i = 0; i < this.MediaYtShare.length; i++) {       
          if (this.MediaYtShare[i].dateid == this.Settanggal[5]) {
              this.tnglIndex5Yt.push(data.data[i]);
          }
      }
       for (let i = 0; i < this.MediaYtShare.length; i++) {       
          if (this.MediaYtShare[i].dateid == this.Settanggal[6]) {
              this.tnglIndex6Yt.push(data.data[i]);
          }
      }
       for (let i = 0; i < this.MediaYtShare.length; i++) {       
          if (this.MediaYtShare[i].dateid == this.Settanggal[7]) {
              this.tnglIndex7Yt.push(data.data[i]);
          }
      }     
      // end topik yt



      // chart buble person
     // ================================== seet data person 
      const person = []

      const person2 = []
      const SetttPerson = []
      const SetttPerson2 = []
          // alert('konten senti : '+this.kontenBerita.length);ok
            // console.log('person :'+this.kontenBerita);
          this.kontenBerita.forEach((element) => {
          // alert('person : '+element["ner_person"]+ '======' +element["ner_organization"]); ok
            if(element["ner_person"] != ''  && element["ner_person"] != null ){
              person.push(element["ner_person"]);
              person2.push(element["ner_person"]);
              // new 
              
            }
          });

          for (let i = 0; i < person.length; i++) {   
              SetttPerson.push(person[i].at(-0));    
              SetttPerson2.push(person[i].at(-1));
          }
          
        const Setperson = [...new Set(SetttPerson)] 
        const Setperson2 = [...new Set(SetttPerson2)]            
        const Setperson3 = Setperson.concat(Setperson2)
        this.SetPerson =  [...new Set(Setperson3)]
        //  =============================== end seet data person






// ======= push variable chartBubleIndx ???? =============================
// ======= push variable chartBubleIndx ???? =============================
// ======= push variable chartBubleIndx ???? =============================
// ======= push variable chartBubleIndx ???? =============================
// ======= push variable chartBubleIndx ???? =============================
// ======= push variable chartBubleIndx???? =============================
// ======= push variable chartBubleIndx???? =============================
// ======= push variable chartBubleIndx???? =============================
// ======= push variable chartBubleIndx???? =============================
        for (let i = 0; i < data.data.length; i++) { 
        // if(data.data[i].ner_person.length > 0 ){
          
          if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null
            if(data.data[i].ner_person[0] != '' && data.data[i].ner_person[0] != null){
              // if(i == 0){
                // s
                if (data.data[i].ner_person[0] == this.SetPerson[0]) {
                // alert(data.data[i].ner_person[0] + '  =========  ' + this.SetPerson[0]);
                  this.chartBubleIndx0.push(data.data[i])
                }  
            } 

          }
          // }      
      }        

      for (let i = 0; i < data.data.length; i++) {   
        
          if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null
            if (data.data[i].ner_person[1] == this.SetPerson[0]) {
              this.chartBubleIndx0.push(data.data[i])
            }       
          }  
      } 
      this.chart[0].name = this.SetPerson[0]
      this.chart[0].amount = this.chartBubleIndx0.length
        for (let i = 0; i < data.data.length; i++) {   
          
          if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null
            if (data.data[i].ner_person[0] == this.SetPerson[1]) {
              this.chartBubleIndx1.push(data.data[i])
            }         
          }
      }          

      for (let i = 0; i < data.data.length; i++) {  

        if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null
          if (data.data[i].ner_person[1] == this.SetPerson[1]) {
            this.chartBubleIndx1.push(data.data[i])
          } 
        }        
      }          
      this.chart[1].name = this.SetPerson[1]
      this.chart[1].amount = this.chartBubleIndx1.length


// ner_person
        for (let i = 0; i < data.data.length; i++) {    
          if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null
            if (data.data[i].ner_person[0] == this.SetPerson[2]) {
              this.chartBubleIndx2.push(data.data[i])
            }  
          }       
      }          
      for (let i = 0; i < data.data.length; i++) {   
          if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null 
            if (data.data[i].ner_person[1] == this.SetPerson[2]) {
              this.chartBubleIndx2.push(data.data[i])
            } 
          }        
      }          
      this.chart[2].name = this.SetPerson[2]
      this.chart[2].amount = this.chartBubleIndx2.length
        for (let i = 0; i < data.data.length; i++) { 
        if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null   
          if (data.data[i].ner_person[0] == this.SetPerson[3]) {
            this.chartBubleIndx3.push(data.data[i])
          } 
        }        
      }          
      for (let i = 0; i < data.data.length; i++) {    
        if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null
          if (data.data[i].ner_person[1] == this.SetPerson[3]) {
            this.chartBubleIndx3.push(data.data[i])
          }  
        }       
      }          
      this.chart[3].name = this.SetPerson[3]
      this.chart[3].amount = this.chartBubleIndx3.length
        for (let i = 0; i < data.data.length; i++) {
        if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null    
          if (data.data[i].ner_person[0] == this.SetPerson[4]) {
            this.chartBubleIndx4.push(data.data[i])
          } 
        }        
      }          
      for (let i = 0; i < data.data.length; i++) {    
        if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null
          if (data.data[i].ner_person[1] == this.SetPerson[4]) {
            this.chartBubleIndx4.push(data.data[i])
          } 
        }        
      }     
      this.chart[4].name = this.SetPerson[4]     
      this.chart[4].amount = this.chartBubleIndx4.length
        for (let i = 0; i < data.data.length; i++) {    
          
          if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null
            if (data.data[i].ner_person[0] == this.SetPerson[5]) {
              this.chartBubleIndx5.push(data.data[i])
            } 
          }        
      }          
      for (let i = 0; i < data.data.length; i++) {  
        
        if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null  
          if (data.data[i].ner_person[1] == this.SetPerson[5]) {
            this.chartBubleIndx5.push(data.data[i])
          }      
        }   
      }          
// ner_person




// ======= push variable chartBubleIndxOrg  ???? =============================
// ======= push variable chartBubleIndxOrg  ???? =============================
// ======= push variable chartBubleIndxOrg  ???? =============================
// ======= push variable chartBubleIndxOrg  ???? =============================
// ======= push variable chartBubleIndxOrg  ???? =============================
// ======= push variable chartBubleIndxOrg ???? =============================
// ======= push variable chartBubleIndxOrg ???? =============================
// ======= push variable chartBubleIndxOrg ???? =============================
// ======= push variable chartBubleIndxOrg ???? =============================

// ner_organization
// ========================= set organization 
      this.chart[5].name = this.SetPerson[5]
      this.chart[5].amount = this.chartBubleIndx5.length   
      // chart buble organisasi


        const organisasi = [] 
        const organisasi2 = []
          this.kontenBerita.forEach((element) => {
            
            if(element["ner_organization"] != '' && element["ner_organization"] != null){
              organisasi.push(element["ner_organization"]);
              organisasi2.push(element["ner_organization"]);
            }
          });
          const SetttOrganisasi = []
      for (let i = 0; i < organisasi.length; i++) {       
          SetttOrganisasi.push(organisasi[i].at(-0))
      }
        const Setorganisasi = [...new Set(SetttOrganisasi)]        
          // this.kontenBerita.forEach((element) => {
          //   if(element["ner_organization"] != '' && element["ner_organization"] != null){
          //     organisasi2.push(element["ner_organization"]);
          //   }
          // });
          const SetttOrganisasi2 = []
      for (let i = 0; i < organisasi2.length; i++) {       
          SetttOrganisasi2.push(organisasi2[i].at(-1))
      }
        const Setorganisasi2 = [...new Set(SetttOrganisasi2)]            
        const Setorganisasi3 = Setorganisasi.concat(Setorganisasi2)
        this.SetOrganisasi =  [...new Set(Setorganisasi3)]
// ================= end set organization 


        for (let i = 0; i < data.data.length; i++) { 
          // alert(data.data[i].ner_organization +'  ============  '+ i);
     
          if (data.data[i].ner_organization != null) { //tambahan karna data ada yang null

            if (data.data[i].ner_organization[0] == this.SetOrganisasi[0]) {
              this.chartBubleIndxOrg0.push(data.data[i])
            }    
          }
      }          
      // for (let i = 0; i < data.data.length; i++) {    
      //     if (data.data[i].ner_organization[1] == this.SetOrganisasi[0]) {
      //       this.chartBubleIndxOrg0.push(data.data[i])
      //     }         
      // } 
      this.chartOrganisasi[0].name = this.SetOrganisasi[0]
      this.chartOrganisasi[0].amount = this.chartBubleIndxOrg0.length
        for (let i = 0; i < data.data.length; i++) {  
          
          if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null
            if (data.data[i].ner_organization[0] == this.SetOrganisasi[1]) {
              this.chartBubleIndxOrg1.push(data.data[i])
            }         
          }         
      }          
      for (let i = 0; i < data.data.length; i++) {    
          if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null
            if (data.data[i].ner_organization[1] == this.SetOrganisasi[1]) {
              this.chartBubleIndxOrg1.push(data.data[i])
            }         
          }
      }          
      this.chartOrganisasi[1].name = this.SetOrganisasi[1]
      this.chartOrganisasi[1].amount = this.chartBubleIndxOrg1.length
        for (let i = 0; i < data.data.length; i++) {   
          
          if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null 
            if (data.data[i].ner_organization[0] == this.SetOrganisasi[2]) {
              this.chartBubleIndxOrg2.push(data.data[i])
            }      
          }   
      }          
      for (let i = 0; i < data.data.length; i++) {   
          if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null 
            if (data.data[i].ner_organization[1] == this.SetOrganisasi[2]) {
              this.chartBubleIndxOrg2.push(data.data[i])
            }         
          }
      }          
      this.chartOrganisasi[2].name = this.SetOrganisasi[2]
      this.chartOrganisasi[2].amount = this.chartBubleIndxOrg2.length
        for (let i = 0; i < data.data.length; i++) {    
          if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null
            if (data.data[i].ner_organization[0] == this.SetOrganisasi[3]) {
              this.chartBubleIndxOrg3.push(data.data[i])
            }         
          }
      }          
      for (let i = 0; i < data.data.length; i++) {  
          if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null  
            if (data.data[i].ner_organization[1] == this.SetOrganisasi[3]) {
              this.chartBubleIndxOrg3.push(data.data[i])
            }        
          } 
      }          
      this.chartOrganisasi[3].name = this.SetOrganisasi[3]
      this.chartOrganisasi[3].amount = this.chartBubleIndxOrg3.length
      for (let i = 0; i < data.data.length; i++) {   
          if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null
            if (data.data[i].ner_organization[0] == this.SetOrganisasi[4]) {
              this.chartBubleIndxOrg4.push(data.data[i])
            }       
          }  
      }          
      for (let i = 0; i < data.data.length; i++) {   
          if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null 
            if (data.data[i].ner_organization[1] == this.SetOrganisasi[4]) {
              this.chartBubleIndxOrg4.push(data.data[i])
            }         
          }
      } 


      this.chartOrganisasi[4].name = this.SetOrganisasi[4]
      this.chartOrganisasi[4].amount = this.chartBubleIndxOrg4.length
      for (let i = 0; i < data.data.length; i++) {   
          if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null
            if (data.data[i].ner_organization[0] == this.SetOrganisasi[5]) {
              this.chartBubleIndxOrg5.push(data.data[i])
            }       
          }  
      }          
      for (let i = 0; i < data.data.length; i++) {    
        
          if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null
            if (data.data[i].ner_organization[1] == this.SetOrganisasi[5]) {
              this.chartBubleIndxOrg5.push(data.data[i])
            }     
          }    
      } 
      this.chartOrganisasi[5].name = this.SetOrganisasi[5]
      this.chartOrganisasi[5].amount = this.chartBubleIndxOrg5.length
      // end chart bar organisasi            
// ==================================
// end bubble alll
// ==================================
















///xxxxxxxxxxxxxxxxxxxx
///xxxxxxxxxxxxxxxxxxxx
///xxxxxxxxxxxxxxxxxxxx
///xxxxxxxxxxxxxxxxxxxx load awal dan identifikasi array
///xxxxxxxxxxxxxxxxxxxx 
///xxxxxxxxxxxxxxxxxxxx
///xxxxxxxxxxxxxxxxxxxx

          
// ==================================
// start chart bELUM
// ==================================   
      // topik 0
      for (let i = 0; i < this.topik0.length; i++) {       
          if (this.topik0[i].dateid == this.Settanggal[0]) {
              this.tanggalIndx0Topik0.push(data.data[i]);
          }
      }     
       for (let i = 0; i < this.topik0.length; i++) {       
          if (this.topik0[i].dateid == this.Settanggal[1]) {
              this.tanggalIndx1Topik0.push(data.data[i]);
          }
      }
       for (let i = 0; i < this.topik0.length; i++) {       
          if (this.topik0[i].dateid == this.Settanggal[2]) {
              this.tanggalIndx2Topik0.push(data.data[i]);
          }
      }
       for (let i = 0; i < this.topik0.length; i++) {       
          if (this.topik0[i].dateid == this.Settanggal[3]) {
              this.tanggalIndx3Topik0.push(data.data[i]);
          }
      }
       for (let i = 0; i < this.topik0.length; i++) {       
          if (this.topik0[i].dateid == this.Settanggal[4]) {
              this.tanggalIndx4Topik0.push(data.data[i]);
          }
      }
       for (let i = 0; i < this.topik0.length; i++) {       
          if (this.topik0[i].dateid == this.Settanggal[5]) {
              this.tanggalIndx5Topik0.push(data.data[i]);
          }
      }
       for (let i = 0; i < this.topik0.length; i++) {       
          if (this.topik0[i].dateid == this.Settanggal[6]) {
              this.tanggalIndx6Topik0.push(data.data[i]);
          }
      }
       for (let i = 0; i < this.topik0.length; i++) {       
          if (this.topik0[i].dateid == this.Settanggal[7]) {
              this.tanggalIndx7Topik0.push(data.data[i]);
          }
      }
        for (let i = 0; i < this.topik0.length; i++) {       
          if (data.data[i].sentiment == "Positive") {
             this.kontenBeritaPositiveTopik0.push(data.data[i]);
          }         
      }  
        for (let i = 0; i < this.topik0.length; i++) {       
          if (data.data[i].sentiment == "Negative") {
             this.kontenBeritaNegativeTopik0.push(data.data[i]);
          }         
      }  
         for (let i = 0; i < this.topik0.length; i++) {       
          if (data.data[i].sentiment == "Netral") {
             this.kontenBeritaNetralTopik0.push(data.data[i]);
          }         
      }  
      // ner_organization
      // chart buble person
      for (let i = 0; i < this.topik0.length; i++) {   
        
          if (this.topik0[i].ner_person != null) {  //tambahan karna data ada yang null    
            if (this.topik0[i].ner_person[0] == this.SetPerson[0]) {
              this.valueBubleIndx0Topik0.push(this.topik0[i]);
            }      
          }   
      }  

      for (let i = 0; i < this.topik0.length; i++) {   
        if (this.topik0[i].ner_person != null) {  //tambahan karna data ada yang null     
          if (this.topik0[i].ner_person[1] == this.SetPerson[0]) {
             this.valueBubleIndx0Topik0.push(this.topik0[i]);
          }  
        }       
      }  
      for (let i = 0; i < this.topik0.length; i++) {  
        
        if (this.topik0[i].ner_person != null) {  //tambahan karna data ada yang null      
          if (this.topik0[i].ner_person[0] == this.SetPerson[1]) {
             this.valueBubleIndx1Topik0.push(this.topik0[i]);
          } 
        }        
      }  
      for (let i = 0; i < this.topik0.length; i++) { 
        if (this.topik0[i].ner_person != null) {  //tambahan karna data ada yang null       
          if (this.topik0[i].ner_person[1] == this.SetPerson[1]) {
             this.valueBubleIndx1Topik0.push(this.topik0[i]);
          } 
        }        
      }    
      for (let i = 0; i < this.topik0.length; i++) {    
        if (this.topik0[i].ner_person != null) {  //tambahan karna data ada yang null    
          if (this.topik0[i].ner_person[0] == this.SetPerson[2]) {
             this.valueBubleIndx2Topik0.push(this.topik0[i]);
          } 
        }        
      }  
      for (let i = 0; i < this.topik0.length; i++) {   
        if (this.topik0[i].ner_person != null) {  //tambahan karna data ada yang null     
          if (this.topik0[i].ner_person[1] == this.SetPerson[2]) {
             this.valueBubleIndx2Topik0.push(this.topik0[i]);
          }
        }         
      }      
      for (let i = 0; i < this.topik0.length; i++) {
        if (this.topik0[i].ner_person != null) {  //tambahan karna data ada yang null        
          if (this.topik0[i].ner_person[0] == this.SetPerson[3]) {
             this.valueBubleIndx3Topik0.push(this.topik0[i]);
          } 
        }        
      }  
      for (let i = 0; i < this.topik0.length; i++) {     
        if (this.topik0[i].ner_person != null) {  //tambahan karna data ada yang null   
          if (this.topik0[i].ner_person[1] == this.SetPerson[3]) {
             this.valueBubleIndx3Topik0.push(this.topik0[i]);
          } 
        }        
      }  
      for (let i = 0; i < this.topik0.length; i++) {
        if (this.topik0[i].ner_person != null) {  //tambahan karna data ada yang null        
          if (this.topik0[i].ner_person[0] == this.SetPerson[4]) {
             this.valueBubleIndx4Topik0.push(this.topik0[i]);
          } 
        }        
      }  
      for (let i = 0; i < this.topik0.length; i++) {  
        if (this.topik0[i].ner_person != null) {  //tambahan karna data ada yang null      
          if (this.topik0[i].ner_person[1] == this.SetPerson[4]) {
             this.valueBubleIndx4Topik0.push(this.topik0[i]);
          }  
        }       
      }   
      for (let i = 0; i < this.topik0.length; i++) {
        if (this.topik0[i].ner_person != null) {  //tambahan karna data ada yang null        
          if (this.topik0[i].ner_person[0] == this.SetPerson[5]) {
             this.valueBubleIndx5Topik0.push(this.topik0[i]);
          }  
        }       
      }  
      for (let i = 0; i < this.topik0.length; i++) {  
        if (this.topik0[i].ner_person != null) {  //tambahan karna data ada yang null      
          if (this.topik0[i].ner_person[1] == this.SetPerson[5]) {
             this.valueBubleIndx5Topik0.push(this.topik0[i]);
          } 
        }        
      }      
      // end chart person   
      
      

      // chart buble organisasi    
      for (let i = 0; i < this.topik0.length; i++) {   
        
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null     
          if (data.data[i].ner_organization[0] == this.SetOrganisasi[0]) {
             this.valueBubleIndx0OrgTopik0.push(data.data[i]);
          } 
        }        
      }  
      for (let i = 0; i < this.topik0.length; i++) {   
        
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null     
          if (data.data[i].ner_organization[1] == this.SetOrganisasi[0]) {
             this.valueBubleIndx0OrgTopik0.push(data.data[i]);
          }         
        }
      }  
      for (let i = 0; i < this.topik0.length; i++) { 
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null       
          if (data.data[i].ner_organization[0] == this.SetOrganisasi[1]) {
             this.valueBubleIndx1OrgTopik0.push(data.data[i]);
          }   
        }      
      }  
      for (let i = 0; i < this.topik0.length; i++) {   
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null     
          if (data.data[i].ner_organization[1] == this.SetOrganisasi[1]) {
             this.valueBubleIndx1OrgTopik0.push(data.data[i]);
          }     
        }    
      }    
      for (let i = 0; i < this.topik0.length; i++) {   
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null     
          if (data.data[i].ner_organization[0] == this.SetOrganisasi[2]) {
             this.valueBubleIndx2OrgTopik0.push(data.data[i]);
          }   
        }      
      }  
      for (let i = 0; i < this.topik0.length; i++) {     
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null   
          if (data.data[i].ner_organization[1] == this.SetOrganisasi[2]) {
             this.valueBubleIndx2OrgTopik0.push(data.data[i]);
          }         
        }
      }      
      for (let i = 0; i < this.topik0.length; i++) { 
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null       
          if (data.data[i].ner_organization[0] == this.SetOrganisasi[3]) {
             this.valueBubleIndx3OrgTopik0.push(data.data[i]);
          }    
        }     
      }  
      for (let i = 0; i < this.topik0.length; i++) {  
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null      
          if (data.data[i].ner_organization[1] == this.SetOrganisasi[3]) {
             this.valueBubleIndx3OrgTopik0.push(data.data[i]);
          }     
        }    
      }  
      for (let i = 0; i < this.topik0.length; i++) {   
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null     
          if (data.data[i].ner_organization[0] == this.SetOrganisasi[4]) {
             this.valueBubleIndx4OrgTopik0.push(data.data[i]);
          }         
        }
      }  
      for (let i = 0; i < this.topik0.length; i++) {  
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null      
          if (data.data[i].ner_organization[1] == this.SetOrganisasi[4]) {
             this.valueBubleIndx4OrgTopik0.push(data.data[i]);
          }    
        }     
      }   
      for (let i = 0; i < this.topik0.length; i++) {    
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null    
          if (data.data[i].ner_organization[0] == this.SetOrganisasi[5]) {
             this.valueBubleIndx5OrgTopik0.push(data.data[i]);
          }      
        }   
      }  
      for (let i = 0; i < this.topik0.length; i++) {  
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null      
          if (data.data[i].ner_organization[1] == this.SetOrganisasi[5]) {
             this.valueBubleIndx5OrgTopik0.push(data.data[i]);
          }       
        }  
      }      
// end chart organisasi 


































     

      for (let i = 0; i < this.topik0.length; i++) {  
          if(this.topik0[i].source == "berita"){
            // if (this.topik0[i].domain == 'kapanlagi.com') {
                this.mediaTopik0OnlineNewsShare.push(this.topik0[i]);
            // }
          }
      }
       for (let i = 0; i < this.topik0.length; i++) {       
          if(this.topik0[i].source == "berita"){
              this.mediaBeritaTopik0.push(this.topik0[i])
              }          
          }
      for (let i = 0; i < this.topik0.length; i++) {       
          if(this.topik0[i].source == "twitter"){
            this.mediaTwetTopik0.push(this.topik0[i])
          }          
      }
      for (let i = 0; i < this.topik0.length; i++) {       
          if(this.topik0[i].source == "youtube"){
              this.mediaYtTopik0.push(this.topik0[i])
          }          
      } 

      // end topik 0
      // topik 1  
      for (let i = 0; i < this.topik1.length; i++) {       
          if (this.topik1[i].dateid == this.Settanggal[0]) {
              this.tanggalIndx0Topik1.push(data.data[i]);
          }
      }    
       for (let i = 0; i < this.topik1.length; i++) {       
          if (this.topik1[i].dateid == this.Settanggal[1]) {
              this.tanggalIndx1Topik1.push(data.data[i]);
          }
      }
       for (let i = 0; i < this.topik1.length; i++) {       
          if (this.topik1[i].dateid == this.Settanggal[2]) {
              this.tanggalIndx2Topik1.push(data.data[i]);
          }
      }
       for (let i = 0; i < this.topik1.length; i++) {       
          if (this.topik1[i].dateid == this.Settanggal[3]) {
              this.tanggalIndx3Topik1.push(data.data[i]);
          }
      }
       for (let i = 0; i < this.topik1.length; i++) {       
          if (this.topik1[i].dateid == this.Settanggal[4]) {
              this.tanggalIndx4Topik1.push(data.data[i]);
          }
      }
       for (let i = 0; i < this.topik1.length; i++) {       
          if (this.topik1[i].dateid == this.Settanggal[5]) {
              this.tanggalIndx5Topik1.push(data.data[i]);
          }
      }
       for (let i = 0; i < this.topik1.length; i++) {       
          if (this.topik1[i].dateid == this.Settanggal[6]) {
              this.tanggalIndx6Topik1.push(data.data[i]);
          }
      }
       for (let i = 0; i < this.topik1.length; i++) {       
          if (this.topik1[i].dateid == this.Settanggal[7]) {
              this.tanggalIndx7Topik1.push(data.data[i]);
          }
      }     
      for (let i = 0; i < this.topik1.length; i++) {       
          if (data.data[i].sentiment == "Positive") {
             this.kontenBeritaPositiveTopik1.push(data.data[i]);
          }         
      }  
        for (let i = 0; i < this.topik1.length; i++) {       
          if (data.data[i].sentiment == "Negative") {
             this.kontenBeritaNegativeTopik1.push(data.data[i]);
          }         
      }  
         for (let i = 0; i < this.topik1.length; i++) {       
          if (data.data[i].sentiment == "Netral") {
             this.kontenBeritaNetralTopik1.push(data.data[i]);
          }         
      }  
      // chart buble person
      for (let i = 0; i < this.topik1.length; i++) {       
          if (data.data[i].ner_person[0] == this.SetPerson[0]) {
             this.valueBubleIndx0Topik1.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik1.length; i++) {       
          if (data.data[i].ner_person[1] == this.SetPerson[0]) {
             this.valueBubleIndx0Topik1.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik1.length; i++) {       
          if (data.data[i].ner_person[0] == this.SetPerson[1]) {
             this.valueBubleIndx1Topik1.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik1.length; i++) {       
          if (data.data[i].ner_person[1] == this.SetPerson[1]) {
             this.valueBubleIndx1Topik1.push(data.data[i]);
          }         
      }    
      for (let i = 0; i < this.topik1.length; i++) {       
          if (data.data[i].ner_person[0] == this.SetPerson[2]) {
             this.valueBubleIndx2Topik1.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik1.length; i++) {       
          if (data.data[i].ner_person[1] == this.SetPerson[2]) {
             this.valueBubleIndx2Topik1.push(data.data[i]);
          }         
      }      
      for (let i = 0; i < this.topik1.length; i++) {       
          if (data.data[i].ner_person[0] == this.SetPerson[3]) {
             this.valueBubleIndx3Topik1.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik1.length; i++) {       
          if (data.data[i].ner_person[1] == this.SetPerson[3]) {
             this.valueBubleIndx3Topik1.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik1.length; i++) {       
          if (data.data[i].ner_person[0] == this.SetPerson[4]) {
             this.valueBubleIndx4Topik1.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik1.length; i++) {       
          if (data.data[i].ner_person[1] == this.SetPerson[4]) {
             this.valueBubleIndx4Topik1.push(data.data[i]);
          }         
      }   
      for (let i = 0; i < this.topik1.length; i++) {       
          if (data.data[i].ner_person[0] == this.SetPerson[5]) {
             this.valueBubleIndx5Topik1.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik1.length; i++) {       
          if (data.data[i].ner_person[1] == this.SetPerson[5]) {
             this.valueBubleIndx5Topik1.push(data.data[i]);
          }         
      }      
      // end chart person      
      // chart buble organisasi    
      for (let i = 0; i < this.topik1.length; i++) {       
          if (data.data[i].ner_organization[0] == this.SetOrganisasi[0]) {
             this.valueBubleIndx0OrgTopik1.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik1.length; i++) {       
          if (data.data[i].ner_organization[1] == this.SetOrganisasi[0]) {
             this.valueBubleIndx0OrgTopik1.push(data.data[i]);
          }        
      }  
      for (let i = 0; i < this.topik1.length; i++) {       
          if (data.data[i].ner_organization[0] == this.SetOrganisasi[1]) {
             this.valueBubleIndx1OrgTopik1.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik1.length; i++) {       
          if (data.data[i].ner_organization[1] == this.SetOrganisasi[1]) {
             this.valueBubleIndx1OrgTopik1.push(data.data[i]);
          }         
      }    
      for (let i = 0; i < this.topik1.length; i++) {       
          if (data.data[i].ner_organization[0] == this.SetOrganisasi[2]) {
             this.valueBubleIndx2OrgTopik1.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik1.length; i++) {       
          if (data.data[i].ner_organization[1] == this.SetOrganisasi[2]) {
             this.valueBubleIndx2OrgTopik1.push(data.data[i]);
          }         
      }      
      for (let i = 0; i < this.topik1.length; i++) {       
          if (data.data[i].ner_organization[0] == this.SetOrganisasi[3]) {
             this.valueBubleIndx3OrgTopik1.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik1.length; i++) {       
          if (data.data[i].ner_organization[1] == this.SetOrganisasi[3]) {
             this.valueBubleIndx3OrgTopik1.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik1.length; i++) {       
          if (data.data[i].ner_organization[0] == this.SetOrganisasi[4]) {
             this.valueBubleIndx4OrgTopik1.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik1.length; i++) {       
          if (data.data[i].ner_organization[1] == this.SetOrganisasi[4]) {
             this.valueBubleIndx4OrgTopik1.push(data.data[i]);
          }         
      }   
      for (let i = 0; i < this.topik1.length; i++) {       
          if (data.data[i].ner_organization[0] == this.SetOrganisasi[5]) {
             this.valueBubleIndx5OrgTopik1.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik1.length; i++) {       
          if (data.data[i].ner_organization[1] == this.SetOrganisasi[5]) {
             this.valueBubleIndx5OrgTopik1.push(data.data[i]);
          }         
      }      
      // end chart organisasi 
      for (let i = 0; i < this.topik1.length; i++) {  
          if(this.topik1[i].source == "berita"){
            // if (this.topik1[i].domain == 'kapanlagi.com') {
                this.mediaTopik1OnlineNewsShare.push(this.topik1[i]);
            // }
          }
      }
       for (let i = 0; i < this.topik1.length; i++) {       
          if(this.topik1[i].source == "berita"){
              this.mediaBeritaTopik1.push(this.topik1[i])
              }          
          }
      for (let i = 0; i < this.topik1.length; i++) {       
          if(this.topik1[i].source == "twitter"){
            this.mediaTwetTopik1.push(this.topik1[i])
          }          
      }
      for (let i = 0; i < this.topik1.length; i++) {       
          if(this.topik1[i].source == "youtube"){
            this.mediaYtTopik1.push(this.topik1[i])
        }          
      }
      // end topik 1     
      // topik 2
      for (let i = 0; i < this.topik2.length; i++) {       
          if (this.topik2[i].dateid == this.Settanggal[0]) {
              this.tanggalIndx0Topik2.push(data.data[i]);
          }
      }    
       for (let i = 0; i < this.topik2.length; i++) {       
          if (this.topik2[i].dateid == this.Settanggal[1]) {
              this.tanggalIndx1Topik2.push(data.data[i]);
          }
      }
       for (let i = 0; i < this.topik2.length; i++) {       
          if (this.topik2[i].dateid == this.Settanggal[2]) {
              this.tanggalIndx2Topik2.push(data.data[i]);
          }
      }
       for (let i = 0; i < this.topik2.length; i++) {       
          if (this.topik2[i].dateid == this.Settanggal[3]) {
              this.tanggalIndx3Topik2.push(data.data[i]);
          }
      }
       for (let i = 0; i < this.topik2.length; i++) {       
          if (this.topik2[i].dateid == this.Settanggal[4]) {
              this.tanggalIndx4Topik2.push(data.data[i]);
          }
      }
       for (let i = 0; i < this.topik2.length; i++) {       
          if (this.topik2[i].dateid == this.Settanggal[5]) {
              this.tanggalIndx5Topik2.push(data.data[i]);
          }
      }
       for (let i = 0; i < this.topik2.length; i++) {       
          if (this.topik2[i].dateid == this.Settanggal[6]) {
              this.tanggalIndx6Topik2.push(data.data[i]);
          }
      }
       for (let i = 0; i < this.topik2.length; i++) {       
          if (this.topik2[i].dateid == this.Settanggal[7]) {
              this.tanggalIndx7Topik2.push(data.data[i]);
          }
      }  
        for (let i = 0; i < this.topik2.length; i++) {       
          if (data.data[i].sentiment == "Positive") {
             this.kontenBeritaPositiveTopik2.push(data.data[i]);
          }         
      }  
        for (let i = 0; i < this.topik2.length; i++) {       
          if (data.data[i].sentiment == "Negative") {
             this.kontenBeritaNegativeTopik2.push(data.data[i]);
          }         
      }  
         for (let i = 0; i < this.topik2.length; i++) {       
          if (data.data[i].sentiment == "Netral") {
             this.kontenBeritaNetralTopik2.push(data.data[i]);
          }         
      }  
      // chart buble person
      for (let i = 0; i < this.topik2.length; i++) {       
          if (data.data[i].ner_person[0] == this.SetPerson[0]) {
             this.valueBubleIndx0Topik2.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik2.length; i++) {       
          if (data.data[i].ner_person[1] == this.SetPerson[0]) {
             this.valueBubleIndx0Topik2.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik2.length; i++) {       
          if (data.data[i].ner_person[0] == this.SetPerson[1]) {
             this.valueBubleIndx1Topik2.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik2.length; i++) {       
          if (data.data[i].ner_person[1] == this.SetPerson[1]) {
             this.valueBubleIndx1Topik2.push(data.data[i]);
          }         
      }    
      for (let i = 0; i < this.topik2.length; i++) {       
          if (data.data[i].ner_person[0] == this.SetPerson[2]) {
             this.valueBubleIndx2Topik2.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik2.length; i++) {       
          if (data.data[i].ner_person[1] == this.SetPerson[2]) {
             this.valueBubleIndx2Topik2.push(data.data[i]);
          }         
      }      
      for (let i = 0; i < this.topik2.length; i++) {       
          if (data.data[i].ner_person[0] == this.SetPerson[3]) {
             this.valueBubleIndx3Topik2.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik2.length; i++) {       
          if (data.data[i].ner_person[1] == this.SetPerson[3]) {
             this.valueBubleIndx3Topik2.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik2.length; i++) {       
          if (data.data[i].ner_person[0] == this.SetPerson[4]) {
             this.valueBubleIndx4Topik2.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik2.length; i++) {       
          if (data.data[i].ner_person[1] == this.SetPerson[4]) {
             this.valueBubleIndx4Topik2.push(data.data[i]);
          }         
      }   
      for (let i = 0; i < this.topik2.length; i++) {       
          if (data.data[i].ner_person[0] == this.SetPerson[5]) {
             this.valueBubleIndx5Topik2.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik2.length; i++) {       
          if (data.data[i].ner_person[1] == this.SetPerson[5]) {
             this.valueBubleIndx5Topik2.push(data.data[i]);
          }         
      }      
      // end chart person      
      // chart buble organisasi    
      for (let i = 0; i < this.topik2.length; i++) {       
          if (data.data[i].ner_organization[0] == this.SetOrganisasi[0]) {
             this.valueBubleIndx0OrgTopik2.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik2.length; i++) {       
          if (data.data[i].ner_organization[1] == this.SetOrganisasi[0]) {
             this.valueBubleIndx0OrgTopik2.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik2.length; i++) {       
          if (data.data[i].ner_organization[0] == this.SetOrganisasi[1]) {
             this.valueBubleIndx1OrgTopik2.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik2.length; i++) {       
          if (data.data[i].ner_organization[1] == this.SetOrganisasi[1]) {
             this.valueBubleIndx1OrgTopik2.push(data.data[i]);
          }         
      }    
      for (let i = 0; i < this.topik2.length; i++) {       
          if (data.data[i].ner_organization[0] == this.SetOrganisasi[2]) {
             this.valueBubleIndx2OrgTopik2.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik2.length; i++) {       
          if (data.data[i].ner_organization[1] == this.SetOrganisasi[2]) {
             this.valueBubleIndx2OrgTopik2.push(data.data[i]);
          }         
      }      
      for (let i = 0; i < this.topik2.length; i++) {       
          if (data.data[i].ner_organization[0] == this.SetOrganisasi[3]) {
             this.valueBubleIndx3OrgTopik2.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik2.length; i++) {       
          if (data.data[i].ner_organization[1] == this.SetOrganisasi[3]) {
             this.valueBubleIndx3OrgTopik2.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik2.length; i++) {       
          if (data.data[i].ner_organization[0] == this.SetOrganisasi[4]) {
             this.valueBubleIndx4OrgTopik2.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik2.length; i++) {       
          if (data.data[i].ner_organization[1] == this.SetOrganisasi[4]) {
             this.valueBubleIndx4OrgTopik2.push(data.data[i]);
          }         
      }   
      for (let i = 0; i < this.topik2.length; i++) {       
          if (data.data[i].ner_organization[0] == this.SetOrganisasi[5]) {
             this.valueBubleIndx5OrgTopik2.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik2.length; i++) {       
          if (data.data[i].ner_organization[1] == this.Settanggal[5]) {
             this.valueBubleIndx5OrgTopik2.push(data.data[i]);
          }         
      }      
      // end chart organisasi      
      for (let i = 0; i < this.topik2.length; i++) {  
          if(this.topik2[i].source == "berita"){
            // if (this.topik2[i].domain == 'kapanlagi.com') {
              this.mediaTopik2OnlineNewsShare.push(this.topik2[i]);
            // }
          }
      }
       for (let i = 0; i < this.topik2.length; i++) {       
          if(this.topik2[i].source == "berita"){
              this.mediaBeritaTopik2.push(this.topik2[i])
            }          
          }
      for (let i = 0; i < this.topik2.length; i++) {       
          if(this.topik2[i].source == "twitter"){
              this.mediaTwetTopik2.push(this.topik2[i])
            }          
          }
      for (let i = 0; i < this.topik2.length; i++) {       
          if(this.topik2[i].source == "youtube"){
            this.mediaYtTopik2.push(this.topik2[i])
          }          
      }
      // end topik 2       
      // topik index 3
      for (let i = 0; i < this.topik3.length; i++) {       
          if (this.topik3[i].dateid == this.Settanggal[0]) {
              this.tanggalIndx0Topik3.push(data.data[i]);
          }
      }    
       for (let i = 0; i < this.topik3.length; i++) {       
          if (this.topik3[i].dateid == this.Settanggal[1]) {
              this.tanggalIndx1Topik3.push(data.data[i]);
          }
      }
       for (let i = 0; i < this.topik3.length; i++) {       
          if (this.topik3[i].dateid == this.Settanggal[2]) {
              this.tanggalIndx2Topik3.push(data.data[i]);
          }
      }
       for (let i = 0; i < this.topik3.length; i++) {       
          if (this.topik3[i].dateid == this.Settanggal[3]) {
              this.tanggalIndx3Topik3.push(data.data[i]);
          }
      }
       for (let i = 0; i < this.topik3.length; i++) {       
          if (this.topik3[i].dateid == this.Settanggal[4]) {
              this.tanggalIndx4Topik3.push(data.data[i]);
          }
      }
       for (let i = 0; i < this.topik3.length; i++) {       
          if (this.topik3[i].dateid == this.Settanggal[5]) {
              this.tanggalIndx5Topik3.push(data.data[i]);
          }
      }
       for (let i = 0; i < this.topik3.length; i++) {       
          if (this.topik3[i].dateid == this.Settanggal[6]) {
              this.tanggalIndx6Topik3.push(data.data[i]);
          }
      }
       for (let i = 0; i < this.topik3.length; i++) {       
          if (this.topik3[i].dateid == this.Settanggal[7]) {
              this.tanggalIndx7Topik3.push(data.data[i]);
          }
      }    
         for (let i = 0; i < this.topik3.length; i++) {       
          if (data.data[i].sentiment == "Positive") {
             this.kontenBeritaPositiveTopik3.push(data.data[i]);
          }         
      }  
        for (let i = 0; i < this.topik3.length; i++) {       
          if (data.data[i].sentiment == "Negative") {
             this.kontenBeritaNegativeTopik3.push(data.data[i]);
          }         
      }  
         for (let i = 0; i < this.topik3.length; i++) {       
          if (data.data[i].sentiment == "Netral") {
             this.kontenBeritaNetralTopik3.push(data.data[i]);
          }         
      }  
      // chart buble person
      for (let i = 0; i < this.topik3.length; i++) {       
          if (data.data[i].ner_person[0] == this.SetPerson[0]) {
             this.valueBubleIndx0Topik3.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik3.length; i++) {       
          if (data.data[i].ner_person[1] == this.SetPerson[0]) {
             this.valueBubleIndx0Topik3.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik3.length; i++) {       
          if (data.data[i].ner_person[0] == this.SetPerson[1]) {
             this.valueBubleIndx1Topik3.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik3.length; i++) {       
          if (data.data[i].ner_person[1] == this.SetPerson[1]) {
             this.valueBubleIndx1Topik3.push(data.data[i]);
          }         
      }    
      for (let i = 0; i < this.topik3.length; i++) {       
          if (data.data[i].ner_person[0] == this.SetPerson[2]) {
             this.valueBubleIndx2Topik3.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik3.length; i++) {       
          if (data.data[i].ner_person[1] == this.SetPerson[2]) {
             this.valueBubleIndx2Topik3.push(data.data[i]);
          }         
      }      
      for (let i = 0; i < this.topik3.length; i++) {       
          if (data.data[i].ner_person[0] == this.SetPerson[3]) {
             this.valueBubleIndx3Topik3.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik3.length; i++) {       
          if (data.data[i].ner_person[1] == this.SetPerson[3]) {
             this.valueBubleIndx3Topik3.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik3.length; i++) {       
          if (data.data[i].ner_person[0] == this.SetPerson[4]) {
             this.valueBubleIndx4Topik3.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik3.length; i++) {       
          if (data.data[i].ner_person[1] == this.SetPerson[4]) {
             this.valueBubleIndx4Topik3.push(data.data[i]);
          }         
      }   
      for (let i = 0; i < this.topik3.length; i++) {       
          if (data.data[i].ner_person[0] == this.SetPerson[5]) {
             this.valueBubleIndx5Topik3.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik3.length; i++) {       
          if (data.data[i].ner_person[1] == this.SetPerson[5]) {
             this.valueBubleIndx5Topik3.push(data.data[i]);
          }         
      }      
      // end chart person      
      // chart buble organisasi    
      for (let i = 0; i < this.topik3.length; i++) {       
          if (data.data[i].ner_organization[0] == this.SetOrganisasi[0]) {
             this.valueBubleIndx0OrgTopik3.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik3.length; i++) {       
          if (data.data[i].ner_organization[1] == this.SetOrganisasi[0]) {
             this.valueBubleIndx0OrgTopik3.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik3.length; i++) {       
          if (data.data[i].ner_organization[0] == this.SetOrganisasi[1]) {
             this.valueBubleIndx1OrgTopik3.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik3.length; i++) {       
          if (data.data[i].ner_organization[1] == this.SetOrganisasi[1]) {
             this.valueBubleIndx1OrgTopik3.push(data.data[i]);
          }         
      }    
      for (let i = 0; i < this.topik3.length; i++) {       
          if (data.data[i].ner_organization[0] == this.SetOrganisasi[2]) {
             this.valueBubleIndx2OrgTopik3.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik3.length; i++) {       
          if (data.data[i].ner_organization[1] == this.SetOrganisasi[2]) {
             this.valueBubleIndx2OrgTopik3.push(data.data[i]);
          }         
      }      
      for (let i = 0; i < this.topik3.length; i++) {       
          if (data.data[i].ner_organization[0] == this.SetOrganisasi[3]) {
             this.valueBubleIndx3OrgTopik3.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik3.length; i++) {       
          if (data.data[i].ner_organization[1] == this.SetOrganisasi[3]) {
             this.valueBubleIndx3OrgTopik3.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik3.length; i++) {       
          if (data.data[i].ner_organization[0] == this.SetOrganisasi[4]) {
             this.valueBubleIndx4OrgTopik3.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik3.length; i++) {       
          if (data.data[i].ner_organization[1] == this.SetOrganisasi[4]) {
             this.valueBubleIndx4OrgTopik3.push(data.data[i]);
          }         
      }   
      for (let i = 0; i < this.topik3.length; i++) {       
          if (data.data[i].ner_organization[0] == this.SetOrganisasi[5]) {
             this.valueBubleIndx5OrgTopik3.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.topik3.length; i++) {       
          if (data.data[i].ner_organization[1] == this.SetOrganisasi[5]) {
             this.valueBubleIndx5OrgTopik3.push(data.data[i]);
          }         
      }      
      // end chart organisasi      
      for (let i = 0; i < this.topik3.length; i++) {       
        if(this.topik3[i].source == "berita"){ 
          // if (this.topik3[i].domain == 'kapanlagi.com') {
              this.mediaTopik3OnlineNewsShare.push(this.topik3[i]);
          // }
          }
      }  
      for (let i = 0; i < this.topik3.length; i++) {       
        if(this.topik3[i].source == "berita"){
          this.mediaBeritaTopik3.push(this.topik3[i])
          }          
      }
      for (let i = 0; i < this.topik3.length; i++) {       
        if(this.topik3[i].source == "twitter"){
          this.mediaTwetTopik3.push(this.topik3[i])
        }          
      }
      for (let i = 0; i < this.topik3.length; i++) {       
        if(this.topik3[i].source == "youtube"){
          this.mediaYtTopik3.push(this.topik3[i])
        }          
      }
      // end topik 3
      // topik today      
       for (let i = 0; i < data.data.length; i++) {       
          if (data.data[i].dateid == this.Settanggal[7]) {
             this.today.push(data.data[i]);
          }         
      }        
      // topik today     
         for (let i = 0; i < this.today.length; i++) {       
          if (data.data[i].sentiment == "Positive") {
             this.kontenBeritaPositiveToday.push(data.data[i]);
          }         
      }  
        for (let i = 0; i < this.today.length; i++) {       
          if (data.data[i].sentiment == "Negative") {
             this.kontenBeritaNegativeToday.push(data.data[i]);
          }         
      }  
         for (let i = 0; i < this.today.length; i++) {       
          if (data.data[i].sentiment == "Netral") {
             this.kontenBeritaNetralToday.push(data.data[i]);
          }         
      }  
      // chart bubble person
      for (let i = 0; i < this.today.length; i++) {    
          if (this.today[i].ner_person[0] == this.SetPerson[0]) {
            this.chartBubleIndx0Today.push(this.today[i])
          }         
      }         
      for (let i = 0; i < this.today.length; i++) {    
          if (this.today[i].ner_person[1] == this.SetPerson[0]) {
            this.chartBubleIndx0Today.push(this.today[i])
          }         
      }      
      for (let i = 0; i < this.today.length; i++) {    
          if (this.today[i].ner_person[0] == this.SetPerson[1]) {
            this.chartBubleIndx1Today.push(this.today[i])
          }         
      }         
      for (let i = 0; i < this.today.length; i++) {    
          if (this.today[i].ner_person[1] == this.SetPerson[1]) {
            this.chartBubleIndx1Today.push(this.today[i])
          }         
      }       
      for (let i = 0; i < this.today.length; i++) {    
          if (this.today[i].ner_person[0] == this.SetPerson[2]) {
            this.chartBubleIndx2Today.push(this.today[i])
          }         
      }         
      for (let i = 0; i < this.today.length; i++) {    
          if (this.today[i].ner_person[1] == this.SetPerson[2]) {
            this.chartBubleIndx2Today.push(this.today[i])
          }         
      }    
        for (let i = 0; i < this.today.length; i++) {    
          if (this.today[i].ner_person[0] == this.SetPerson[3]) {
            this.chartBubleIndx3Today.push(this.today[i])
          }         
      }          
      for (let i = 0; i < this.today.length; i++) {    
          if (this.today[i].ner_person[1] == this.SetPerson[3]) {
            this.chartBubleIndx3Today.push(this.today[i])
          }         
      }            
        for (let i = 0; i < this.today.length; i++) {    
          if (this.today[i].ner_person[0] == this.SetPerson[4]) {
            this.chartBubleIndx4Today.push(this.today[i])
          }         
      }          
      for (let i = 0; i < this.today.length; i++) {    
          if (this.today[i].ner_person[1] == this.SetPerson[4]) {
            this.chartBubleIndx4Today.push(this.today[i])
          }         
      }             
        for (let i = 0; i < this.today.length; i++) {    
          if (this.today[i].ner_person[0] == this.SetPerson[5]) {
            this.chartBubleIndx5Today.push(this.today[i])
          }         
      }          
      for (let i = 0; i < this.today.length; i++) {    
          if (this.today[i].ner_person[1] == this.SetPerson[5]) {
            this.chartBubleIndx5Today.push(this.today[i])
          }         
      }              
      // end buble person today
      // chart buble organisasi today
      for (let i = 0; i < this.today.length; i++) {    
          if (this.today[i].ner_organization[0] == this.SetOrganisasi[0]) {
            this.chartBubleIndx0OrgToday.push(this.today[i])
          }         
      }         
      for (let i = 0; i < this.today.length; i++) {    
          if (this.today[i].ner_organization[1] == this.SetOrganisasi[0]) {
            this.chartBubleIndx0OrgToday.push(this.today[i])
          }         
      }      
      for (let i = 0; i < this.today.length; i++) {    
          if (this.today[i].ner_organization[0] == this.SetOrganisasi[1]) {
            this.chartBubleIndx1OrgToday.push(this.today[i])
          }         
      }         
      for (let i = 0; i < this.today.length; i++) {    
          if (this.today[i].ner_organization[1] == this.SetOrganisasi[1]) {
            this.chartBubleIndx1OrgToday.push(this.today[i])
          }         
      }       
      for (let i = 0; i < this.today.length; i++) {    
          if (this.today[i].ner_organization[0] == this.SetOrganisasi[2]) {
            this.chartBubleIndx2OrgToday.push(this.today[i])
          }         
      }         
      for (let i = 0; i < this.today.length; i++) {    
          if (this.today[i].ner_organization[1] == this.SetOrganisasi[2]) {
            this.chartBubleIndx2OrgToday.push(this.today[i])
          }         
      }    
        for (let i = 0; i < this.today.length; i++) {    
          if (this.today[i].ner_organization[0] == this.SetOrganisasi[3]) {
            this.chartBubleIndx3OrgToday.push(this.today[i])
          }         
      }          
      for (let i = 0; i < this.today.length; i++) {    
          if (this.today[i].ner_organization[1] == this.SetOrganisasi[3]) {
            this.chartBubleIndx3OrgToday.push(this.today[i])
          }         
      }            
        for (let i = 0; i < this.today.length; i++) {    
          if (this.today[i].ner_organization[0] == this.SetOrganisasi[4]) {
            this.chartBubleIndx4OrgToday.push(this.today[i])
          }         
      }          
      for (let i = 0; i < this.today.length; i++) {    
          if (this.today[i].ner_organization[1] == this.SetOrganisasi[4]) {
            this.chartBubleIndx4OrgToday.push(this.today[i])
          }         
      }             
        for (let i = 0; i < this.today.length; i++) {    
          if (this.today[i].ner_organization[0] == this.SetOrganisasi[5]) {
            this.chartBubleIndx5OrgToday.push(this.today[i])
          }         
      }          
      for (let i = 0; i < this.today.length; i++) {    
          if (this.today[i].ner_organization[1] == this.SetOrganisasi[5]) {
            this.chartBubleIndx5OrgToday.push(this.today[i])
          }         
      }              
      // end chart bar organisasi today
      for (let i = 0; i < this.today.length; i++) {
        if(this.today[i].source == "berita"){        
          // if (this.today[i].domain == 'kapanlagi.com') {
              this.mediaTodayOnlineNewsShare.push(this.today[i]);
            // }
          }
      }
      for (let i = 0; i < this.today.length; i++) {       
          if(this.today[i].source == "berita"){
              this.mediaBeritaToday.push(this.today[i])
            }          
        }
      for (let i = 0; i < this.today.length; i++) {       
          if(this.today[i].source == "twitter"){
              this.mediaTwetToday.push(this.today[i])
          }          
        }
      for (let i = 0; i < this.today.length; i++) {       
        if(this.today[i].source == "youtube"){
          this.mediaYtToday.push(this.today[i])
        }          
      }
      // end today
      // yesterday
      for (let i = 0; i < data.data.length; i++) {       
          if (data.data[i].dateid == this.Settanggal[6]) {
             this.yesterday.push(data.data[i]);
          }         
      } 
         for (let i = 0; i < this.yesterday.length; i++) {       
          if (data.data[i].sentiment == "Positive") {
             this.kontenBeritaPositiveYesterday.push(data.data[i]);
          }         
      }  
        for (let i = 0; i < this.yesterday.length; i++) {       
          if (data.data[i].sentiment == "Negative") {
             this.kontenBeritaNegativeYesterday.push(data.data[i]);
          }         
      }  
         for (let i = 0; i < this.yesterday.length; i++) {       
          if (data.data[i].sentiment == "Netral") {
             this.kontenBeritaNetralYesterday.push(data.data[i]);
          }         
      }       
      // chart bubble person
      for (let i = 0; i < this.yesterday.length; i++) {    
          if (this.yesterday[i].ner_person[0] == this.SetPerson[0]) {
            this.chartBubleIndx0Yesterday.push(this.yesterday[i])
          }         
      }         
      for (let i = 0; i < this.yesterday.length; i++) {    
          if (this.yesterday[i].ner_person[1] == this.SetPerson[0]) {
            this.chartBubleIndx0Yesterday.push(this.yesterday[i])
          }         
      }      
      for (let i = 0; i < this.yesterday.length; i++) {    
          if (this.yesterday[i].ner_person[0] == this.SetPerson[1]) {
            this.chartBubleIndx1Yesterday.push(this.yesterday[i])
          }         
      }         
      for (let i = 0; i < this.yesterday.length; i++) {    
          if (this.yesterday[i].ner_person[1] == this.SetPerson[1]) {
            this.chartBubleIndx1Yesterday.push(this.yesterday[i])
          }         
      }       
      for (let i = 0; i < this.yesterday.length; i++) {    
          if (this.yesterday[i].ner_person[0] == this.SetPerson[2]) {
            this.chartBubleIndx2Yesterday.push(this.yesterday[i])
          }         
      }         
      for (let i = 0; i < this.yesterday.length; i++) {    
          if (this.yesterday[i].ner_person[1] == this.SetPerson[2]) {
            this.chartBubleIndx2Yesterday.push(this.yesterday[i])
          }         
      }    
        for (let i = 0; i < this.yesterday.length; i++) {    
          if (this.yesterday[i].ner_person[0] == this.SetPerson[3]) {
            this.chartBubleIndx3Yesterday.push(this.yesterday[i])
          }         
      }          
      for (let i = 0; i < this.yesterday.length; i++) {    
          if (this.yesterday[i].ner_person[1] == this.SetPerson[3]) {
            this.chartBubleIndx3Yesterday.push(this.yesterday[i])
          }         
      }            
        for (let i = 0; i < this.yesterday.length; i++) {    
          if (this.yesterday[i].ner_person[0] == this.SetPerson[4]) {
            this.chartBubleIndx4Yesterday.push(this.yesterday[i])
          }         
      }          
      for (let i = 0; i < this.yesterday.length; i++) {    
          if (this.yesterday[i].ner_person[1] == this.SetPerson[4]) {
            this.chartBubleIndx4Yesterday.push(this.yesterday[i])
          }         
      }             
        for (let i = 0; i < this.yesterday.length; i++) {    
          if (this.yesterday[i].ner_person[0] == this.SetPerson[5]) {
            this.chartBubleIndx5Yesterday.push(this.yesterday[i])
          }         
      }          
      for (let i = 0; i < this.yesterday.length; i++) {    
          if (this.yesterday[i].ner_person[1] == this.SetPerson[5]) {
            this.chartBubleIndx5Yesterday.push(this.yesterday[i])
          }         
      }              
      // end buble person today
      // chart buble organisasi
      for (let i = 0; i < this.yesterday.length; i++) {    
          if (this.yesterday[i].ner_organization[0] == this.SetOrganisasi[0]) {
            this.chartBubleIndx0OrgYesterday.push(this.yesterday[i])
          }         
      }         
      for (let i = 0; i < this.yesterday.length; i++) {    
          if (this.yesterday[i].ner_organization[1] == this.SetOrganisasi[0]) {
            this.chartBubleIndx0OrgYesterday.push(this.yesterday[i])
          }         
      }      
      for (let i = 0; i < this.yesterday.length; i++) {    
          if (this.yesterday[i].ner_organization[0] == this.SetOrganisasi[1]) {
            this.chartBubleIndx1OrgYesterday.push(this.yesterday[i])
          }         
      }         
      for (let i = 0; i < this.yesterday.length; i++) {    
          if (this.yesterday[i].ner_organization[1] == this.SetOrganisasi[1]) {
            this.chartBubleIndx1OrgYesterday.push(this.yesterday[i])
          }         
      }       
      for (let i = 0; i < this.yesterday.length; i++) {    
          if (this.yesterday[i].ner_organization[0] == this.SetOrganisasi[2]) {
            this.chartBubleIndx2OrgYesterday.push(this.yesterday[i])
          }         
      }         
      for (let i = 0; i < this.yesterday.length; i++) {    
          if (this.yesterday[i].ner_organization[1] == this.SetOrganisasi[2]) {
            this.chartBubleIndx2OrgYesterday.push(this.yesterday[i])
          }         
      }    
        for (let i = 0; i < this.yesterday.length; i++) {    
          if (this.yesterday[i].ner_organization[0] == this.SetOrganisasi[3]) {
            this.chartBubleIndx3OrgYesterday.push(this.yesterday[i])
          }         
      }          
      for (let i = 0; i < this.yesterday.length; i++) {    
          if (this.yesterday[i].ner_organization[1] == this.SetOrganisasi[3]) {
            this.chartBubleIndx3OrgYesterday.push(this.yesterday[i])
          }         
      }            
        for (let i = 0; i < this.yesterday.length; i++) {    
          if (this.yesterday[i].ner_organization[0] == this.SetOrganisasi[4]) {
            this.chartBubleIndx4OrgYesterday.push(this.yesterday[i])
          }         
      }          
      for (let i = 0; i < this.yesterday.length; i++) {    
          if (this.yesterday[i].ner_organization[1] == this.SetOrganisasi[4]) {
            this.chartBubleIndx4OrgYesterday.push(this.yesterday[i])
          }         
      }             
        for (let i = 0; i < this.yesterday.length; i++) {    
          if (this.yesterday[i].ner_organization[0] == this.SetOrganisasi[5]) {
            this.chartBubleIndx5OrgYesterday.push(this.yesterday[i])
          }         
      }          
      for (let i = 0; i < this.yesterday.length; i++) {    
          if (this.yesterday[i].ner_organization[1] == this.SetOrganisasi[5]) {
            this.chartBubleIndx5OrgYesterday.push(this.yesterday[i])
          }         
      }     
      // end chart buble organisasi yesterday
      for (let i = 0; i < this.yesterday.length; i++) {  
        if(this.yesterday[i].source == "berita"){      
          // if (this.yesterday[i].domain == 'kapanlagi.com') {
              this.mediaYesterdayOnlineNewsShare.push(this.yesterday[i]);
            // }
          }
      }
      for (let i = 0; i < this.yesterday.length; i++) {       
        if(this.yesterday[i].source == "berita"){
          this.mediaBeritaYesterday.push(this.yesterday[i])
        }          
      }
      for (let i = 0; i < this.yesterday.length; i++) {       
          if(this.yesterday[i].source == "twitter"){
              this.mediaTwetYesterday.push(this.yesterday[i])
            }          
          }
      for (let i = 0; i < this.yesterday.length; i++) {       
          if(this.yesterday[i].source == "youtube"){
            this.mediaYtYesterday.push(this.yesterday[i])
        }          
      }
      // end yesteday    
      // last 7 day
        for (let i = 0; i < data.data.length; i++) {       
          if (data.data[i].dateid <= this.Settanggal[7] && data.data[i].dateid >= this.Settanggal[1]) {
             this.Last7Day.push(data.data[i]);
          }         
      }           
         for (let i = 0; i < this.Last7Day.length; i++) {       
          if (data.data[i].sentiment == "Positive") {
             this.kontenBeritaPositiveLast7Day.push(data.data[i]);
          }         
      }  
        for (let i = 0; i < this.Last7Day.length; i++) {       
          if (data.data[i].sentiment == "Negative") {
             this.kontenBeritaNegativeLast7Day.push(data.data[i]);
          }         
      }  
         for (let i = 0; i < this.Last7Day.length; i++) {       
          if (data.data[i].sentiment == "Netral") {
             this.kontenBeritaNetralLast7Day.push(data.data[i]);
          }         
      }       



      // chart bubble person
      for (let i = 0; i < this.Last7Day.length; i++) {    
          if (this.Last7Day[i].ner_person[0] == this.SetPerson[0]) {
            this.chartBubleIndx0Last7Day.push(this.Last7Day[i])
          }         
      }         
      for (let i = 0; i < this.Last7Day.length; i++) {    
          if (this.Last7Day[i].ner_person[1] == this.SetPerson[0]) {
            this.chartBubleIndx0Last7Day.push(this.Last7Day[i])
          }         
      }      
      for (let i = 0; i < this.Last7Day.length; i++) {    
          if (this.Last7Day[i].ner_person[0] == this.SetPerson[1]) {
            this.chartBubleIndx1Last7Day.push(this.Last7Day[i])
          }         
      }         
      for (let i = 0; i < this.Last7Day.length; i++) {    
          if (this.Last7Day[i].ner_person[1] == this.SetPerson[1]) {
            this.chartBubleIndx1Last7Day.push(this.Last7Day[i])
          }         
      }       
      for (let i = 0; i < this.Last7Day.length; i++) {    
          if (this.Last7Day[i].ner_person[0] == this.SetPerson[2]) {
            this.chartBubleIndx2Last7Day.push(this.Last7Day[i])
          }         
      }         
      for (let i = 0; i < this.Last7Day.length; i++) {    
          if (this.Last7Day[i].ner_person[1] == this.SetPerson[2]) {
            this.chartBubleIndx2Last7Day.push(this.Last7Day[i])
          }         
      }    
        for (let i = 0; i < this.Last7Day.length; i++) {    
          if (this.Last7Day[i].ner_person[0] == this.SetPerson[3]) {
            this.chartBubleIndx3Last7Day.push(this.Last7Day[i])
          }         
      }          
      for (let i = 0; i < this.Last7Day.length; i++) {    
          if (this.Last7Day[i].ner_person[1] == this.SetPerson[3]) {
            this.chartBubleIndx3Last7Day.push(this.Last7Day[i])
          }         
      }            
        for (let i = 0; i < this.Last7Day.length; i++) {    
          if (this.Last7Day[i].ner_person[0] == this.SetPerson[4]) {
            this.chartBubleIndx4Last7Day.push(this.Last7Day[i])
          }         
      }          
      for (let i = 0; i < this.Last7Day.length; i++) {    
          if (this.Last7Day[i].ner_person[1] == this.SetPerson[4]) {
            this.chartBubleIndx4Last7Day.push(this.Last7Day[i])
          }         
      }             
        for (let i = 0; i < this.Last7Day.length; i++) {    
          if (this.Last7Day[i].ner_person[0] == this.SetPerson[5]) {
            this.chartBubleIndx5Last7Day.push(this.Last7Day[i])
          }         
      }          
      for (let i = 0; i < this.Last7Day.length; i++) {    
          if (this.Last7Day[i].ner_person[1] == this.SetPerson[5]) {
            this.chartBubleIndx5Last7Day.push(this.Last7Day[i])
          }         
      }              
      // end buble person today
      
      // chart buble organisasi
      for (let i = 0; i < this.Last7Day.length; i++) {    
          if (this.Last7Day[i].ner_organization[0] == this.SetOrganisasi[0]) {
            this.chartBubleIndx0OrgLast7Day.push(this.Last7Day[i])
          }         
      }         
      for (let i = 0; i < this.Last7Day.length; i++) {    
          if (this.Last7Day[i].ner_organization[1] == this.SetOrganisasi[0]) {
            this.chartBubleIndx0OrgLast7Day.push(this.Last7Day[i])
          }         
      }      
      for (let i = 0; i < this.Last7Day.length; i++) {    
          if (this.Last7Day[i].ner_organization[0] == this.SetOrganisasi[1]) {
            this.chartBubleIndx1OrgLast7Day.push(this.Last7Day[i])
          }         
      }         
      for (let i = 0; i < this.Last7Day.length; i++) {    
          if (this.Last7Day[i].ner_organization[1] == this.SetOrganisasi[1]) {
            this.chartBubleIndx1OrgLast7Day.push(this.Last7Day[i])
          }         
      }       
      for (let i = 0; i < this.Last7Day.length; i++) {    
          if (this.Last7Day[i].ner_organization[0] == this.SetOrganisasi[2]) {
            this.chartBubleIndx2OrgLast7Day.push(this.Last7Day[i])
          }         
      }         
      for (let i = 0; i < this.Last7Day.length; i++) {    
          if (this.Last7Day[i].ner_organization[1] == this.SetOrganisasi[2]) {
            this.chartBubleIndx2OrgLast7Day.push(this.Last7Day[i])
          }         
      }    
        for (let i = 0; i < this.Last7Day.length; i++) {    
          if (this.Last7Day[i].ner_organization[0] == this.SetOrganisasi[3]) {
            this.chartBubleIndx3OrgLast7Day.push(this.Last7Day[i])
          }         
      }          
      for (let i = 0; i < this.Last7Day.length; i++) {    
          if (this.Last7Day[i].ner_organization[1] == this.SetOrganisasi[3]) {
            this.chartBubleIndx3OrgLast7Day.push(this.Last7Day[i])
          }         
      }            
        for (let i = 0; i < this.Last7Day.length; i++) {    
          if (this.Last7Day[i].ner_organization[0] == this.SetOrganisasi[4]) {
            this.chartBubleIndx4OrgLast7Day.push(this.Last7Day[i])
          }         
      }          
      for (let i = 0; i < this.Last7Day.length; i++) {    
          if (this.Last7Day[i].ner_organization[1] == this.SetOrganisasi[4]) {
            this.chartBubleIndx4OrgLast7Day.push(this.Last7Day[i])
          }         
      }             
        for (let i = 0; i < this.Last7Day.length; i++) {    
          if (this.Last7Day[i].ner_organization[0] == this.SetOrganisasi[5]) {
            this.chartBubleIndx5OrgLast7Day.push(this.Last7Day[i])
          }         
      }          
      for (let i = 0; i < this.Last7Day.length; i++) {    
          if (this.Last7Day[i].ner_organization[1] == this.SetOrganisasi[5]) {
            this.chartBubleIndx5OrgLast7Day.push(this.Last7Day[i])
          }         
      }         
      // end chart organisasi last 7
      for (let i = 0; i < this.Last7Day.length; i++) {  
          if(this.Last7Day[i].source == "berita"){
            // if (this.Last7Day[i].domain == 'kapanlagi.com') {
                this.mediaLast7DayOnlineNewsShare.push(this.Last7Day[i]);
            // }
          }
      }
       for (let i = 0; i < this.Last7Day.length; i++) {       
          if(this.Last7Day[i].source == "berita"){
              this.mediaBeritaLast7Day.push(this.Last7Day[i])
              }          
          }
      for (let i = 0; i < this.Last7Day.length; i++) {       
          if(this.Last7Day[i].source == "twitter"){
                this.mediaTwetLast7Day.push(this.Last7Day[i])
              }          
          }
      for (let i = 0; i < this.Last7Day.length; i++) {       
          if(this.Last7Day[i].source == "youtube"){
                this.mediaYtLast7Day.push(this.Last7Day[i])
              }          
      }
      // end last 7 day
      // last 30 day
      for (let i = 0; i < data.data.length; i++) {       
          if (data.data[i].dateid <= this.EndDate && data.data[i].dateid >= this.StartDateLast30) {
             this.Last30Day.push(data.data[i]);
          }         
      }                  
      //berita last 30day  
      for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "berita"){         
          if (this.Last30Day[i].dateid == this.SettanggalLast30[0]) {
              this.tnglIndex0Last30Day.push(data.data[i]);
          }
        }
      }
      for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "berita"){       
          if (this.Last30Day[i].dateid == this.SettanggalLast30[1]) {
              this.tnglIndex1Last30Day.push(data.data[i]);
          }
        }
      }
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "berita"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[2]) {
              this.tnglIndex2Last30Day.push(data.data[i]);
          }
        }
      }   
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "berita"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[3]) {
              this.tnglIndex3Last30Day.push(data.data[i]);
          }
        }
      }
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "berita"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[4]) {
              this.tnglIndex4Last30Day.push(data.data[i]);
          }
        }
      }
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "berita"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[5]) {
              this.tnglIndex5Last30Day.push(data.data[i]);
          }
        }
      }
      for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "berita"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[6]) {
              this.tnglIndex6Last30Day.push(data.data[i]);
          }
        }
      }
      for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "berita"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[7]) {
              this.tnglIndex7Last30Day.push(data.data[i]);
          }
        }
      }
         for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "berita"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[8]) {
              this.tnglIndex8Last30Day.push(data.data[i]);
          }
        }
      }
      for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "berita"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[9]) {
              this.tnglIndex9Last30Day.push(data.data[i]);
          }
        }
      }
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "berita"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[10]) {
              this.tnglIndex10Last30Day.push(data.data[i]);
          }
        }
      }   
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "berita"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[11]) {
              this.tnglIndex11Last30Day.push(data.data[i]);
          }
        }
      }
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "berita"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[12]) {
              this.tnglIndex12Last30Day.push(data.data[i]);
          }
        }
      }
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "berita"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[13]) {
              this.tnglIndex13Last30Day.push(data.data[i]);
          }
        }
      }
      for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "berita"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[14]) {
              this.tnglIndex14Last30Day.push(data.data[i]);
          }
        }
      }
      for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "berita"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[15]) {
              this.tnglIndex15Last30Day.push(data.data[i]);
          }
        }
      }
         for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "berita"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[16]) {
              this.tnglIndex16Last30Day.push(data.data[i]);
          }
        }
      }
      for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "berita"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[17]) {
              this.tnglIndex17Last30Day.push(data.data[i]);
          }
        }
      }
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "berita"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[18]) {
              this.tnglIndex18Last30Day.push(data.data[i]);
          }
        }
      }   
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "berita"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[19]) {
              this.tnglIndex19Last30Day.push(data.data[i]);
          }
        }
      }
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "berita"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[20]) {
              this.tnglIndex20Last30Day.push(data.data[i]);
          }
        }
      }
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "berita"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[21]) {
              this.tnglIndex21Last30Day.push(data.data[i]);
          }
        }
      }
      for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "berita"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[22]) {
              this.tnglIndex22Last30Day.push(data.data[i]);
          }
        }
      }
      for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "berita"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[23]) {
              this.tnglIndex23Last30Day.push(data.data[i]);
          }
        }
      }
         for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "berita"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[24]) {
              this.tnglIndex24Last30Day.push(data.data[i]);
          }
        }
      }
      for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "berita"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[25]) {
              this.tnglIndex25Last30Day.push(data.data[i]);
          }
        }
      }
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "berita"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[26]) {
              this.tnglIndex26Last30Day.push(data.data[i]);
          }
        }
      }   
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "berita"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[27]) {
              this.tnglIndex27Last30Day.push(data.data[i]);
          }
        }
      }
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "berita"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[28]) {
              this.tnglIndex28Last30Day.push(data.data[i]);
          }
        }
      }
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "berita"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[29]) {
              this.tnglIndex29Last30Day.push(data.data[i]);
          }
        }
      }
      for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "berita"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[30]) {
              this.tnglIndex30Last30Day.push(data.data[i]);
          }
        }
      }
      //end berita last 30day
      //youtube last 30day
      for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "youtube"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[0]) {
              this.tnglIndex0Last30DayYoutube.push(data.data[i]);
          }
        }
      }
      for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "youtube"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[1]) {
              this.tnglIndex1Last30DayYoutube.push(data.data[i]);
          }
        }
      }
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "youtube"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[2]) {
              this.tnglIndex2Last30DayYoutube.push(data.data[i]);
          }
        }
      }
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "youtube"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[3]) {
              this.tnglIndex3Last30DayYoutube.push(data.data[i]);
          }
        }
      }
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "youtube"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[4]) {
              this.tnglIndex4Last30DayYoutube.push(data.data[i]);
          }
        }
      }
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "youtube"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[5]) {
              this.tnglIndex5Last30DayYoutube.push(data.data[i]);
          }
        }
      }
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "youtube"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[6]) {
              this.tnglIndex6Last30DayYoutube.push(data.data[i]);
          }
        }
      }
      for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "youtube"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[7]) {
              this.tnglIndex7Last30DayYoutube.push(data.data[i]);
          }
        }
      }
      for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "youtube"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[8]) {
              this.tnglIndex8Last30DayYoutube.push(data.data[i]);
          }
        }
      }
        for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "youtube"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[9]) {
              this.tnglIndex9Last30DayYoutube.push(data.data[i]);
          }
        }
      }
      for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "youtube"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[10]) {
              this.tnglIndex10Last30DayYoutube.push(data.data[i]);
          }
        }
      }
      for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "youtube"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[11]) {
              this.tnglIndex11Last30DayYoutube.push(data.data[i]);
          }
        }
      }
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "youtube"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[12]) {
              this.tnglIndex12Last30DayYoutube.push(data.data[i]);
          }
        }
      }
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "youtube"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[13]) {
              this.tnglIndex13Last30DayYoutube.push(data.data[i]);
          }
        }
      }
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "youtube"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[14]) {
              this.tnglIndex14Last30DayYoutube.push(data.data[i]);
          }
        }
      }
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "youtube"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[15]) {
              this.tnglIndex15Last30DayYoutube.push(data.data[i]);
          }
        }
      }
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "youtube"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[16]) {
              this.tnglIndex16Last30Day.push(data.data[i]);
          }
        }
      }
      for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "youtube"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[17]) {
              this.tnglIndex17Last30DayYoutube.push(data.data[i]);
          }
        }
      }
      for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "youtube"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[18]) {
              this.tnglIndex18Last30DayYoutube.push(data.data[i]);
          }
        }
      }
        for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "youtube"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[19]) {
              this.tnglIndex19Last30DayYoutube.push(data.data[i]);
          }
        }
      }
      for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "youtube"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[20]) {
              this.tnglIndex20Last30DayYoutube.push(data.data[i]);
          }
        }
      }
      for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "youtube"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[21]) {
              this.tnglIndex21Last30DayYoutube.push(data.data[i]);
          }
        }
      }
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "youtube"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[22]) {
              this.tnglIndex22Last30DayYoutube.push(data.data[i]);
          }
        }
      }
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "youtube"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[23]) {
              this.tnglIndex23Last30DayYoutube.push(data.data[i]);
          }
        }
      }
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "youtube"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[24]) {
              this.tnglIndex24Last30DayYoutube.push(data.data[i]);
          }
        }
      }
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "youtube"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[25]) {
              this.tnglIndex25Last30DayYoutube.push(data.data[i]);
          }
        }
      }
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "youtube"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[26]) {
              this.tnglIndex26Last30Day.push(data.data[i]);
          }
        }
      }
      for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "youtube"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[27]) {
              this.tnglIndex27Last30DayYoutube.push(data.data[i]);
          }
        }
      }
      for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "youtube"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[28]) {
              this.tnglIndex28Last30DayYoutube.push(data.data[i]);
          }
        }
      }
        for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "youtube"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[29]) {
              this.tnglIndex29Last30DayYoutube.push(data.data[i]);
          }
        }
      }
        for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "youtube"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[30]) {
              this.tnglIndex30Last30DayYoutube.push(data.data[i]);
          }
        }
      }
      //end youtube last 30day
      //twitter last 30day
      for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "twitter"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[0]) {
              this.tnglIndex0Last30DayTwitter.push(data.data[i]);
          }
        }
      }
      for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "twitter"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[1]) {
              this.tnglIndex1Last30DayTwitter.push(data.data[i]);
          }
        }
      }
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "twitter"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[2]) {
              this.tnglIndex2Last30DayTwitter.push(data.data[i]);
          }
        }
      }
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "twitter"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[3]) {
              this.tnglIndex3Last30DayTwitter.push(data.data[i]);
          }
        }
      }
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "twitter"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[4]) {
              this.tnglIndex4Last30DayTwitter.push(data.data[i]);
          }
        }
      }
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "twitter"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[5]) {
              this.tnglIndex5Last30DayTwitter.push(data.data[i]);
          }
        }
      }
      for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "twitter"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[6]) {
              this.tnglIndex6Last30DayTwitter.push(data.data[i]);
          }
        }
      }
      for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "twitter"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[7]) {
              this.tnglIndex7Last30DayTwitter.push(data.data[i]);
          }
        }
      }
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "twitter"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[8]) {
              this.tnglIndex8Last30DayTwitter.push(data.data[i]);
          }
        }
      }
      for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "twitter"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[9]) {
              this.tnglIndex9Last30DayTwitter.push(data.data[i]);
          }
        }
      }
      for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "twitter"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[10]) {
              this.tnglIndex10Last30DayTwitter.push(data.data[i]);
          }
        }
      }
      for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "twitter"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[11]) {
              this.tnglIndex11Last30DayTwitter.push(data.data[i]);
          }
        }
      }
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "twitter"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[12]) {
              this.tnglIndex12Last30DayTwitter.push(data.data[i]);
          }
        }
      }
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "twitter"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[13]) {
              this.tnglIndex13Last30DayTwitter.push(data.data[i]);
          }
        }
      }
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "twitter"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[14]) {
              this.tnglIndex14Last30DayTwitter.push(data.data[i]);
          }
        }
      }
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "twitter"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[15]) {
              this.tnglIndex15Last30DayTwitter.push(data.data[i]);
          }
        }
      }
      for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "twitter"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[16]) {
              this.tnglIndex16Last30DayTwitter.push(data.data[i]);
          }
        }
      }
      for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "twitter"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[17]) {
              this.tnglIndex17Last30DayTwitter.push(data.data[i]);
          }
        }
      }
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "twitter"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[18]) {
              this.tnglIndex18Last30DayTwitter.push(data.data[i]);
          }
        }
      }
      for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "twitter"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[19]) {
              this.tnglIndex19Last30DayTwitter.push(data.data[i]);
          }
        }
      }
      for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "twitter"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[20]) {
              this.tnglIndex20Last30DayTwitter.push(data.data[i]);
          }
        }
      }
      for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "twitter"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[21]) {
              this.tnglIndex21Last30DayTwitter.push(data.data[i]);
          }
        }
      }
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "twitter"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[22]) {
              this.tnglIndex22Last30DayTwitter.push(data.data[i]);
          }
        }
      }
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "twitter"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[23]) {
              this.tnglIndex23Last30DayTwitter.push(data.data[i]);
          }
        }
      }
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "twitter"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[24]) {
              this.tnglIndex24Last30DayTwitter.push(data.data[i]);
          }
        }
      }
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "twitter"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[25]) {
              this.tnglIndex25Last30DayTwitter.push(data.data[i]);
          }
        }
      }
      for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "twitter"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[26]) {
              this.tnglIndex26Last30DayTwitter.push(data.data[i]);
          }
        }
      }
      for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "twitter"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[27]) {
              this.tnglIndex27Last30DayTwitter.push(data.data[i]);
          }
        }
      }
       for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "twitter"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[28]) {
              this.tnglIndex28Last30DayTwitter.push(data.data[i]);
          }
        }
      }
      for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "twitter"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[29]) {
              this.tnglIndex29Last30DayTwitter.push(data.data[i]);
          }
        }
      }
      for (let i = 0; i < this.Last30Day.length; i++) {  
        if(this.Last30Day[i].source == "twitter"){      
          if (this.Last30Day[i].dateid == this.SettanggalLast30[30]) {
              this.tnglIndex30Last30DayTwitter.push(data.data[i]);
          }
        }
      }
      // end twitter last 30day      
      for (let i = 0; i < this.Last30Day.length; i++) {       
          if (data.data[i].sentiment == "Positive") {
             this.kontenBeritaPositiveLast30Day.push(data.data[i]);
          }         
      }  
        for (let i = 0; i < this.Last30Day.length; i++) {       
          if (data.data[i].sentiment == "Negative") {
             this.kontenBeritaNegativeLast30Day.push(data.data[i]);
          }         
      }  
         for (let i = 0; i < this.Last30Day.length; i++) {       
          if (data.data[i].sentiment == "Netral") {
             this.kontenBeritaNetralLast30Day.push(data.data[i]);
          }         
      }  
      // chart bubble person
      for (let i = 0; i < this.Last30Day.length; i++) {    
          if (this.Last30Day[i].ner_person[0] == this.SetPerson[0]) {
            this.chartBubleIndx0Last30Day.push(this.Last30Day[i])
          }         
      }         
      for (let i = 0; i < this.Last30Day.length; i++) {    
          if (this.Last30Day[i].ner_person[1] == this.SetPerson[0]) {
            this.chartBubleIndx0Last30Day.push(this.Last30Day[i])
          }         
      }      
      for (let i = 0; i < this.Last30Day.length; i++) {    
          if (this.Last30Day[i].ner_person[0] == this.SetPerson[1]) {
            this.chartBubleIndx1Last30Day.push(this.Last30Day[i])
          }         
      }         
      for (let i = 0; i < this.Last30Day.length; i++) {    
          if (this.Last30Day[i].ner_person[1] == this.SetPerson[1]) {
            this.chartBubleIndx1Last30Day.push(this.Last30Day[i])
          }         
      }       
      for (let i = 0; i < this.Last30Day.length; i++) {    
          if (this.Last30Day[i].ner_person[0] == this.SetPerson[2]) {
            this.chartBubleIndx2Last30Day.push(this.Last30Day[i])
          }         
      }         
      for (let i = 0; i < this.Last30Day.length; i++) {    
          if (this.Last30Day[i].ner_person[1] == this.SetPerson[2]) {
            this.chartBubleIndx2Last30Day.push(this.Last30Day[i])
          }         
      }    
        for (let i = 0; i < this.Last30Day.length; i++) {    
          if (this.Last30Day[i].ner_person[0] == this.SetPerson[3]) {
            this.chartBubleIndx3Last30Day.push(this.Last30Day[i])
          }         
      }          
      for (let i = 0; i < this.Last30Day.length; i++) {    
          if (this.Last30Day[i].ner_person[1] == this.SetPerson[3]) {
            this.chartBubleIndx3Last30Day.push(this.Last30Day[i])
          }         
      }            
        for (let i = 0; i < this.Last30Day.length; i++) {    
          if (this.Last30Day[i].ner_person[0] == this.SetPerson[4]) {
            this.chartBubleIndx4Last30Day.push(this.Last30Day[i])
          }         
      }          
      for (let i = 0; i < this.Last30Day.length; i++) {    
          if (this.Last30Day[i].ner_person[1] == this.SetPerson[4]) {
            this.chartBubleIndx4Last30Day.push(this.Last30Day[i])
          }         
      }             
        for (let i = 0; i < this.Last30Day.length; i++) {    
          if (this.Last30Day[i].ner_person[0] == this.SetPerson[5]) {
            this.chartBubleIndx5Last30Day.push(this.Last30Day[i])
          }         
      }          
      for (let i = 0; i < this.Last30Day.length; i++) {    
          if (this.Last30Day[i].ner_person[1] == this.SetPerson[5]) {
            this.chartBubleIndx5Last30Day.push(this.Last30Day[i])
          }         
      }              
      // end buble person today
      // chart buble organisasi
      for (let i = 0; i < this.Last30Day.length; i++) {    
          if (this.Last30Day[i].ner_organization[0] == this.SetOrganisasi[0]) {
            this.chartBubleIndx0OrgLast30Day.push(this.Last30Day[i])
          }         
      }         
      for (let i = 0; i < this.Last30Day.length; i++) {    
          if (this.Last30Day[i].ner_organization[1] == this.SetOrganisasi[0]) {
            this.chartBubleIndx0OrgLast30Day.push(this.Last30Day[i])
          }         
      }      
      for (let i = 0; i < this.Last30Day.length; i++) {    
          if (this.Last30Day[i].ner_organization[0] == this.SetOrganisasi[1]) {
            this.chartBubleIndx1OrgLast30Day.push(this.Last30Day[i])
          }         
      }         
      for (let i = 0; i < this.Last30Day.length; i++) {    
          if (this.Last30Day[i].ner_organization[1] == this.SetOrganisasi[1]) {
            this.chartBubleIndx1OrgLast30Day.push(this.Last30Day[i])
          }         
      }       
      for (let i = 0; i < this.Last30Day.length; i++) {    
          if (this.Last30Day[i].ner_organization[0] == this.SetOrganisasi[2]) {
            this.chartBubleIndx2OrgLast30Day.push(this.Last30Day[i])
          }         
      }         
      for (let i = 0; i < this.Last30Day.length; i++) {    
          if (this.Last30Day[i].ner_organization[1] == this.SetOrganisasi[2]) {
            this.chartBubleIndx2OrgLast30Day.push(this.Last30Day[i])
          }         
      }    
        for (let i = 0; i < this.Last30Day.length; i++) {    
          if (this.Last30Day[i].ner_organization[0] == this.SetOrganisasi[3]) {
            this.chartBubleIndx3OrgLast30Day.push(this.Last30Day[i])
          }         
      }          
      for (let i = 0; i < this.Last30Day.length; i++) {    
          if (this.Last30Day[i].ner_organization[1] == this.SetOrganisasi[3]) {
            this.chartBubleIndx3OrgLast30Day.push(this.Last30Day[i])
          }         
      }            
        for (let i = 0; i < this.Last30Day.length; i++) {    
          if (this.Last30Day[i].ner_organization[0] == this.SetOrganisasi[4]) {
            this.chartBubleIndx4OrgLast30Day.push(this.Last30Day[i])
          }         
      }          
      for (let i = 0; i < this.Last30Day.length; i++) {    
          if (this.Last30Day[i].ner_organization[1] == this.SetOrganisasi[4]) {
            this.chartBubleIndx4OrgLast30Day.push(this.Last30Day[i])
          }         
      }             
        for (let i = 0; i < this.Last30Day.length; i++) {    
          if (this.Last30Day[i].ner_organization[0] == this.SetOrganisasi[5]) {
            this.chartBubleIndx5OrgLast30Day.push(this.Last30Day[i])
          }         
      }          
      for (let i = 0; i < this.Last30Day.length; i++) {    
          if (this.Last30Day[i].ner_organization[1] == this.SetOrganisasi[5]) {
            this.chartBubleIndx5OrgLast30Day.push(this.Last30Day[i])
          }         
      }         
      // end chart buble organisasi

        this.seriessentiment[0].data.push(this.tnglIndex0.length, this.tnglIndex1.length, this.tnglIndex2.length, this.tnglIndex3.length, this.tnglIndex4.length, this.tnglIndex5.length, this.tnglIndex6.length, this.tnglIndex7.length)
        this.seriessentiment[1].data.push(this.tnglIndex0Twet.length, this.tnglIndex1Twet.length, this.tnglIndex2Twet.length, this.tnglIndex3Twet.length, this.tnglIndex4Twet.length, this.tnglIndex5Twet.length, this.tnglIndex6Twet.length, this.tnglIndex7Twet.length)
        this.seriessentiment[2].data.push(this.tnglIndex0Yt.length, this.tnglIndex1Yt.length, this.tnglIndex2Yt.length, this.tnglIndex3Yt.length, this.tnglIndex4Yt.length, this.tnglIndex5Yt.length, this.tnglIndex6Yt.length, this.tnglIndex7Yt.length)
        window.dispatchEvent(new Event('resize'))
        for (let i = 0; i < this.Last30Day.length; i++) {     
          if(this.Last30Day[i].source == "berita"){  
            // if (this.Last30Day[i].domain == 'kapanlagi.com') {
                this.mediaLast30DayOnlineNewsShare.push(this.Last30Day[i]);
            // }
          }
        }
        for (let i = 0; i < this.Last30Day.length; i++) {       
          if(this.Last30Day[i].source == "berita"){
              this.mediaBeritaLast30Day.push(this.Last30Day[i])
            }          
          }
        for (let i = 0; i < this.Last30Day.length; i++) {       
            if(this.Last30Day[i].source == "twitter"){
              this.mediaTwetLast30Day.push(this.Last30Day[i])
            }          
          }
        for (let i = 0; i < this.Last30Day.length; i++) {       
            if(this.Last30Day[i].source == "youtube"){
              this.mediaYtLast30Day.push(this.Last30Day[i])
            }          
          }
      // klik button jumlah          
      for (let i = 0; i < this.mediaBerita.length; i++) {  
        
        if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null      
          if (data.data[i].ner_person[0] == this.SetPerson[0]) {
             this.valueBubleIndx0Berita.push(data.data[i]);
          }         
        }
      }  
      for (let i = 0; i < this.mediaBerita.length; i++) { 
        if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null        
          if (data.data[i].ner_person[1] == this.SetPerson[0]) {
             this.valueBubleIndx0Berita.push(data.data[i]);
          }  
        }       
      }  
      for (let i = 0; i < this.mediaBerita.length; i++) {  
        if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null        
          if (data.data[i].ner_person[0] == this.SetPerson[1]) {
             this.valueBubleIndx1Berita.push(data.data[i]);
          }         
        }
      }  
      for (let i = 0; i < this.mediaBerita.length; i++) { 
        if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null         
          if (data.data[i].ner_person[1] == this.SetPerson[1]) {
             this.valueBubleIndx1Berita.push(data.data[i]);
          }        
        } 
      }  
      for (let i = 0; i < this.mediaBerita.length; i++) { 
        if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null         
          if (data.data[i].ner_person[0] == this.SetPerson[2]) {
             this.valueBubleIndx2Berita.push(data.data[i]);
          }         
        }
      }  
      for (let i = 0; i < this.mediaBerita.length; i++) {   
        if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null       
          if (data.data[i].ner_person[1] == this.SetPerson[2]) {
             this.valueBubleIndx2Berita.push(data.data[i]);
          }      
        }   
      }  
      for (let i = 0; i < this.mediaBerita.length; i++) { 
        if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null         
          if (data.data[i].ner_person[0] == this.SetPerson[3]) {
             this.valueBubleIndx3Berita.push(data.data[i]);
          }  
        }       
      }  
      for (let i = 0; i < this.mediaBerita.length; i++) {
        if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null          
          if (data.data[i].ner_person[1] == this.SetPerson[3]) {
             this.valueBubleIndx3Berita.push(data.data[i]);
          }       
        }  
      }  
      for (let i = 0; i < this.mediaBerita.length; i++) {  
        if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null        
          if (data.data[i].ner_person[0] == this.SetPerson[4]) {
             this.valueBubleIndx4Berita.push(data.data[i]);
          }         
        }
      }  
      for (let i = 0; i < this.mediaBerita.length; i++) {   
        if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null       
          if (data.data[i].ner_person[1] == this.SetPerson[4]) {
             this.valueBubleIndx4Berita.push(data.data[i]);
          }      
        }   
      }
      for (let i = 0; i < this.mediaBerita.length; i++) {   
        if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null       
          if (data.data[i].ner_person[0] == this.SetPerson[5]) {
             this.valueBubleIndx5Berita.push(data.data[i]);
          }       
        }  
      }  
      for (let i = 0; i < this.mediaBerita.length; i++) {   
        if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null       
          if (data.data[i].ner_person[1] == this.SetPerson[5]) {
             this.valueBubleIndx5Berita.push(data.data[i]);
          }   
        }      
      }
      for (let i = 0; i < this.mediaBerita.length; i++) {
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null          
          if (data.data[i].ner_organization[0] == this.SetOrganisasi[0]) {
             this.valueBubleIndx0OrgBerita.push(data.data[i]);
          }         
        }
      }  
      for (let i = 0; i < this.mediaBerita.length; i++) {  
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null        
          if (data.data[i].ner_organization[1] == this.SetOrganisasi[0]) {
             this.valueBubleIndx0OrgBerita.push(data.data[i]);
          }         
        }
      }  
      for (let i = 0; i < this.mediaBerita.length; i++) {    
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null      
          if (data.data[i].ner_organization[0] == this.SetOrganisasi[1]) {
             this.valueBubleIndx1OrgBerita.push(data.data[i]);
          }      
        }   
      }  
      for (let i = 0; i < this.mediaBerita.length; i++) {    
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null      
          if (data.data[i].ner_organization[1] == this.SetOrganisasi[1]) {
             this.valueBubleIndx1OrgBerita.push(data.data[i]);
          }      
        }   
      }  
      for (let i = 0; i < this.mediaBerita.length; i++) { 
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null         
          if (data.data[i].ner_organization[0] == this.SetOrganisasi[2]) {
             this.valueBubleIndx2OrgBerita.push(data.data[i]);
          }         
        }
      }  
      for (let i = 0; i < this.mediaBerita.length; i++) {   
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null       
          if (data.data[i].ner_organization[1] == this.SetOrganisasi[2]) {
             this.valueBubleIndx2OrgBerita.push(data.data[i]);
          }  
        }       
      }  
      for (let i = 0; i < this.mediaBerita.length; i++) {  
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null        
          if (data.data[i].ner_organization[0] == this.SetOrganisasi[3]) {
             this.valueBubleIndx3OrgBerita.push(data.data[i]);
          }         
        }
      }  
      for (let i = 0; i < this.mediaBerita.length; i++) {    
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null      
          if (data.data[i].ner_organization[1] == this.SetOrganisasi[3]) {
             this.valueBubleIndx3OrgBerita.push(data.data[i]);
          }  
        }       
      }  
      for (let i = 0; i < this.mediaBerita.length; i++) {   
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null       
          if (data.data[i].ner_organization[0] == this.SetOrganisasi[4]) {
             this.valueBubleIndx4OrgBerita.push(data.data[i]);
          }         
        }
      }  
      for (let i = 0; i < this.mediaBerita.length; i++) {   
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null       
          if (data.data[i].ner_organization[1] == this.SetOrganisasi[4]) {
             this.valueBubleIndx4OrgBerita.push(data.data[i]);
          }         
        }
      }      
      for (let i = 0; i < this.mediaBerita.length; i++) {    
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null      
          if (data.data[i].ner_organization[0] == this.SetOrganisasi[5]) {
             this.valueBubleIndx5OrgBerita.push(data.data[i]);
          }       
        }  
      }  
      for (let i = 0; i < this.mediaBerita.length; i++) { 
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null         
          if (data.data[i].ner_organization[1] == this.SetOrganisasi[5]) {
             this.valueBubleIndx5OrgBerita.push(data.data[i]);
          }   
        }      
      }     



        // sentiment berita
          for (let i = 0; i < this.mediaBerita.length; i++) {       
              if (data.data[i].sentiment == 'Netral') {
                  this.mediaBeritaNetral.push(data.data[i]);
              }
          }
          for (let i = 0; i < this.mediaBerita.length; i++) {       
              if (data.data[i].sentiment == 'Negative') {
                  this.mediaBeritaNegative.push(data.data[i]);
              }
          }
          for (let i = 0; i < this.mediaBerita.length; i++) {       
              if (data.data[i].sentiment == 'Positive') {
                  this.mediaBeritaPositive.push(data.data[i]);
              }
          }
          // end sentiment berita 
      for (let i = 0; i < this.MediatwitterShare.length; i++) {   
        
        if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null       
          if (data.data[i].ner_person[0] == this.SetPerson[0]) {
             this.valueBubleIndx0Twitter.push(data.data[i]);
          }         
        }
      }  
      for (let i = 0; i < this.MediatwitterShare.length; i++) {     
        if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null   
          if (data.data[i].ner_person[1] == this.SetPerson[0]) {
             this.valueBubleIndx0Twitter.push(data.data[i]);
          }       
        }  
      }  
      for (let i = 0; i < this.MediatwitterShare.length; i++) {  
        if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null      
          if (data.data[i].ner_person[0] == this.SetPerson[1]) {
             this.valueBubleIndx1Twitter.push(data.data[i]);
          }  
        }       
      }  
      for (let i = 0; i < this.MediatwitterShare.length; i++) {  
        if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null      
          if (data.data[i].ner_person[1] == this.SetPerson[1]) {
             this.valueBubleIndx1Twitter.push(data.data[i]);
          }      
        }   
      }  
      for (let i = 0; i < this.MediatwitterShare.length; i++) {   
        if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null     
          if (data.data[i].ner_person[0] == this.SetPerson[2]) {
             this.valueBubleIndx2Twitter.push(data.data[i]);
          }    
        }     
      }  
      for (let i = 0; i < this.MediatwitterShare.length; i++) { 
        if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null       
          if (data.data[i].ner_person[1] == this.SetPerson[2]) {
             this.valueBubleIndx2Twitter.push(data.data[i]);
          }     
        }    
      }  
      for (let i = 0; i < this.MediatwitterShare.length; i++) {   
        if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null     
          if (data.data[i].ner_person[0] == this.SetPerson[3]) {
             this.valueBubleIndx3Twitter.push(data.data[i]);
          }         
        }
      }  
      for (let i = 0; i < this.MediatwitterShare.length; i++) {  
        if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null      
          if (data.data[i].ner_person[1] == this.SetPerson[3]) {
             this.valueBubleIndx3Twitter.push(data.data[i]);
          }        
        } 
      }  
      for (let i = 0; i < this.MediatwitterShare.length; i++) {  
        if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null      
          if (data.data[i].ner_person[0] == this.SetPerson[4]) {
             this.valueBubleIndx4Twitter.push(data.data[i]);
          }       
        }  
      }  
      for (let i = 0; i < this.MediatwitterShare.length; i++) { 
        if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null       
          if (data.data[i].ner_person[1] == this.SetPerson[4]) {
             this.valueBubleIndx4Twitter.push(data.data[i]);
          }   
        }      
      }
      for (let i = 0; i < this.MediatwitterShare.length; i++) { 
        if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null       
          if (data.data[i].ner_person[0] == this.SetPerson[5]) {
             this.valueBubleIndx5Twitter.push(data.data[i]);
          }   
        }      
      }  
      for (let i = 0; i < this.MediatwitterShare.length; i++) { 
        if (data.data[i].ner_person != null) {  //tambahan karna data ada yang null       
          if (data.data[i].ner_person[1] == this.SetPerson[5]) {
             this.valueBubleIndx5Twitter.push(data.data[i]);
          }      
        }   
      }
      for (let i = 0; i < this.MediatwitterShare.length; i++) {    
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null    
          if (data.data[i].ner_organization[0] == this.SetOrganisasi[0]) {
             this.valueBubleIndx0OrgTwitter.push(data.data[i]);
          }         
        }
      }  
      for (let i = 0; i < this.MediatwitterShare.length; i++) {   
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null        
          if (data.data[i].ner_organization[1] == this.SetOrganisasi[0]) {
             this.valueBubleIndx0OrgTwitter.push(data.data[i]);
          }         
        }
      }  
      for (let i = 0; i < this.MediatwitterShare.length; i++) {    
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null       
          if (data.data[i].ner_organization[0] == this.SetOrganisasi[1]) {
             this.valueBubleIndx1OrgTwitter.push(data.data[i]);
          }        
        } 
      }  
      for (let i = 0; i < this.MediatwitterShare.length; i++) {  
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null         
          if (data.data[i].ner_organization[1] == this.SetOrganisasi[1]) {
             this.valueBubleIndx1OrgTwitter.push(data.data[i]);
          }         
        }
      }  
      for (let i = 0; i < this.MediatwitterShare.length; i++) {      
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null     
          if (data.data[i].ner_organization[0] == this.SetOrganisasi[2]) {
             this.valueBubleIndx2OrgTwitter.push(data.data[i]);
          }       
        }  
      }  
      for (let i = 0; i < this.MediatwitterShare.length; i++) {  
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null         
          if (data.data[i].ner_organization[1] == this.SetOrganisasi[2]) {
             this.valueBubleIndx2OrgTwitter.push(data.data[i]);
          }   
        }      
      }  
      for (let i = 0; i < this.MediatwitterShare.length; i++) {    
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null       
          if (data.data[i].ner_organization[0] == this.SetOrganisasi[3]) {
             this.valueBubleIndx3OrgTwitter.push(data.data[i]);
          }
        }         
      }  
      for (let i = 0; i < this.MediatwitterShare.length; i++) {  
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null         
          if (data.data[i].ner_organization[1] == this.SetOrganisasi[3]) {
             this.valueBubleIndx3OrgTwitter.push(data.data[i]);
          }     
        }    
      }     
      for (let i = 0; i < this.MediatwitterShare.length; i++) {  
        
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null         
          if (data.data[i].ner_organization[0] == this.SetOrganisasi[4]) {
             this.valueBubleIndx4OrgTwitter.push(data.data[i]);
          }         
        }
      }  
      for (let i = 0; i < this.MediatwitterShare.length; i++) { 
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null          
          if (data.data[i].ner_organization[1] == this.SetOrganisasi[4]) {
             this.valueBubleIndx4OrgTwitter.push(data.data[i]);
          }         
        }
      }     
      for (let i = 0; i < this.MediatwitterShare.length; i++) {   
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null        
          if (data.data[i].ner_organization[0] == this.SetOrganisasi[5]) {
             this.valueBubleIndx5OrgTwitter.push(data.data[i]);
          }         
        }
      }  
      for (let i = 0; i < this.MediatwitterShare.length; i++) {    
        if (data.data[i].ner_organization != null) {  //tambahan karna data ada yang null       
          if (data.data[i].ner_organization[1] == this.SetOrganisasi[5]) {
             this.valueBubleIndx5OrgTwitter.push(data.data[i]);
          }   
        }      
      } 
         // sentiment tweet
          for (let i = 0; i < this.MediatwitterShare.length; i++) {       
              if (data.data[i].sentiment == 'Netral') {
                  this.mediaTweetNetral.push(data.data[i]);
              }
          }
          for (let i = 0; i < this.MediatwitterShare.length; i++) {       
              if (data.data[i].sentiment == 'Negative') {
                  this.mediaTweetNegative.push(data.data[i]);
              }
          }
          for (let i = 0; i < this.MediatwitterShare.length; i++) {       
              if (data.data[i].sentiment == 'Positive') {
                  this.mediaTweetPositive.push(data.data[i]);
              }
          }
      // end sentiment tweet    
      for (let i = 0; i < this.MediaYtShare.length; i++) {       
          if (data.data[i].ner_person[0] == this.SetPerson[0]) {
             this.valueBubleIndx0Youtube.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.MediaYtShare.length; i++) {       
          if (data.data[i].ner_person[1] == this.SetPerson[0]) {
             this.valueBubleIndx0Youtube.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.MediaYtShare.length; i++) {       
          if (data.data[i].ner_person[0] == this.SetPerson[1]) {
             this.valueBubleIndx1Youtube.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.MediaYtShare.length; i++) {       
          if (data.data[i].ner_person[1] == this.SetPerson[1]) {
             this.valueBubleIndx1Youtube.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.MediaYtShare.length; i++) {       
          if (data.data[i].ner_person[0] == this.SetPerson[2]) {
             this.valueBubleIndx2Youtube.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.MediaYtShare.length; i++) {       
          if (data.data[i].ner_person[1] == this.SetPerson[2]) {
             this.valueBubleIndx2Youtube.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.MediaYtShare.length; i++) {       
          if (data.data[i].ner_person[0] == this.SetPerson[3]) {
             this.valueBubleIndx3Youtube.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.MediaYtShare.length; i++) {       
          if (data.data[i].ner_person[1] == this.SetPerson[3]) {
             this.valueBubleIndx3Youtube.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.MediaYtShare.length; i++) {       
          if (data.data[i].ner_person[0] == this.SetPerson[4]) {
             this.valueBubleIndx4Youtube.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.MediaYtShare.length; i++) {       
          if (data.data[i].ner_person[1] == this.SetPerson[4]) {
             this.valueBubleIndx4Youtube.push(data.data[i]);
          }         
      }  
         for (let i = 0; i < this.MediaYtShare.length; i++) {       
          if (data.data[i].ner_person[0] == this.SetPerson[5]) {
             this.valueBubleIndx4Youtube.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.MediaYtShare.length; i++) {       
          if (data.data[i].ner_person[1] == this.SetPerson[5]) {
             this.valueBubleIndx4Youtube.push(data.data[i]);
          }         
      }
        for (let i = 0; i < this.MediaYtShare.length; i++) {       
          if (data.data[i].ner_organization[0] == this.SetOrganisasi[0]) {
             this.valueBubleIndx0OrgYoutube.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.MediaYtShare.length; i++) {       
          if (data.data[i].ner_organization[1] == this.SetOrganisasi[0]) {
             this.valueBubleIndx0OrgYoutube.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.MediaYtShare.length; i++) {       
          if (data.data[i].ner_organization[0] == this.SetOrganisasi[1]) {
             this.valueBubleIndx1OrgYoutube.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.MediaYtShare.length; i++) {       
          if (data.data[i].ner_organization[1] == this.SetOrganisasi[1]) {
             this.valueBubleIndx1OrgYoutube.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.MediaYtShare.length; i++) {       
          if (data.data[i].ner_organization[0] == this.SetOrganisasi) {
             this.valueBubleIndx2OrgYoutube.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.MediaYtShare.length; i++) {       
          if (data.data[i].ner_organization[1] == this.SetOrganisasi) {
             this.valueBubleIndx2OrgYoutube.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.MediaYtShare.length; i++) {       
          if (data.data[i].ner_organization[0] == this.SetOrganisasi[3]) {
             this.valueBubleIndx3OrgYoutube.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.MediaYtShare.length; i++) {       
          if (data.data[i].ner_organization[1] == this.SetOrganisasi[3]) {
             this.valueBubleIndx3OrgYoutube.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.MediaYtShare.length; i++) {       
          if (this.MediaYtShare[i].ner_organization[0] == this.SetOrganisasi[4]) {
             this.valueBubleIndx4OrgYoutube.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.MediaYtShare.length; i++) {       
          if (this.MediaYtShare[i].ner_organization[1] == this.SetOrganisasi[4]) {
             this.valueBubleIndx4OrgYoutube.push(data.data[i]);
          }         
      }          
      for (let i = 0; i < this.MediaYtShare.length; i++) {       
          if (this.MediaYtShare[i].ner_organization[0] == this.SetOrganisasi[5]) {
             this.valueBubleIndx5OrgYoutube.push(data.data[i]);
          }         
      }  
      for (let i = 0; i < this.MediaYtShare.length; i++) {       
          if (this.MediaYtShare[i].ner_organization[1] == this.SetOrganisasi[5]) {
             this.valueBubleIndx5OrgYoutube.push(data.data[i]);
          }         
      }   
       // sentiment yt
      for (let i = 0; i < this.MediaYtShare.length; i++) {       
          if (data.data[i].sentiment == 'Netral') {
              this.mediaYtNetral.push(data.data[i]);
            }
          }
      for (let i = 0; i < this.MediaYtShare.length; i++) {       
          if (data.data[i].sentiment == 'Negative') {
              this.mediaYtNegative.push(data.data[i]);
            }
          }
      for (let i = 0; i < this.MediaYtShare.length; i++) {       
          if (data.data[i].sentiment == 'Positive') {
              this.mediaYtPositive.push(data.data[i]);
            }
          }
      // end sentiment yt




      // klik buble person
      // buble index 0
       for (let i = 0; i < this.chartBubleIndx0.length; i++) {    
          if (this.chartBubleIndx0[i].ner_organization[0] == this.SetOrganisasi[0]) {
            this.valueIndx0Org0.push(this.chartBubleIndx0[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndx0.length; i++) {    
          if (this.chartBubleIndx0[i].ner_organization[1] == this.SetOrganisasi[0]) {
            this.valueIndx0Org0.push(this.chartBubleIndx0[i])
          }         
      } 
       for (let i = 0; i < this.chartBubleIndx0.length; i++) {    
          if (this.chartBubleIndx0[i].ner_organization[0] == this.SetOrganisasi[1]) {
            this.valueIndx0Org1.push(this.chartBubleIndx0[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndx0.length; i++) {    
          if (this.chartBubleIndx0[i].ner_organization[1] == this.SetOrganisasi[1]) {
            this.valueIndx0Org1.push(this.chartBubleIndx0[i])
          }         
      } 
        for (let i = 0; i < this.chartBubleIndx0.length; i++) {    
          if (this.chartBubleIndx0[i].ner_organization[0] == this.SetOrganisasi[2]) {
            this.valueIndx0Org2.push(this.chartBubleIndx0[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndx0.length; i++) {    
          if (this.chartBubleIndx0[i].ner_organization[1] == this.SetOrganisasi[2]) {
            this.valueIndx0Org2.push(this.chartBubleIndx0[i])
          }         
      } 
        for (let i = 0; i < this.chartBubleIndx0.length; i++) {    
          if (this.chartBubleIndx0[i].ner_organization[0] == this.SetOrganisasi[3]) {
            this.valueIndx0Org3.push(this.chartBubleIndx0[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndx0.length; i++) {    
          if (this.chartBubleIndx0[i].ner_organization[1] == this.SetOrganisasi[3]) {
            this.valueIndx0Org3.push(this.chartBubleIndx0[i])
          }         
      } 
        for (let i = 0; i < this.chartBubleIndx0.length; i++) {    
          if (this.chartBubleIndx0[i].ner_organization[0] == this.SetOrganisasi[4]) {
            this.valueIndx0Org4.push(this.chartBubleIndx0[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndx0.length; i++) {    
          if (this.chartBubleIndx0[i].ner_organization[1] == this.SetOrganisasi[4]) {
            this.valueIndx0Org4.push(this.chartBubleIndx0[i])
          }         
      } 
        for (let i = 0; i < this.chartBubleIndx0.length; i++) {    
          if (this.chartBubleIndx0[i].ner_organization[0] == this.SetOrganisasi[5]) {
            this.valueIndx0Org5.push(this.chartBubleIndx0[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndx0.length; i++) {    
          if (this.chartBubleIndx0[i].ner_organization[1] == this.SetOrganisasi[5]) {
            this.valueIndx0Org5.push(this.chartBubleIndx0[i])
          }         
      } 
        for (let i = 0; i < this.chartBubleIndx0.length; i++) {       
          if (this.chartBubleIndx0[i].sentiment == "Positive") {
             this.valueBubleIndx0Positive.push(this.chartBubleIndx0[i]);
          }         
      }  
        for (let i = 0; i < this.chartBubleIndx0.length; i++) {       
          if (this.chartBubleIndx0[i].sentiment == "Negative") {
             this.valueBubleIndx0Negative.push(this.chartBubleIndx0[i]);
          }         
      }  
         for (let i = 0; i < this.chartBubleIndx0.length; i++) {       
          if (this.chartBubleIndx0[i].sentiment == "Netral") {
             this.valueBubleIndx0Netral.push(this.chartBubleIndx0[i]);
          }         
      }
      for (let i = 0; i < this.chartBubleIndx0.length; i++) {
          if (this.chartBubleIndx0[i].source == 'berita') {
              this.valueBubleIndx0NewsShare.push(this.chartBubleIndx0[i]);
          }
      }
       for (let i = 0; i < this.chartBubleIndx0.length; i++) {       
          if (this.chartBubleIndx0[i].source == 'twitter') {
              this.valueBubleIndx0ShareTwitter.push(this.chartBubleIndx0[i]);
          }
      }
      for (let i = 0; i < this.chartBubleIndx0.length; i++) {       
          if (this.chartBubleIndx0[i].source == 'youtube') {
              this.valueBubleIndx0ShareYoutube.push(this.chartBubleIndx0[i]);
          }
      }
      // end buble index 0
      // buble index 1
      for (let i = 0; i < this.chartBubleIndx1.length; i++) {    
          if (this.chartBubleIndx1[i].ner_organization[0] == this.SetOrganisasi[0]) {
            this.valueIndx1Org0.push(this.chartBubleIndx1[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndx1.length; i++) {    
          if (this.chartBubleIndx1[i].ner_organization[1] == this.SetOrganisasi[0]) {
            this.valueIndx1Org0.push(this.chartBubleIndx1[i])
          }         
      } 
       for (let i = 0; i < this.chartBubleIndx1.length; i++) {    
          if (this.chartBubleIndx1[i].ner_organization[0] == this.SetOrganisasi[1]) {
            this.valueIndx1Org1.push(this.chartBubleIndx1[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndx1.length; i++) {    
          if (this.chartBubleIndx1[i].ner_organization[1] == this.SetOrganisasi[1]) {
            this.valueIndx1Org1.push(this.chartBubleIndx1[i])
          }         
      } 
        for (let i = 0; i < this.chartBubleIndx1.length; i++) {    
          if (this.chartBubleIndx1[i].ner_organization[0] == this.SetOrganisasi[2]) {
            this.valueIndx1Org2.push(this.chartBubleIndx1[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndx1.length; i++) {    
          if (this.chartBubleIndx1[i].ner_organization[1] == this.SetOrganisasi[2]) {
            this.valueIndx1Org2.push(this.chartBubleIndx1[i])
          }         
      } 
        for (let i = 0; i < this.chartBubleIndx1.length; i++) {    
          if (this.chartBubleIndx1[i].ner_organization[0] == this.SetOrganisasi[3]) {
            this.valueIndx1Org3.push(this.chartBubleIndx1[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndx1.length; i++) {    
          if (this.chartBubleIndx1[i].ner_organization[1] == this.SetOrganisasi[3]) {
            this.valueIndx1Org3.push(this.chartBubleIndx1[i])
          }         
      } 
        for (let i = 0; i < this.chartBubleIndx1.length; i++) {    
          if (this.chartBubleIndx1[i].ner_organization[0] == this.SetOrganisasi[4]) {
            this.valueIndx1Org4.push(this.chartBubleIndx1[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndx1.length; i++) {    
          if (this.chartBubleIndx1[i].ner_organization[1] == this.SetOrganisasi[4]) {
            this.valueIndx1Org4.push(this.chartBubleIndx1[i])
          }         
      } 
        for (let i = 0; i < this.chartBubleIndx1.length; i++) {    
          if (this.chartBubleIndx1[i].ner_organization[0] == this.SetOrganisasi[5]) {
            this.valueIndx1Org5.push(this.chartBubleIndx1[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndx1.length; i++) {    
          if (this.chartBubleIndx1[i].ner_organization[1] == this.SetOrganisasi[5]) {
            this.valueIndx1Org5.push(this.chartBubleIndx1[i])
          }         
      } 
      for (let i = 0; i < this.chartBubleIndx1.length; i++) {       
          if (this.chartBubleIndx1[i].sentiment == "Positive") {
             this.valueBubleIndx1Positive.push(this.chartBubleIndx1[i]);
          }         
      }  
      for (let i = 0; i < this.chartBubleIndx1.length; i++) {       
          if (this.chartBubleIndx1[i].sentiment == "Negative") {
             this.valueBubleIndx1Negative.push(this.chartBubleIndx1[i]);
          }         
      }  
      for (let i = 0; i < this.chartBubleIndx1.length; i++) {       
          if (this.chartBubleIndx1[i].sentiment == "Netral") {
             this.valueBubleIndx1Netral.push(this.chartBubleIndx1[i]);
          }         
      }
      for (let i = 0; i < this.chartBubleIndx1.length; i++) {       
          if (this.chartBubleIndx1[i].source == 'berita') {
              this.valueBubleIndx1NewsShare.push(this.chartBubleIndx1[i]);
          }
      }
       for (let i = 0; i < this.chartBubleIndx1.length; i++) {       
          if (this.chartBubleIndx1[i].source == 'twitter') {
              this.valueBubleIndx1ShareTwitter.push(this.chartBubleIndx1[i]);
          }
      }
      for (let i = 0; i < this.chartBubleIndx1.length; i++) {       
          if (this.chartBubleIndx1[i].source == 'youtube') {
              this.valueBubleIndx1ShareYoutube.push(this.chartBubleIndx1[i]);
          }
      }
      // end buble index 1
      // buble index 2
       for (let i = 0; i < this.chartBubleIndx2.length; i++) {    
          if (this.chartBubleIndx2[i].ner_organization[0] == this.SetOrganisasi[0]) {
            this.valueIndx2Org0.push(this.chartBubleIndx2[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndx2.length; i++) {    
          if (this.chartBubleIndx2[i].ner_organization[1] == this.SetOrganisasi[0]) {
            this.valueIndx2Org0.push(this.chartBubleIndx2[i])
          }         
      } 
       for (let i = 0; i < this.chartBubleIndx2.length; i++) {    
          if (this.chartBubleIndx2[i].ner_organization[0] == this.SetOrganisasi[1]) {
            this.valueIndx2Org1.push(this.chartBubleIndx2[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndx2.length; i++) {    
          if (this.chartBubleIndx2[i].ner_organization[1] == this.SetOrganisasi[1]) {
            this.valueIndx2Org1.push(this.chartBubleIndx2[i])
          }         
      } 
        for (let i = 0; i < this.chartBubleIndx2.length; i++) {    
          if (this.chartBubleIndx2[i].ner_organization[0] == this.SetOrganisasi[2]) {
            this.valueIndx2Org2.push(this.chartBubleIndx2[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndx2.length; i++) {    
          if (this.chartBubleIndx2[i].ner_organization[1] == this.SetOrganisasi[2]) {
            this.valueIndx2Org2.push(this.chartBubleIndx2[i])
          }         
      } 
        for (let i = 0; i < this.chartBubleIndx2.length; i++) {    
          if (this.chartBubleIndx2[i].ner_organization[0] == this.SetOrganisasi[3]) {
            this.valueIndx2Org3.push(this.chartBubleIndx2[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndx2.length; i++) {    
          if (this.chartBubleIndx2[i].ner_organization[1] == this.SetOrganisasi[3]) {
            this.valueIndx2Org3.push(this.chartBubleIndx2[i])
          }         
      }  
        for (let i = 0; i < this.chartBubleIndx2.length; i++) {    
          if (this.chartBubleIndx2[i].ner_organization[0] == this.SetOrganisasi[4]) {
            this.valueIndx2Org4.push(this.chartBubleIndx2[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndx2.length; i++) {    
          if (this.chartBubleIndx2[i].ner_organization[1] == this.SetOrganisasi[4]) {
            this.valueIndx2Org4.push(this.chartBubleIndx2[i])
          }         
      }  
        for (let i = 0; i < this.chartBubleIndx2.length; i++) {    
          if (this.chartBubleIndx2[i].ner_organization[0] == this.SetOrganisasi[5]) {
            this.valueIndx2Org5.push(this.chartBubleIndx2[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndx2.length; i++) {    
          if (this.chartBubleIndx2[i].ner_organization[1] == this.SetOrganisasi[5]) {
            this.valueIndx2Org5.push(this.chartBubleIndx2[i])
          }         
      }  
      for (let i = 0; i < this.chartBubleIndx2.length; i++) {       
          if (this.chartBubleIndx2[i].sentiment == "Positive") {
             this.valueBubleIndx2Positive.push(this.chartBubleIndx2[i]);
          }         
      }  
      for (let i = 0; i < this.chartBubleIndx2.length; i++) {       
          if (this.chartBubleIndx2[i].sentiment == "Negative") {
             this.valueBubleIndx2Negative.push(this.chartBubleIndx2[i]);
          }         
      }  
      for (let i = 0; i < this.chartBubleIndx2.length; i++) {       
          if (this.chartBubleIndx2[i].sentiment == "Netral") {
             this.valueBubleIndx2Netral.push(this.chartBubleIndx2[i]);
          }         
      }
      for (let i = 0; i < this.chartBubleIndx2.length; i++) {       
          if (this.chartBubleIndx2[i].source == 'berita') {
              this.valueBubleIndx2NewsShare.push(this.chartBubleIndx2[i]);
          }
      }
       for (let i = 0; i < this.chartBubleIndx2.length; i++) {       
          if (this.chartBubleIndx2[i].source == 'twitter') {
              this.valueBubleIndx2ShareTwitter.push(this.chartBubleIndx2[i]);
          }
      }
      for (let i = 0; i < this.chartBubleIndx2.length; i++) {       
          if (this.chartBubleIndx2[i].source == 'youtube') {
              this.valueBubleIndx2ShareYoutube.push(this.chartBubleIndx2[i]);
          }
      }
      // end buble index 2
      // buble index 3
      for (let i = 0; i < this.chartBubleIndx3.length; i++) {  
        
        if (this.chartBubleIndx3[i].ner_organization != null) {  //tambahan karna data ada yang null      
          if (this.chartBubleIndx3[i].ner_organization[0] == this.SetOrganisasi[0]) {
            this.valueIndx3Org0.push(this.chartBubleIndx3[i])
          }         
        }
      }          
      for (let i = 0; i < this.chartBubleIndx3.length; i++) {  
        if (this.chartBubleIndx3[i].ner_organization != null) {  //tambahan karna data ada yang null     
          if (this.chartBubleIndx3[i].ner_organization[1] == this.SetOrganisasi[0]) {
            this.valueIndx3Org0.push(this.chartBubleIndx3[i])
          }         
        }
      }         
      for (let i = 0; i < this.chartBubleIndx3.length; i++) {  
        if (this.chartBubleIndx3[i].ner_organization != null) {  //tambahan karna data ada yang null     
          if (this.chartBubleIndx3[i].ner_organization[0] == this.SetOrganisasi[1]) {
            this.valueIndx3Org1.push(this.chartBubleIndx3[i])
          }         
        }
      }          
      for (let i = 0; i < this.chartBubleIndx3.length; i++) {   
        if (this.chartBubleIndx3[i].ner_organization != null) {  //tambahan karna data ada yang null    
          if (this.chartBubleIndx3[i].ner_organization[1] == this.SetOrganisasi[1]) {
            this.valueIndx3Org1.push(this.chartBubleIndx3[i])
          }    
        }     
      } 
      for (let i = 0; i < this.chartBubleIndx3.length; i++) { 
        if (this.chartBubleIndx3[i].ner_organization != null) {  //tambahan karna data ada yang null      
          if (this.chartBubleIndx3[i].ner_organization[0] == this.SetOrganisasi[2]) {
            this.valueIndx3Org2.push(this.chartBubleIndx3[i])
          }      
        }   
      }          
      for (let i = 0; i < this.chartBubleIndx3.length; i++) { 
        if (this.chartBubleIndx3[i].ner_organization != null) {  //tambahan karna data ada yang null      
          if (this.chartBubleIndx3[i].ner_organization[1] == this.SetOrganisasi[2]) {
            this.valueIndx3Org2.push(this.chartBubleIndx3[i])
          } 
        }        
      }     
      for (let i = 0; i < this.chartBubleIndx3.length; i++) {    
        if (this.chartBubleIndx3[i].ner_organization != null) {  //tambahan karna data ada yang null   
          if (this.chartBubleIndx3[i].ner_organization[0] == this.SetOrganisasi[3]) {
            this.valueIndx3Org3.push(this.chartBubleIndx3[i])
          }       
        }  
      }          
      for (let i = 0; i < this.chartBubleIndx3.length; i++) {  
        if (this.chartBubleIndx3[i].ner_organization != null) {  //tambahan karna data ada yang null     
          if (this.chartBubleIndx3[i].ner_organization[1] == this.SetOrganisasi[3]) {
            this.valueIndx3Org3.push(this.chartBubleIndx3[i])
          }         
        }
      }     
      for (let i = 0; i < this.chartBubleIndx3.length; i++) {  
        if (this.chartBubleIndx3[i].ner_organization != null) {  //tambahan karna data ada yang null     
          if (this.chartBubleIndx3[i].ner_organization[0] == this.SetOrganisasi[4]) {
            this.valueIndx3Org4.push(this.chartBubleIndx3[i])
          }         
        }
      }          
      for (let i = 0; i < this.chartBubleIndx3.length; i++) {  
        if (this.chartBubleIndx3[i].ner_organization != null) {  //tambahan karna data ada yang null     
          if (this.chartBubleIndx3[i].ner_organization[1] == this.SetOrganisasi[4]) {
            this.valueIndx3Org4.push(this.chartBubleIndx3[i])
          }         
        }
      }     
      for (let i = 0; i < this.chartBubleIndx3.length; i++) {  
        if (this.chartBubleIndx3[i].ner_organization != null) {  //tambahan karna data ada yang null     
          if (this.chartBubleIndx3[i].ner_organization[0] == this.SetOrganisasi[5]) {
            this.valueIndx3Org5.push(this.chartBubleIndx3[i])
          }       
        }  
      }          
      for (let i = 0; i < this.chartBubleIndx3.length; i++) {    
        if (this.chartBubleIndx3[i].ner_organization != null) {  //tambahan karna data ada yang null   
          if (this.chartBubleIndx3[i].ner_organization[1] == this.SetOrganisasi[5]) {
            this.valueIndx3Org5.push(this.chartBubleIndx3[i])
          }         
        }
      }     
      for (let i = 0; i < this.chartBubleIndx3.length; i++) {       
          if (this.chartBubleIndx3[i].sentiment == "Positive") {
             this.valueBubleIndx3Positive.push(this.chartBubleIndx3[i]);
          }         
      }  
      for (let i = 0; i < this.chartBubleIndx3.length; i++) {       
          if (this.chartBubleIndx3[i].sentiment == "Negative") {
             this.valueBubleIndx3Negative.push(this.chartBubleIndx3[i]);
          }         
      }  
      for (let i = 0; i < this.chartBubleIndx3.length; i++) {       
          if (this.chartBubleIndx3[i].sentiment == "Netral") {
             this.valueBubleIndx3Netral.push(this.chartBubleIndx3[i]);
          }         
      }
      for (let i = 0; i < this.chartBubleIndx3.length; i++) {       
          if (this.chartBubleIndx3[i].source == 'berita') {
              this.valueBubleIndx3NewsShare.push(this.chartBubleIndx3[i]);
          }
      }
       for (let i = 0; i < this.chartBubleIndx3.length; i++) {       
          if (this.chartBubleIndx3[i].source == 'twitter') {
              this.valueBubleIndx3ShareTwitter.push(this.chartBubleIndx3[i]);
          }
      }
      for (let i = 0; i < this.chartBubleIndx3.length; i++) {       
          if (this.chartBubleIndx3[i].source == 'youtube') {
              this.valueBubleIndx3ShareYoutube.push(this.chartBubleIndx3[i]);
          }
      }
      // end buble index 3





// =================================================
// =================================================
// =================================================
// ================================================= xxxxxxxxxxxxxxxxxxxxxxxx index buble error
// =================================================
// =================================================
// =================================================
      // buble index 4
      for (let i = 0; i < this.chartBubleIndx4.length; i++) {    
        
        if (this.chartBubleIndx4[i].ner_organization != null) {  //tambahan karna data ada yang null  
          if (this.chartBubleIndx4[i].ner_organization[0] == this.SetOrganisasi[0]) {
            this.valueIndx4Org0.push(this.chartBubleIndx4[i])
          }        
        } 
      }          
      for (let i = 0; i < this.chartBubleIndx4.length; i++) {    
          if (this.chartBubleIndx4[i].ner_organization[1] == this.SetOrganisasi[0]) {
            this.valueIndx4Org0.push(this.chartBubleIndx4[i])
          }         
      }         
        for (let i = 0; i < this.chartBubleIndx4.length; i++) {    
          if (this.chartBubleIndx4[i].ner_organization[0] == this.SetOrganisasi[1]) {
            this.valueIndx4Org1.push(this.chartBubleIndx4[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndx4.length; i++) {    
          if (this.chartBubleIndx4[i].ner_organization[1] == this.SetOrganisasi[1]) {
            this.valueIndx4Org1.push(this.chartBubleIndx4[i])
          }         
      } 
      for (let i = 0; i < this.chartBubleIndx4.length; i++) {    
          if (this.chartBubleIndx4[i].ner_organization[0] == this.SetOrganisasi[2]) {
            this.valueIndx4Org2.push(this.chartBubleIndx4[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndx4.length; i++) {    
          if (this.chartBubleIndx4[i].ner_organization[1] == this.SetOrganisasi[2]) {
            this.valueIndx4Org2.push(this.chartBubleIndx4[i])
          }         
      }     
      for (let i = 0; i < this.chartBubleIndx4.length; i++) {    
          if (this.chartBubleIndx4[i].ner_organization[0] == this.SetOrganisasi[3]) {
            this.valueIndx4Org3.push(this.chartBubleIndx4[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndx4.length; i++) {    
          if (this.chartBubleIndx4[i].ner_organization[1] == this.SetOrganisasi[3]) {
            this.valueIndx4Org3.push(this.chartBubleIndx4[i])
          }         
      }     
      for (let i = 0; i < this.chartBubleIndx4.length; i++) {    
          if (this.chartBubleIndx4[i].ner_organization[0] == this.SetOrganisasi[4]) {
            this.valueIndx4Org4.push(this.chartBubleIndx4[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndx4.length; i++) {    
          if (this.chartBubleIndx4[i].ner_organization[1] == this.SetOrganisasi[4]) {
            this.valueIndx4Org4.push(this.chartBubleIndx4[i])
          }         
      }     
      for (let i = 0; i < this.chartBubleIndx4.length; i++) {    
          if (this.chartBubleIndx4[i].ner_organization[0] == this.SetOrganisasi[5]) {
            this.valueIndx4Org5.push(this.chartBubleIndx4[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndx4.length; i++) {    
          if (this.chartBubleIndx4[i].ner_organization[1] == this.SetOrganisasi[5]) {
            this.valueIndx4Org5.push(this.chartBubleIndx4[i])
          }         
      }     
      for (let i = 0; i < this.chartBubleIndx4.length; i++) {       
          if (this.chartBubleIndx4[i].sentiment == "Positive") {
             this.valueBubleIndx4Positive.push(this.chartBubleIndx4[i]);
          }         
      }  
      for (let i = 0; i < this.chartBubleIndx4.length; i++) {       
          if (this.chartBubleIndx4[i].sentiment == "Negative") {
             this.valueBubleIndx4Negative.push(this.chartBubleIndx4[i]);
          }         
      }  
      for (let i = 0; i < this.chartBubleIndx4.length; i++) {       
          if (this.chartBubleIndx4[i].sentiment == "Netral") {
             this.valueBubleIndx4Netral.push(this.chartBubleIndx4[i]);
          }         
      }
      for (let i = 0; i < this.chartBubleIndx4.length; i++) {       
          if (this.chartBubleIndx4[i].source == 'berita') {
              this.valueBubleIndx4NewsShare.push(this.chartBubleIndx4[i]);
          }
      }
       for (let i = 0; i < this.chartBubleIndx4.length; i++) {       
          if (this.chartBubleIndx4[i].source == 'twitter') {
              this.valueBubleIndx4ShareTwitter.push(this.chartBubleIndx4[i]);
          }
      }
      for (let i = 0; i < this.chartBubleIndx4.length; i++) {       
          if (this.chartBubleIndx4[i].source == 'youtube') {
              this.valueBubleIndx4ShareYoutube.push(this.chartBubleIndx4[i]);
          }
      }
      // end buble index 4
      // buble index 5
      for (let i = 0; i < this.chartBubleIndx5.length; i++) {    
          if (this.chartBubleIndx5[i].ner_organization[0] == this.SetOrganisasi[0]) {
            this.valueIndx5Org0.push(this.chartBubleIndx5[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndx5.length; i++) {    
          if (this.chartBubleIndx5[i].ner_organization[1] == this.SetOrganisasi[0]) {
            this.valueIndx5Org0.push(this.chartBubleIndx5[i])
          }         
      }         
        for (let i = 0; i < this.chartBubleIndx5.length; i++) {    
          if (this.chartBubleIndx5[i].ner_organization[0] == this.SetOrganisasi[1]) {
            this.valueIndx5Org1.push(this.chartBubleIndx5[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndx5.length; i++) {    
          if (this.chartBubleIndx5[i].ner_organization[1] == this.SetOrganisasi[1]) {
            this.valueIndx5Org1.push(this.chartBubleIndx5[i])
          }         
      } 
      for (let i = 0; i < this.chartBubleIndx5.length; i++) {    
          if (this.chartBubleIndx5[i].ner_organization[0] == this.SetOrganisasi[2]) {
            this.valueIndx5Org2.push(this.chartBubleIndx5[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndx5.length; i++) {    
          if (this.chartBubleIndx5[i].ner_organization[1] == this.SetOrganisasi[2]) {
            this.valueIndx5Org2.push(this.chartBubleIndx5[i])
          }         
      }     
      for (let i = 0; i < this.chartBubleIndx5.length; i++) {    
          if (this.chartBubleIndx5[i].ner_organization[0] == this.SetOrganisasi[3]) {
            this.valueIndx5Org3.push(this.chartBubleIndx5[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndx5.length; i++) {    
          if (this.chartBubleIndx5[i].ner_organization[1] == this.SetOrganisasi[3]) {
            this.valueIndx5Org3.push(this.chartBubleIndx5[i])
          }         
      }     
      for (let i = 0; i < this.chartBubleIndx5.length; i++) {    
          if (this.chartBubleIndx5[i].ner_organization[0] == this.SetOrganisasi[4]) {
            this.valueIndx5Org4.push(this.chartBubleIndx5[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndx5.length; i++) {    
          if (this.chartBubleIndx5[i].ner_organization[1] == this.SetOrganisasi[4]) {
            this.valueIndx5Org4.push(this.chartBubleIndx5[i])
          }         
      }     
      for (let i = 0; i < this.chartBubleIndx5.length; i++) {    
          if (this.chartBubleIndx5[i].ner_organization[0] == this.SetOrganisasi[5]) {
            this.valueIndx5Org5.push(this.chartBubleIndx5[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndx5.length; i++) {    
          if (this.chartBubleIndx5[i].ner_organization[1] == this.SetOrganisasi[5]) {
            this.valueIndx5Org5.push(this.chartBubleIndx5[i])
          }         
      }      
      
      
      for (let i = 0; i < this.chartBubleIndx5.length; i++) {       
          if (this.chartBubleIndx5[i].sentiment == "Positive") {
             this.valueBubleIndx5Positive.push(this.chartBubleIndx5[i]);
          }         
      }  
      
      for (let i = 0; i < this.chartBubleIndx5.length; i++) {       
          if (this.chartBubleIndx5[i].sentiment == "Negative") {
             this.valueBubleIndx5Negative.push(this.chartBubleIndx5[i]);
          }         
      }  
      for (let i = 0; i < this.chartBubleIndx5.length; i++) {       
          if (this.chartBubleIndx5[i].sentiment == "Netral") {
             this.valueBubleIndx5Netral.push(this.chartBubleIndx5[i]);
          }         
      }
      for (let i = 0; i < this.chartBubleIndx5.length; i++) {       
          if (this.chartBubleIndx5[i].source == 'berita') {
              this.valueBubleIndx5NewsShare.push(this.chartBubleIndx5[i]);
          }
      }
       for (let i = 0; i < this.chartBubleIndx5.length; i++) {       
          if (this.chartBubleIndx5[i].source == 'twitter') {
              this.valueBubleIndx5ShareTwitter.push(this.chartBubleIndx5[i]);
          }
      }
      for (let i = 0; i < this.chartBubleIndx5.length; i++) {       
          if (this.chartBubleIndx5[i].source == 'youtube') {
              this.valueBubleIndx5ShareYoutube.push(this.chartBubleIndx5[i]);
          }
      }
// // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
//        setTimeout(() => {
//          this.dialog = false;
//         }, 1000);                        
//     } catch (e) {
//       console.log('error')
//       console.log(e)
//       }
//  },
//     //sentimentanalysis
//     async testtt(){
      
//       // this.dialog = true;
//       try{
//         // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
      // end buble index 5
      // end klik top person
      // klik buble organisasi
        // ======================================================= char ======================================================= 
        // ======================================================= char ======================================================= 
        // ======================================================= char ======================================================= 
        // ======================================================= char ======================================================= 
      // buble 0 org
       for (let i = 0; i < this.chartBubleIndxOrg0.length; i++) {    
          if (this.chartBubleIndxOrg0[i].ner_person[0] == this.SetPerson[0]) {
            this.valueOrg0Indx0.push(this.chartBubleIndxOrg0[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndxOrg0.length; i++) {    
          if (this.chartBubleIndxOrg0[i].ner_person[1] == this.SetPerson[0]) {
            this.valueOrg0Indx0.push(this.chartBubleIndxOrg0[i])
          }         
      } 
       for (let i = 0; i < this.chartBubleIndxOrg0.length; i++) {    
          if (this.chartBubleIndxOrg0[i].ner_person[0] == this.SetPerson[1]) {
            this.valueOrg0Indx1.push(this.chartBubleIndxOrg0[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndxOrg0.length; i++) {    
          if (this.chartBubleIndxOrg0[i].ner_person[1] == this.SetPerson[1]) {
            this.valueOrg0Indx1.push(this.chartBubleIndxOrg0[i])
          }         
      } 
        for (let i = 0; i < this.chartBubleIndxOrg0.length; i++) {    
          if (this.chartBubleIndxOrg0[i].ner_person[0] == this.SetPerson[2]) {
            this.valueOrg0Indx2.push(this.chartBubleIndxOrg0[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndxOrg0.length; i++) {    
          if (this.chartBubleIndxOrg0[i].ner_person[1] == this.SetPerson[2]) {
            this.valueOrg0Indx2.push(this.chartBubleIndxOrg0[i])
          }         
      } 
        for (let i = 0; i < this.chartBubleIndxOrg0.length; i++) {    
          if (this.chartBubleIndxOrg0[i].ner_person[0] == this.SetPerson[3]) {
            this.valueOrg0Indx3.push(this.chartBubleIndxOrg0[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndxOrg0.length; i++) {    
          if (this.chartBubleIndxOrg0[i].ner_person[1] == this.SetPerson[3]) {
            this.valueOrg0Indx3.push(this.chartBubleIndxOrg0[i])
          }         
      } 
        for (let i = 0; i < this.chartBubleIndxOrg0.length; i++) {    
          if (this.chartBubleIndxOrg0[i].ner_person[0] == this.SetPerson[4]) {
            this.valueOrg0Indx4.push(this.chartBubleIndxOrg0[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndxOrg0.length; i++) {    
          if (this.chartBubleIndxOrg0[i].ner_person[1] == this.SetPerson[4]) {
            this.valueOrg0Indx4.push(this.chartBubleIndxOrg0[i])
          }         
      } 
        for (let i = 0; i < this.chartBubleIndxOrg0.length; i++) {    
          if (this.chartBubleIndxOrg0[i].ner_person[0] == this.SetPerson[5]) {
            this.valueOrg0Indx5.push(this.chartBubleIndxOrg0[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndxOrg0.length; i++) {    
          if (this.chartBubleIndxOrg0[i].ner_person[1] == this.SetPerson[5]) {
            this.valueOrg0Indx5.push(this.chartBubleIndxOrg0[i])
          }         
      } 
       for (let i = 0; i < this.chartBubleIndxOrg0.length; i++) {       
          if (this.chartBubleIndxOrg0[i].sentiment == "Positive") {
             this.valueBubleIndx0OrgPositive.push(this.chartBubleIndxOrg0[i]);
          }         
      }  
      for (let i = 0; i < this.chartBubleIndxOrg0.length; i++) {       
          if (this.chartBubleIndxOrg0[i].sentiment == "Negative") {
             this.valueBubleIndx0OrgNegative.push(this.chartBubleIndxOrg0[i]);
          }         
      }  
      for (let i = 0; i < this.chartBubleIndxOrg0.length; i++) {       
          if (this.chartBubleIndxOrg0[i].sentiment == "Netral") {
             this.valueBubleIndx0OrgNetral.push(this.chartBubleIndxOrg0[i]);
          }         
      }
      for (let i = 0; i < this.chartBubleIndxOrg0.length; i++) {       
          if (this.chartBubleIndxOrg0[i].source == 'berita') {
              this.valueBubleIndx0OrgNewsShare.push(this.chartBubleIndxOrg0[i]);
          }
      }
       for (let i = 0; i < this.chartBubleIndxOrg0.length; i++) {       
          if (this.chartBubleIndxOrg0[i].source == 'twitter') {
              this.valueBubleIndx0OrgShareTwitter.push(this.chartBubleIndxOrg0[i]);
          }
      }
      for (let i = 0; i < this.chartBubleIndxOrg0.length; i++) {       
          if (this.chartBubleIndxOrg0[i].source == 'youtube') {
              this.valueBubleIndx0OrgShareYoutube.push(this.chartBubleIndxOrg0[i]);
          }
      }
      // end buble 0 org
      // buble 1 org
      for (let i = 0; i < this.chartBubleIndxOrg1.length; i++) {    
          if (this.chartBubleIndxOrg1[i].ner_person[0] == this.SetPerson[0]) {
            this.valueOrg1Indx0.push(this.chartBubleIndxOrg1[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndxOrg1.length; i++) {    
          if (this.chartBubleIndxOrg1[i].ner_person[1] == this.SetPerson[0]) {
            this.valueOrg1Indx0.push(this.chartBubleIndxOrg1[i])
          }         
      } 
       for (let i = 0; i < this.chartBubleIndxOrg1.length; i++) {    
          if (this.chartBubleIndxOrg1[i].ner_person[0] == this.SetPerson[1]) {
            this.valueOrg1Indx1.push(this.chartBubleIndxOrg1[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndxOrg1.length; i++) {    
          if (this.chartBubleIndxOrg1[i].ner_person[1] == this.SetPerson[1]) {
            this.valueOrg1Indx1.push(this.chartBubleIndxOrg1[i])
          }         
      } 
        for (let i = 0; i < this.chartBubleIndxOrg1.length; i++) {    
          if (this.chartBubleIndxOrg1[i].ner_person[0] == this.SetPerson[2]) {
            this.valueOrg1Indx2.push(this.chartBubleIndxOrg1[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndxOrg1.length; i++) {    
          if (this.chartBubleIndxOrg1[i].ner_person[1] == this.SetPerson[2]) {
            this.valueOrg1Indx2.push(this.chartBubleIndxOrg1[i])
          }         
      } 
        for (let i = 0; i < this.chartBubleIndxOrg1.length; i++) {    
          if (this.chartBubleIndxOrg1[i].ner_person[0] == this.SetPerson[3]) {
            this.valueOrg1Indx3.push(this.chartBubleIndxOrg1[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndxOrg1.length; i++) {    
          if (this.chartBubleIndxOrg1[i].ner_person[1] == this.SetPerson[3]) {
            this.valueOrg1Indx3.push(this.chartBubleIndxOrg1[i])
          }         
      } 
        for (let i = 0; i < this.chartBubleIndxOrg1.length; i++) {    
          if (this.chartBubleIndxOrg1[i].ner_person[0] == this.SetPerson[4]) {
            this.valueOrg1Indx4.push(this.chartBubleIndxOrg1[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndxOrg1.length; i++) {    
          if (this.chartBubleIndxOrg1[i].ner_person[1] == this.SetPerson[4]) {
            this.valueOrg1Indx4.push(this.chartBubleIndxOrg1[i])
          }         
      } 
        for (let i = 0; i < this.chartBubleIndxOrg1.length; i++) {    
          if (this.chartBubleIndxOrg1[i].ner_person[0] == this.SetPerson[5]) {
            this.valueOrg1Indx5.push(this.chartBubleIndxOrg1[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndxOrg1.length; i++) {    
          if (this.chartBubleIndxOrg1[i].ner_person[1] == this.SetPerson[5]) {
            this.valueOrg1Indx5.push(this.chartBubleIndxOrg1[i])
          }         
      } 
      // end buble 1 org
       for (let i = 0; i < this.chartBubleIndxOrg1.length; i++) {       
          if (this.chartBubleIndxOrg1[i].sentiment == "Positive") {
             this.valueBubleIndx1OrgPositive.push(this.chartBubleIndxOrg1[i]);
          }         
      }  
      for (let i = 0; i < this.chartBubleIndxOrg1.length; i++) {       
          if (this.chartBubleIndxOrg1[i].sentiment == "Negative") {
             this.valueBubleIndx1OrgNegative.push(this.chartBubleIndxOrg1[i]);
          }         
      }  
      for (let i = 0; i < this.chartBubleIndxOrg1.length; i++) {       
          if (this.chartBubleIndxOrg1[i].sentiment == "Netral") {
             this.valueBubleIndx1OrgNetral.push(this.chartBubleIndxOrg1[i]);
          }         
      }
      for (let i = 0; i < this.chartBubleIndxOrg1.length; i++) {       
          if (this.chartBubleIndxOrg1[i].source == 'berita') {
              this.valueBubleIndx1OrgNewsShare.push(this.chartBubleIndxOrg1[i]);
          }
      }
       for (let i = 0; i < this.chartBubleIndxOrg1.length; i++) {       
          if (this.chartBubleIndxOrg1[i].source == 'twitter') {
              this.valueBubleIndx1OrgShareTwitter.push(this.chartBubleIndxOrg1[i]);
          }
      }
      for (let i = 0; i < this.chartBubleIndxOrg1.length; i++) {       
          if (this.chartBubleIndxOrg1[i].source == 'youtube') {
              this.valueBubleIndx1OrgShareYoutube.push(this.chartBubleIndxOrg1[i]);
          }
      }
      // buble 2 org
       for (let i = 0; i < this.chartBubleIndxOrg2.length; i++) {  
        if (this.chartBubleIndxOrg2[i].ner_person != null) {  //tambahan karna data ada yang null     
          if (this.chartBubleIndxOrg2[i].ner_person[0] == this.SetPerson[0]) {
            this.valueOrg2Indx0.push(this.chartBubleIndxOrg2[i])
          }         
        }
      }          
      for (let i = 0; i < this.chartBubleIndxOrg2.length; i++) {   
        if (this.chartBubleIndxOrg2[i].ner_person != null) {  //tambahan karna data ada yang null   
          if (this.chartBubleIndxOrg2[i].ner_person[1] == this.SetPerson[0]) {
            this.valueOrg2Indx0.push(this.chartBubleIndxOrg2[i])
          }         
        }
      } 
       for (let i = 0; i < this.chartBubleIndxOrg2.length; i++) {  
        if (this.chartBubleIndxOrg2[i].ner_person != null) {  //tambahan karna data ada yang null    
          if (this.chartBubleIndxOrg2[i].ner_person[0] == this.SetPerson[1]) {
            this.valueOrg2Indx1.push(this.chartBubleIndxOrg2[i])
          }        
        } 
      }          
      for (let i = 0; i < this.chartBubleIndxOrg2.length; i++) {    
        if (this.chartBubleIndxOrg2[i].ner_person != null) {  //tambahan karna data ada yang null  
          if (this.chartBubleIndxOrg2[i].ner_person[1] == this.SetPerson[1]) {
            this.valueOrg2Indx1.push(this.chartBubleIndxOrg2[i])
          }         
        }
      } 
      for (let i = 0; i < this.chartBubleIndxOrg2.length; i++) {    
        if (this.chartBubleIndxOrg2[i].ner_person != null) {  //tambahan karna data ada yang null  
          if (this.chartBubleIndxOrg2[i].ner_person[0] == this.SetPerson[2]) {
            this.valueOrg2Indx2.push(this.chartBubleIndxOrg2[i])
          }         
        }
      }          
      for (let i = 0; i < this.chartBubleIndxOrg2.length; i++) {    
        if (this.chartBubleIndxOrg2[i].ner_person != null) {  //tambahan karna data ada yang null  
          if (this.chartBubleIndxOrg2[i].ner_person[1] == this.SetPerson[2]) {
            this.valueOrg2Indx2.push(this.chartBubleIndxOrg2[i])
          }         
        }
      } 
      for (let i = 0; i < this.chartBubleIndxOrg2.length; i++) {    
        if (this.chartBubleIndxOrg2[i].ner_person != null) {  //tambahan karna data ada yang null  
          if (this.chartBubleIndxOrg2[i].ner_person[0] == this.SetPerson[3]) {
            this.valueOrg2Indx3.push(this.chartBubleIndxOrg2[i])
          }      
        }   
      }          
      for (let i = 0; i < this.chartBubleIndxOrg2.length; i++) { 
        if (this.chartBubleIndxOrg2[i].ner_person != null) {  //tambahan karna data ada yang null     
          if (this.chartBubleIndxOrg2[i].ner_person[1] == this.SetPerson[3]) {
            this.valueOrg2Indx3.push(this.chartBubleIndxOrg2[i])
          }      
        }   
      } 
      for (let i = 0; i < this.chartBubleIndxOrg2.length; i++) {    
        if (this.chartBubleIndxOrg2[i].ner_person != null) {  //tambahan karna data ada yang null    
          if (this.chartBubleIndxOrg2[i].ner_person[0] == this.SetPerson[4]) {
            this.valueOrg2Indx4.push(this.chartBubleIndxOrg2[i])
          }    
        }     
      }          
      for (let i = 0; i < this.chartBubleIndxOrg2.length; i++) {    
        if (this.chartBubleIndxOrg2[i].ner_person != null) {  //tambahan karna data ada yang null    
          if (this.chartBubleIndxOrg2[i].ner_person[1] == this.SetPerson[4]) {
            this.valueOrg2Indx4.push(this.chartBubleIndxOrg2[i])
          }         
        }
      } 
      for (let i = 0; i < this.chartBubleIndxOrg2.length; i++) {    
        if (this.chartBubleIndxOrg2[i].ner_person != null) {  //tambahan karna data ada yang null    
          if (this.chartBubleIndxOrg2[i].ner_person[0] == this.SetPerson[5]) {
            this.valueOrg2Indx5.push(this.chartBubleIndxOrg2[i])
          }    
        }     
      }          
      for (let i = 0; i < this.chartBubleIndxOrg2.length; i++) {    
        if (this.chartBubleIndxOrg2[i].ner_person != null) {  //tambahan karna data ada yang null    
          if (this.chartBubleIndxOrg2[i].ner_person[1] == this.SetPerson[5]) {
            this.valueOrg2Indx5.push(this.chartBubleIndxOrg2[i])
          }      
        }   
      } 
       for (let i = 0; i < this.chartBubleIndxOrg2.length; i++) {       
          if (this.chartBubleIndxOrg2[i].sentiment == "Positive") {
             this.valueBubleIndx2OrgPositive.push(this.chartBubleIndxOrg2[i]);
          }         
      }  
      for (let i = 0; i < this.chartBubleIndxOrg2.length; i++) {       
          if (this.chartBubleIndxOrg2[i].sentiment == "Negative") {
             this.valueBubleIndx2OrgNegative.push(this.chartBubleIndxOrg2[i]);
          }         
      }  
      for (let i = 0; i < this.chartBubleIndxOrg2.length; i++) {       
          if (this.chartBubleIndxOrg2[i].sentiment == "Netral") {
             this.valueBubleIndx2OrgNetral.push(this.chartBubleIndxOrg2[i]);
          }         
      }
      for (let i = 0; i < this.chartBubleIndxOrg2.length; i++) {       
          if (this.chartBubleIndxOrg2[i].source == 'berita') {
              this.valueBubleIndx2OrgNewsShare.push(this.chartBubleIndxOrg2[i]);
          }
      }
       for (let i = 0; i < this.chartBubleIndxOrg2.length; i++) {       
          if (this.chartBubleIndxOrg2[i].source == 'twitter') {
              this.valueBubleIndx2OrgShareTwitter.push(this.chartBubleIndxOrg2[i]);
          }
      }
      for (let i = 0; i < this.chartBubleIndxOrg2.length; i++) {       
          if (this.chartBubleIndxOrg2[i].source == 'youtube') {
              this.valueBubleIndx2OrgShareYoutube.push(this.chartBubleIndxOrg2[i]);
          }
      }
      // end buble 2 org
      // buble 3 org
      for (let i = 0; i < this.chartBubleIndxOrg3.length; i++) {    
        if (this.chartBubleIndxOrg3[i].ner_person != null) {  //tambahan karna data ada yang null  
          if (this.chartBubleIndxOrg3[i].ner_person[1] == this.SetPerson[0]) {
            this.valueOrg3Indx0.push(this.chartBubleIndxOrg3[i])
          }         
        }
      } 
      for (let i = 0; i < this.chartBubleIndxOrg3.length; i++) {  
        if (this.chartBubleIndxOrg3[i].ner_person != null) {  //tambahan karna data ada yang null    
          if (this.chartBubleIndxOrg3[i].ner_person[1] == this.SetPerson[0]) {
            this.valueOrg3Indx0.push(this.chartBubleIndxOrg3[i])
          }         
        }
      } 
       for (let i = 0; i < this.chartBubleIndxOrg3.length; i++) {    
        if (this.chartBubleIndxOrg3[i].ner_person != null) {  //tambahan karna data ada yang null 
          if (this.chartBubleIndxOrg3[i].ner_person[0] == this.SetPerson[1]) {
            this.valueOrg3Indx1.push(this.chartBubleIndxOrg3[i])
          }     
        }    
      }          
      for (let i = 0; i < this.chartBubleIndxOrg3.length; i++) {  
        if (this.chartBubleIndxOrg3[i].ner_person != null) {  //tambahan karna data ada yang null   
          if (this.chartBubleIndxOrg3[i].ner_person[1] == this.SetPerson[1]) {
            this.valueOrg3Indx1.push(this.chartBubleIndxOrg3[i])
          }         
        }
      } 
        for (let i = 0; i < this.chartBubleIndxOrg3.length; i++) {
        if (this.chartBubleIndxOrg3[i].ner_person != null) {  //tambahan karna data ada yang null     
          if (this.chartBubleIndxOrg3[i].ner_person[0] == this.SetPerson[2]) {
            this.valueOrg3Indx2.push(this.chartBubleIndxOrg3[i])
          }         
        }
      }          
      for (let i = 0; i < this.chartBubleIndxOrg3.length; i++) {    
        if (this.chartBubleIndxOrg3[i].ner_person != null) {  //tambahan karna data ada yang null 
          if (this.chartBubleIndxOrg3[i].ner_person[1] == this.SetPerson[2]) {
            this.valueOrg3Indx2.push(this.chartBubleIndxOrg3[i])
          }         
        }
      } 
      for (let i = 0; i < this.chartBubleIndxOrg3.length; i++) {    
        if (this.chartBubleIndxOrg3[i].ner_person != null) {  //tambahan karna data ada yang null 
          if (this.chartBubleIndxOrg3[i].ner_person[0] == this.SetPerson[3]) {
            this.valueOrg3Indx3.push(this.chartBubleIndxOrg3[i])
          }       
        }  
      }          
      for (let i = 0; i < this.chartBubleIndxOrg3.length; i++) {   
        if (this.chartBubleIndxOrg3[i].ner_person != null) {  //tambahan karna data ada yang null  
          if (this.chartBubleIndxOrg3[i].ner_person[1] == this.SetPerson[3]) {
            this.valueOrg3Indx3.push(this.chartBubleIndxOrg3[i])
          }         
        }
      } 
        for (let i = 0; i < this.chartBubleIndxOrg3.length; i++) { 
        if (this.chartBubleIndxOrg3[i].ner_person != null) {  //tambahan karna data ada yang null    
          if (this.chartBubleIndxOrg3[i].ner_person[0] == this.SetPerson[4]) {
            this.valueOrg3Indx4.push(this.chartBubleIndxOrg3[i])
          }         
        }
      }          
      for (let i = 0; i < this.chartBubleIndxOrg3.length; i++) {    
        if (this.chartBubleIndxOrg3[i].ner_person != null) {  //tambahan karna data ada yang null 
          if (this.chartBubleIndxOrg3[i].ner_person[1] == this.SetPerson[4]) {
            this.valueOrg3Indx4.push(this.chartBubleIndxOrg3[i])
          }         
        }
      } 
        for (let i = 0; i < this.chartBubleIndxOrg3.length; i++) {    
          if (this.chartBubleIndxOrg3[i].ner_person[0] == this.SetPerson[5]) {
            this.valueOrg3Indx5.push(this.chartBubleIndxOrg3[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndxOrg3.length; i++) {    
          if (this.chartBubleIndxOrg3[i].ner_person[1] == this.SetPerson[5]) {
            this.valueOrg3Indx5.push(this.chartBubleIndxOrg3[i])
          }         
      } 
       for (let i = 0; i < this.chartBubleIndxOrg3.length; i++) {       
          if (this.chartBubleIndxOrg3[i].sentiment == "Positive") {
             this.valueBubleIndx3OrgPositive.push(this.chartBubleIndxOrg3[i]);
          }         
      }  
      for (let i = 0; i < this.chartBubleIndxOrg3.length; i++) {       
          if (this.chartBubleIndxOrg3[i].sentiment == "Negative") {
             this.valueBubleIndx3OrgNegative.push(this.chartBubleIndxOrg3[i]);
          }         
      }  
      for (let i = 0; i < this.chartBubleIndxOrg3.length; i++) {       
          if (this.chartBubleIndxOrg3[i].sentiment == "Netral") {
             this.valueBubleIndx3OrgNetral.push(this.chartBubleIndxOrg3[i]);
          }         
      }
      for (let i = 0; i < this.chartBubleIndxOrg3.length; i++) {       
          if (this.chartBubleIndxOrg3[i].source == 'berita') {
              this.valueBubleIndx3OrgNewsShare.push(this.chartBubleIndxOrg3[i]);
          }
      }
       for (let i = 0; i < this.chartBubleIndxOrg3.length; i++) {       
          if (this.chartBubleIndxOrg3[i].source == 'twitter') {
              this.valueBubleIndx3OrgShareTwitter.push(this.chartBubleIndxOrg3[i]);
          }
      }
      for (let i = 0; i < this.chartBubleIndxOrg3.length; i++) {       
          if (this.chartBubleIndxOrg3[i].source == 'youtube') {
              this.valueBubleIndx3OrgShareYoutube.push(this.chartBubleIndxOrg3[i]);
          }
      }
      // end buble 3 org
      // buble 4 org
      for (let i = 0; i < this.chartBubleIndxOrg4.length; i++) {    
          if (this.chartBubleIndxOrg4[i].ner_person[1] == this.SetPerson[0]) {
            this.valueOrg4Indx0.push(this.chartBubleIndxOrg4[i])
          }         
      } 
        for (let i = 0; i < this.chartBubleIndxOrg4.length; i++) {    
          if (this.chartBubleIndxOrg4[i].ner_person[1] == this.SetPerson[0]) {
            this.valueOrg4Indx0.push(this.chartBubleIndxOrg4[i])
          }         
      } 
       for (let i = 0; i < this.chartBubleIndxOrg4.length; i++) {    
          if (this.chartBubleIndxOrg4[i].ner_person[0] == this.SetPerson[1]) {
            this.valueOrg4Indx1.push(this.chartBubleIndxOrg4[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndxOrg4.length; i++) {    
          if (this.chartBubleIndxOrg4[i].ner_person[1] == this.SetPerson[1]) {
            this.valueOrg4Indx1.push(this.chartBubleIndxOrg4[i])
          }         
      } 
        for (let i = 0; i < this.chartBubleIndxOrg4.length; i++) {    
          if (this.chartBubleIndxOrg4[i].ner_person[0] == this.SetPerson[2]) {
            this.valueOrg4Indx2.push(this.chartBubleIndxOrg4[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndxOrg4.length; i++) {    
          if (this.chartBubleIndxOrg4[i].ner_person[1] == this.SetPerson[2]) {
            this.valueOrg4Indx2.push(this.chartBubleIndxOrg4[i])
          }         
      } 
        for (let i = 0; i < this.chartBubleIndxOrg4.length; i++) {    
          if (this.chartBubleIndxOrg4[i].ner_person[0] == this.SetPerson[3]) {
            this.valueOrg4Indx3.push(this.chartBubleIndxOrg4[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndxOrg4.length; i++) {    
          if (this.chartBubleIndxOrg4[i].ner_person[1] == this.SetPerson[3]) {
            this.valueOrg4Indx3.push(this.chartBubleIndxOrg4[i])
          }         
      } 
        for (let i = 0; i < this.chartBubleIndxOrg4.length; i++) {    
          if (this.chartBubleIndxOrg4[i].ner_person[0] == this.SetPerson[4]) {
            this.valueOrg4Indx4.push(this.chartBubleIndxOrg4[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndxOrg4.length; i++) {    
          if (this.chartBubleIndxOrg4[i].ner_person[1] == this.SetPerson[4]) {
            this.valueOrg4Indx4.push(this.chartBubleIndxOrg4[i])
          }         
      } 
        for (let i = 0; i < this.chartBubleIndxOrg4.length; i++) {    
          if (this.chartBubleIndxOrg4[i].ner_person[0] == this.SetPerson[5]) {
            this.valueOrg4Indx5.push(this.chartBubleIndxOrg4[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndxOrg4.length; i++) {    
          if (this.chartBubleIndxOrg4[i].ner_person[1] == this.SetPerson[5]) {
            this.valueOrg4Indx5.push(this.chartBubleIndxOrg4[i])
          }         
      } 
       for (let i = 0; i < this.chartBubleIndxOrg4.length; i++) {       
          if (this.chartBubleIndxOrg4[i].sentiment == "Positive") {
             this.valueBubleIndx4OrgPositive.push(this.chartBubleIndxOrg4[i]);
          }         
      }  
      for (let i = 0; i < this.chartBubleIndxOrg4.length; i++) {       
          if (this.chartBubleIndxOrg4[i].sentiment == "Negative") {
             this.valueBubleIndx4OrgNegative.push(this.chartBubleIndxOrg4[i]);
          }         
      }  
      for (let i = 0; i < this.chartBubleIndxOrg4.length; i++) {       
          if (this.chartBubleIndxOrg4[i].sentiment == "Netral") {
             this.valueBubleIndx4OrgNetral.push(this.chartBubleIndxOrg4[i]);
          }         
      }
      for (let i = 0; i < this.chartBubleIndxOrg4.length; i++) {       
          if (this.chartBubleIndxOrg4[i].source == 'berita') {
              this.valueBubleIndx4OrgNewsShare.push(this.chartBubleIndxOrg4[i]);
          }
      }
       for (let i = 0; i < this.chartBubleIndxOrg4.length; i++) {       
          if (this.chartBubleIndxOrg4[i].source == 'twitter') {
              this.valueBubleIndx4OrgShareTwitter.push(this.chartBubleIndxOrg4[i]);
          }
      }
      for (let i = 0; i < this.chartBubleIndxOrg4.length; i++) {       
          if (this.chartBubleIndxOrg4[i].source == 'youtube') {
              this.valueBubleIndx4OrgShareYoutube.push(this.chartBubleIndxOrg4[i]);
          }
      }
      // end buble 4 org
      // buble 5 org
      for (let i = 0; i < this.chartBubleIndxOrg5.length; i++) {    
          if (this.chartBubleIndxOrg5[i].ner_person[1] == this.SetPerson[0]) {
            this.valueOrg5Indx0.push(this.chartBubleIndxOrg5[i])
          }         
      } 
        for (let i = 0; i < this.chartBubleIndxOrg5.length; i++) {    
          if (this.chartBubleIndxOrg5[i].ner_person[1] == this.SetPerson[0]) {
            this.valueOrg5Indx0.push(this.chartBubleIndxOrg5[i])
          }         
      } 
       for (let i = 0; i < this.chartBubleIndxOrg5.length; i++) {    
          if (this.chartBubleIndxOrg5[i].ner_person[0] == this.SetPerson[1]) {
            this.valueOrg5Indx1.push(this.chartBubleIndxOrg5[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndxOrg5.length; i++) {    
          if (this.chartBubleIndxOrg5[i].ner_person[1] == this.SetPerson[1]) {
            this.valueOrg5Indx1.push(this.chartBubleIndxOrg5[i])
          }         
      } 
        for (let i = 0; i < this.chartBubleIndxOrg5.length; i++) {    
          if (this.chartBubleIndxOrg5[i].ner_person[0] == this.SetPerson[2]) {
            this.valueOrg5Indx2.push(this.chartBubleIndxOrg5[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndxOrg5.length; i++) {    
          if (this.chartBubleIndxOrg5[i].ner_person[1] == this.SetPerson[2]) {
            this.valueOrg5Indx2.push(this.chartBubleIndxOrg5[i])
          }         
      } 
        for (let i = 0; i < this.chartBubleIndxOrg5.length; i++) {    
          if (this.chartBubleIndxOrg5[i].ner_person[0] == this.SetPerson[3]) {
            this.valueOrg5Indx3.push(this.chartBubleIndxOrg5[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndxOrg5.length; i++) {    
          if (this.chartBubleIndxOrg5[i].ner_person[1] == this.SetPerson[3]) {
            this.valueOrg5Indx3.push(this.chartBubleIndxOrg5[i])
          }         
      } 
        for (let i = 0; i < this.chartBubleIndxOrg5.length; i++) {    
          if (this.chartBubleIndxOrg5[i].ner_person[0] == this.SetPerson[4]) {
            this.valueOrg5Indx4.push(this.chartBubleIndxOrg5[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndxOrg5.length; i++) {    
          if (this.chartBubleIndxOrg5[i].ner_person[1] == this.SetPerson[4]) {
            this.valueOrg5Indx4.push(this.chartBubleIndxOrg5[i])
          }         
      } 
        for (let i = 0; i < this.chartBubleIndxOrg5.length; i++) {    
          if (this.chartBubleIndxOrg5[i].ner_person[0] == this.SetPerson[5]) {
            this.valueOrg5Indx5.push(this.chartBubleIndxOrg5[i])
          }         
      }          
      for (let i = 0; i < this.chartBubleIndxOrg5.length; i++) {    
          if (this.chartBubleIndxOrg5[i].ner_person[1] == this.SetPerson[5]) {
            this.valueOrg5Indx5.push(this.chartBubleIndxOrg5[i])
          }         
      } 
        for (let i = 0; i < this.chartBubleIndxOrg5.length; i++) {       
          if (this.chartBubleIndxOrg5[i].sentiment == "Positive") {
             this.valueBubleIndx5OrgPositive.push(this.chartBubleIndxOrg5[i]);
          }         
      }  
      for (let i = 0; i < this.chartBubleIndxOrg5.length; i++) {       
          if (this.chartBubleIndxOrg5[i].sentiment == "Negative") {
             this.valueBubleIndx5OrgNegative.push(this.chartBubleIndxOrg5[i]);
          }         
      }  
      for (let i = 0; i < this.chartBubleIndxOrg5.length; i++) {       
          if (this.chartBubleIndxOrg5[i].sentiment == "Netral") {
             this.valueBubleIndx5OrgNetral.push(this.chartBubleIndxOrg5[i]);
          }         
      }
      for (let i = 0; i < this.chartBubleIndxOrg5.length; i++) {       
          if (this.chartBubleIndxOrg5[i].source == 'berita') {
              this.valueBubleIndx5OrgNewsShare.push(this.chartBubleIndxOrg5[i]);
          }
      }
       for (let i = 0; i < this.chartBubleIndxOrg5.length; i++) {       
          if (this.chartBubleIndxOrg5[i].source == 'twitter') {
              this.valueBubleIndx5OrgShareTwitter.push(this.chartBubleIndxOrg5[i]);
          }
      }
      for (let i = 0; i < this.chartBubleIndxOrg5.length; i++) {       
          // if (this.chartBubleIndxOrg5[i].domain == 'youtube.com') {
          //     this.valueBubleIndx5OrgShareYoutube.push(this.chartBubleIndxOrg5[i]);
          // }
          
          if (this.chartBubleIndxOrg5[i].source == 'youtube') {
              this.valueBubleIndx5OrgShareYoutube.push(this.chartBubleIndxOrg5[i]);
          }  
          
      }
      if(this.click == ''){
      this.seriess.push(this.kontenBeritaNetral.length, this.kontenBeritaNegative.length, this.kontenBeritaPositive.
      length)             
      } 
      
       setTimeout(() => {
          this.dialog = false;
        }, 1000);                        
    } catch (e) {
      
       setTimeout(() => {
          this.dialog = false;
        }, 1000);   
      console.log('error')
      console.log(e)
      }
      },    
      
      
    // ========================================== =============== ======================================
    // ========================================== end sentiment analisis ======================================
    // ========================================== =============== ======================================






























      // Online News Share
      async loadKontenOnlineNews(data){
      try{
        // const data1 = await axios.get("news")
        
        //   const data =data1.data; 
          
      // const data1 = await axios.get("solr-dashboard?start_date="+this.date2+"&end_date="+this.date1+"&topic="+this.selectedTopic,
      //   {headers:{'auth-token':localStorage.getItem('token_app')}}
      //   )
      //   const data =data1.data;  

      for (let i = 0; i < this.mediaBerita.length; i++) {  
          if (data.data[i].source == 'berita') {

              this.DomainOnlineNews.push(data.data[i]);
          }     
          // if (data.data[i].domain == 'kapanlagi.com') {
          //     this.DomainOnlineNews.push(data.data[i]);
          // }
      }           
      this.valueTotalDomain = this.DomainOnlineNews.length
      const persenDomain = this.DomainOnlineNews.length / this.mediaBerita.length * 10000 /100  
      // alert('Total Online News Share :' +this.DomainOnlineNews.length);    
      this.seriesonline.push(parseInt(persenDomain))
    } catch (e) {
      console.log('error')
      }
      },

      // Online Media Share
    async loadKontenOnlineMedia(data){
      try{
        // const data1 = await axios.get("news")
        //   const data =data1.data;  
        // const data1 = await axios.get("solr-dashboard?start_date="+this.date2+"&end_date="+this.date1+"&topic="+this.selectedTopic,
        //   {headers:{'auth-token':localStorage.getItem('token_app')}}
        //   )
        //   const data =data1.data;     
        
        this.MediaOnlineShare = []
      this.valueTotalBerita = this.mediaBerita.length
      for (let i = 0; i < data.data.length; i++) {       
          if (data.data[i].source != 'berita') {
              this.MediaOnlineShare.push(data.data[i]);
          }
      }    
      this.valueTotalTwet = this.MediatwitterShare.length
      const persenTwiter = this.MediatwitterShare.length / this.MediaOnlineShare.length * 10000 /100     
      this.valueTotalYt = this.MediaYtShare.length
      const persenYt = this.MediaYtShare.length / this.MediaOnlineShare.length * 10000 /100      
      // this.seriesmedia.push(parseInt(persenTwiter.toFixed(2)), parseInt(persenYt.toFixed(2)))
      this.seriesmedia.push(parseInt(persenTwiter.toFixed(2)), parseInt(persenYt.toFixed(2)))
    } catch (e) {
      console.log('error')
      }
      },
      





// =====================================================
// =====================================================
// =====================================================
// =====================================================
// =====================================================
// ===================================================== Click Kategori Brita
// =====================================================
// =====================================================
// =====================================================
// =====================================================
     //sentimentanalysisberita
      async loadSentimentanalysisBerita(){
          this.dialog = true
          setTimeout(() => {
          this.dialog = false;
        }, 1000);     
               this.chart[0].name = this.SetPerson[0]
               this.chart[0].amount = this.valueBubleIndx0Berita.length
               this.chart[1].name = this.SetPerson[1]
               this.chart[1].amount = this.valueBubleIndx1Berita.length
              this.chart[2].name = this.SetPerson[2]
               this.chart[2].amount = this.valueBubleIndx2Berita.length
               this.chart[3].name = this.SetPerson[3]
               this.chart[3].amount = this.valueBubleIndx3Berita.length
               this.chart[4].name = this.SetPerson[4]
               this.chart[4].amount = this.valueBubleIndx4Berita.length
               this.chart[5].name = this.SetPerson[5]
               this.chart[5].amount = this.valueBubleIndx5Berita.length
              this.chartOrganisasi[0].name = this.SetOrganisasi[0]
               this.chartOrganisasi[0].amount = this.valueBubleIndx0OrgBerita.length
               this.chartOrganisasi[1].name = this.SetOrganisasi[1]
               this.chartOrganisasi[1].amount = this.valueBubleIndx1OrgBerita.length
               this.chartOrganisasi[2].name = this.SetOrganisasi[2]
               this.chartOrganisasi[2].amount = this.valueBubleIndx2OrgBerita.length
               this.chartOrganisasi[3].name = this.SetOrganisasi[3]
               this.chartOrganisasi[3].amount = this.valueBubleIndx3OrgBerita.length
               this.chartOrganisasi[4].name = this.SetOrganisasi[4]
               this.chartOrganisasi[4].amount = this.valueBubleIndx4OrgBerita.length       
               this.chartOrganisasi[5].name = this.SetOrganisasi[5]
               this.chartOrganisasi[5].amount = this.valueBubleIndx5OrgBerita.length
      try{   
        this.click = 'berita'
        if(this.click == 'berita'){
        // this.seriess = []
        // this.seriess.push(this.mediaBeritaNetral.length, this.mediaBeritaNegative.length, this.mediaBeritaPositive.length)                
        this.kontenBeritaPositive = []
        this.kontenBeritaNegative = []
        this.kontenBeritaNetral = []
        for (let i = 0; i < this.mediaBerita.length; i++) {       
          if (this.mediaBerita[i].sentiment == 'Positive') {
              this.kontenBeritaPositive.push(this.mediaBerita[i]);
          }
      }      
        for (let i = 0; i < this.mediaBerita.length; i++) {       
          if (this.mediaBerita[i].sentiment == 'Negative') {
              this.kontenBeritaNegative.push(this.mediaBerita[i]);
          }
      }      
        for (let i = 0; i < this.mediaBerita.length; i++) {       
          if (this.mediaBerita[i].sentiment == 'Netral') {
              this.kontenBeritaNetral.push(this.mediaBerita[i]);
          }
      }      
      
      this.seriess = []
      this.seriess.push(this.kontenBeritaNetral.length, this.kontenBeritaNegative.length, this.kontenBeritaPositive.length)    

      const beritaNetralPersen = this.kontenBeritaNetral.length / this.mediaBerita.length * 100 
      this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
      const beritaNegativePersen = this.kontenBeritaNegative.length / this.mediaBerita.length * 100 
      this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
      const beritaPositvePersen = this.kontenBeritaPositive.length / this.mediaBerita.length * 100 
      this.beritaPositifPersen = beritaPositvePersen.toFixed(2)
      this.DomainOnlineNews = []
      this.seriesonline = []
      for (let i = 0; i < this.mediaBerita.length; i++) {       
          // if (this.mediaBerita[i].domain == 'kapanlagi.com') {
          //     this.DomainOnlineNews.push(this.mediaBerita[i]);
          // }
          
          if (this.mediaBerita[i].source == 'berita') {
              this.DomainOnlineNews.push(this.mediaBerita[i]);
          }  
      }           
      this.valueTotalDomain = this.DomainOnlineNews.length
      const persenDomain = this.DomainOnlineNews.length / this.mediaBerita.length * 10000 /100      
      this.seriesonline.push(parseInt(persenDomain)) 
      }
      } catch (e) {
        console.log('error')
        console.log(e)
        }
      },




      //load sentiment twet
      async loadSentimentTweet(){
          this.dialog = true
          setTimeout(() => {
          this.dialog = false;
        }, 1000);            
      try{     
      this.click = 'twitter'
      if(this.click =='twitter'){      
      // this.seriess=[]
      // this.seriess.push(this.mediaTweetNetral.length, this.mediaTweetNegative.length, this.mediaTweetPositive.length)
      this.chart[0].name = this.SetPerson[0]
      this.chart[0].amount = this.valueBubleIndx0Twitter.length
      this.chart[1].name = this.SetPerson[1]
      this.chart[1].amount = this.valueBubleIndx1Twitter.length
      this.chart[2].name = this.SetPerson[2]
      this.chart[2].amount = this.valueBubleIndx2Twitter.length
      this.chart[3].name = this.SetPerson[3]
      this.chart[3].amount = this.valueBubleIndx3Twitter.length
      this.chart[4].name = this.SetPerson[4]
      this.chart[4].amount = this.valueBubleIndx4Twitter.length
      this.chart[5].name = this.SetPerson[5]
      this.chart[5].amount = this.valueBubleIndx5Twitter.length
      this.chartOrganisasi[0].name = this.SetOrganisasi[0]
      this.chartOrganisasi[0].amount = this.valueBubleIndx0OrgTwitter.length
      this.chartOrganisasi[1].name = this.SetOrganisasi[1]
      this.chartOrganisasi[1].amount = this.valueBubleIndx1OrgTwitter.length
      this.chartOrganisasi[2].name = this.SetOrganisasi[2]
      this.chartOrganisasi[2].amount = this.valueBubleIndx2OrgTwitter.length
      this.chartOrganisasi[3].name = this.SetOrganisasi[3]
      this.chartOrganisasi[3].amount = this.valueBubleIndx3OrgTwitter.length
      this.chartOrganisasi[4].name = this.SetOrganisasi[4]
      this.chartOrganisasi[4].amount = this.valueBubleIndx4OrgTwitter.length       
      this.chartOrganisasi[5].name = this.SetOrganisasi[5]
      this.chartOrganisasi[5].amount = this.valueBubleIndx5OrgTwitter.length
      this.kontenBeritaPositive = []
      this.kontenBeritaNegative = []
      this.kontenBeritaNetral = []
      for (let i = 0; i < this.MediatwitterShare.length; i++) {       
          if (this.MediatwitterShare[i].sentiment == 'Positive') {
              this.kontenBeritaPositive.push(this.MediatwitterShare[i]);
          }
      }      
        for (let i = 0; i < this.MediatwitterShare.length; i++) {       
          if (this.MediatwitterShare[i].sentiment == 'Negative') {
              this.kontenBeritaNegative.push(this.MediatwitterShare[i]);
          }
      }      
        for (let i = 0; i < this.MediatwitterShare.length; i++) {       
          if (this.MediatwitterShare[i].sentiment == 'Netral') {
              this.kontenBeritaNetral.push(this.MediatwitterShare[i]);
          }
      }      
      
      this.seriess=[]
      this.seriess.push(this.kontenBeritaNetral.length, this.kontenBeritaNegative.length, this.kontenBeritaPositive.length)
      const beritaNetralPersen = this.kontenBeritaNetral.length / this.MediatwitterShare.length * 100 
      this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
      const beritaNegativePersen = this.kontenBeritaNegative.length / this.MediatwitterShare.length * 100 
      this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
      const beritaPositvePersen = this.kontenBeritaPositive.length / this.MediatwitterShare.length * 100 
      this.beritaPositifPersen = beritaPositvePersen.toFixed(2)
      this.DomainOnlineNews = []
      this.seriesonline = []
      for (let i = 0; i < this.MediatwitterShare.length; i++) {       
          // if (this.MediatwitterShare[i].domain == 'kapanlagi.com') {
          //     this.DomainOnlineNews.push(this.MediatwitterShare[i]);
          // }
          
          if (this.MediatwitterShare[i].source == 'twitter') {
              this.DomainOnlineNews.push(this.MediatwitterShare[i]);
          }   
      }           
      this.valueTotalDomain = this.DomainOnlineNews.length
      const persenDomain = this.DomainOnlineNews.length / this.MediatwitterShare.length * 10000 /100      
      this.seriesonline.push(parseInt(persenDomain))
      }    
    } catch (e) {
      console.log('error')
      }
      },

      //load sentiment yt
      async loadSentimentYt(){
        this.dialog = true
          setTimeout(() => {
          this.dialog = false;
        }, 1000);            
      try{       
      this.click = 'youtube'
      if(this.click =='youtube'){
      // this.seriess=[]
      // this.seriess.push(this.mediaYtNetral.length, this.mediaYtNegative.length, this.mediaYtPositive.length)
      this.chart[0].name = this.SetPerson[0]
      this.chart[0].amount = this.valueBubleIndx0Youtube.length
      this.chart[1].name = this.SetPerson[1]
      this.chart[1].amount = this.valueBubleIndx1Youtube.length
      this.chart[2].name = this.SetPerson[2]
      this.chart[2].amount = this.valueBubleIndx2Youtube.length
      this.chart[3].name = this.SetPerson[3]
      this.chart[3].amount = this.valueBubleIndx3Youtube.length
      this.chart[4].name = this.SetPerson[4]
      this.chart[4].amount = this.valueBubleIndx4Youtube.length
      this.chart[5].name = this.SetPerson[5]
      this.chart[5].amount = this.valueBubleIndx5Youtube.length
      this.chartOrganisasi[0].name = this.SetOrganisasi[0]
      this.chartOrganisasi[0].amount = this.valueBubleIndx0OrgYoutube.length
      this.chartOrganisasi[1].name = this.SetOrganisasi[1]
      this.chartOrganisasi[1].amount = this.valueBubleIndx1OrgYoutube.length
      this.chartOrganisasi[2].name = this.SetOrganisasi[2]
      this.chartOrganisasi[2].amount = this.valueBubleIndx2OrgYoutube.length
      this.chartOrganisasi[3].name = this.SetOrganisasi[3]
      this.chartOrganisasi[3].amount = this.valueBubleIndx3OrgYoutube.length
      this.chartOrganisasi[4].name = this.SetOrganisasi[4]
      this.chartOrganisasi[4].amount = this.valueBubleIndx4OrgYoutube.length       
      this.chartOrganisasi[5].name = this.SetOrganisasi[5]
      this.chartOrganisasi[5].amount = this.valueBubleIndx5OrgYoutube.length
      this.kontenBeritaPositive = []
      this.kontenBeritaNegative = []
      this.kontenBeritaNetral = []
      for (let i = 0; i < this.MediaYtShare.length; i++) {       
          if (this.MediaYtShare[i].sentiment == 'Positive') {
              this.kontenBeritaPositive.push(this.MediaYtShare[i]);
          }
      }      
        for (let i = 0; i < this.MediaYtShare.length; i++) {       
          if (this.MediaYtShare[i].sentiment == 'Negative') {
              this.kontenBeritaNegative.push(this.MediaYtShare[i]);
          }
      }      
        for (let i = 0; i < this.MediaYtShare.length; i++) {       
          if (this.MediaYtShare[i].sentiment == 'Netral') {
              this.kontenBeritaNetral.push(this.MediaYtShare[i]);
          }
      }      
      
      this.seriess=[]
      this.seriess.push(this.kontenBeritaNetral.length, this.kontenBeritaNegative.length, this.kontenBeritaPositive.length)
      const beritaNetralPersen = this.kontenBeritaNetral.length / this.MediaYtShare.length * 100 
      this.beritaNetralPersen = beritaNetralPersen.toFixed(2)
      const beritaNegativePersen = this.kontenBeritaNegative.length / this.MediaYtShare.length * 100 
      this.beritaNegativePersen = beritaNegativePersen.toFixed(2)
      const beritaPositvePersen = this.kontenBeritaPositive.length / this.MediaYtShare.length * 100 
      this.beritaPositifPersen = beritaPositvePersen.toFixed(2)
      this.DomainOnlineNews = []
      this.seriesonline = []
      for (let i = 0; i < this.MediaYtShare.length; i++) {       
          // if (this.MediaYtShare[i].domain == 'kapanlagi.com') {
          //     this.DomainOnlineNews.push(this.MediaYtShare[i]);
          // }
          
          if (this.MediaYtShare[i].source == 'berita') {
              this.DomainOnlineNews.push(this.MediaYtShare[i]);
          }     
      }           
      this.valueTotalDomain = this.DomainOnlineNews.length
      const persenDomain = this.DomainOnlineNews.length / this.MediaYtShare.length * 10000 /100      
      this.seriesonline.push(parseInt(persenDomain))
      }
    } catch (e) {
      console.log('error')
      }
      }
      
// =====================================================
// =====================================================
// =====================================================
// =====================================================
// =====================================================
// ===================================================== end Click Kategori Brita
// =====================================================
// =====================================================
// =====================================================
// =====================================================





   } 
}


</script>

<style> 
/*note css jangan diubah*/
.v-sheet--offset {
  top: -24px;
  position: relative;
}
#app{
  background-color: #f7f6f4;
}
.apexcharts-toolbar {
  z-index: 0;
}
.tooltip .tooltip-inner{
  max-width: 100px !important;
  width: 100px !important;
}
.v-tooltip__content {
  font-size: 9px !important;
  max-width: 100px;
}
.row-pointer{
  cursor: pointer;
}
svg {
  display: block;
  margin: 0 auto;
}
.chart {
  transition: transform 0.7s ease-in-out;
  text-anchor: middle;
}
.chart__circle {
  transition: r .3s ease-in-out;
}
.chart__label {
  font-size: 14px;
  fill: #fff;
  font-weight: bold;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}
</style>
